// i18n namespace `recognition` (de) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Zurück zum Portal',
    collapseMenu: 'Menü einklappen',
    expandMenu: 'Menü ausklappen',
    fundamentals: 'Grundprinzipien',
  },
  moduleTitle: 'Anerkennungsprogramm',
  nav: {
    recognize: 'Anerkennen',
    shine: 'Shine Together',
    profile: 'Mein Profil',
    admin: 'Admin',
    team: 'Team',
    dashboard: 'Übersicht',
    innovation: 'Innovation LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Mehr anzeigen',
    title: 'Weitere Optionen',
    documents: 'Dokumente',
    language: 'Sprache',
    selectLanguage: 'Sprache auswählen',
  },
  common: {
    loading: 'Wird geladen…',
    error: 'Die Informationen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    empty: 'Es gibt noch nichts anzuzeigen.',
    notConfigured: 'Der Anerkennungsdienst ist nicht konfiguriert.',
    forbidden: 'Sie haben keine Berechtigung, diesen Bereich zu sehen.',
    close: 'Schließen',
    remove: 'Entfernen',
    cancel: 'Abbrechen',
    insertEmoji: 'Emoji einfügen',
    actions: 'Aktionen',
  },
  recognize: {
    title: 'Kolleg:in anerkennen',
    subtitle: 'Bedanke dich für ein Verhalten, das unseren Grundprinzipien entspricht.',
    feedTitle: 'Neueste Anerkennungen',
    feedEmpty: 'Es gibt noch keine Anerkennungen. Sei die erste Person, die anerkennt!',
    newCta: 'Neue Anerkennung',
    form: {
      messagePlaceholder: 'Schreibe deine Anerkennungsnachricht…',
      anonymous: 'Anonym senden',
      submit: 'Anerkennung senden',
    },
  },
  wall: {
    title: 'Anerkennungswand',
    count: '{{count}} Anerkennungen',
    empty: 'Es gibt noch keine Anerkennungen zum Anzeigen.',
    prev: 'Vorherige',
    next: 'Nächste',
    pageOf: 'Seite {{page}} von {{total}}',
    for: 'für',
    anonymous: 'Anonym',
    senderHidden: 'Identität nicht sichtbar',
    userUnavailable: 'Benutzer nicht verfügbar',
    points_one: '+{{count}} Punkt',
    points_other: '+{{count}} Punkte',
    pointsTitle: 'Punkte, die diese Anerkennung wert ist',
    fundamentalsRecognized: 'Anerkannte Grundprinzipien',
    fundIconTooltipAria: 'Alle Grundprinzipien dieser Anerkennung ansehen',
    behaviorsRecognized: 'Anerkannte Verhaltensweisen',
    habitsRecognized: 'Anerkannte tägliche Gewohnheiten',
    detailUnavailable: 'Die vollständigen Details konnten nicht geladen werden.',
    reportCount: '{{count}} Mal gemeldet — in Prüfung',
    receivedIn: 'Erhalten in:',
    antiSpoilerBlurredHint: 'Warte auf die Preisverleihung der Brillamos-Juntos-Veranstaltung, um deine Nominierungen zu sehen.',
    antiSpoilerHiddenHint: 'Einige Anerkennungen sind durch den Anti-Spoiler-Modus ausgeblendet, bis ihre Kampagne endet.',
  },
  reactions: {
    addLabel: 'Reagieren',
    countLabel: '{{count}} Reaktionen',
    modalTitle: 'Reaktionen',
    error: 'Deine Reaktion konnte nicht gespeichert werden. Bitte versuche es erneut.',
    whoReacted: 'Reagiert haben',
    whoLoading: 'Wird geladen…',
    whoEmpty: 'Noch niemand hat reagiert.',
    whoError: 'Die Liste konnte nicht geladen werden.',
  },
  origin: {
    diario: 'Täglich',
    brillamos: 'Wir strahlen',
    personalizada: 'Kampagne',
    csv: 'Massenimport',
    delegado: 'Delegiert',
    sistema: 'System',
  },
  panel: {
    title: 'Nominiere deine Kolleg:innen',
    recipientsLabel: 'Personen',
    recipientsPlaceholder: 'Nach Namen oder E-Mail suchen…',
    searchError: 'Die Personensuche konnte nicht durchgeführt werden.',
    fundamentalLabel: 'Grundwert (max. {{max}})',
    fundamentalLabelUnbounded: 'Grundwert',
    maxFundamentalsHint: 'Du kannst maximal {{max}} Grundwerte auswählen.',
    behaviorsLabel: 'Verhaltensweisen',
    habitsLabel: 'Tägliche Verhaltensweisen',
    habitRequiredHint: 'Wähle mindestens eine tägliche Verhaltens- weise aus, um die Nominierung senden zu können.',
    summaryLabel: 'Zusammenfassung',
    edit: 'Bearbeiten',
    messageLabel: 'Deine Nachricht',
    messagePlaceholder: 'Warum möchtest Du diese Person nominieren?',
    anonymous: 'Anonym senden',
    sendToBrillamos: 'Auch an Shine Together senden',
    // Decisión 6 (2026-10-15) — «Enviar también a Brillamos» avisa antes y después de enviar.
    sendToBrillamosNoCabe: 'Diese Anerkennung passt nicht zu den Regeln von „{{campana}}“ ({{limites}}). Wenn du sie so sendest, geht sie als tägliche Anerkennung raus.',
    brillamosMaxPersonas_one: 'höchstens {{count}} Person',
    brillamosMaxPersonas_few: 'höchstens {{count}} Personen',
    brillamosMaxPersonas_other: 'höchstens {{count}} Personen',
    brillamosMaxFundamentales_one: 'höchstens {{count}} Fundamental',
    brillamosMaxFundamentales_few: 'höchstens {{count}} Fundamentals',
    brillamosMaxFundamentales_other: 'höchstens {{count}} Fundamentals',
    sendToBrillamosSalioDiario: 'Als tägliche Anerkennung gesendet: Sie ist nicht in „{{campana}}“ eingegangen.',
    charCount: '{{count}} Zeichen',
    charsAvailableHint: 'Du näherst dich dem Limit. Dir bleiben {{remaining}} von {{max}} Zeichen.',
    charsLimitReachedHint: 'Du hast das Limit von {{max}} Zeichen erreicht. Kürze einen Teil, um weiterzuschreiben.',
    charsLimitSentenceNote: 'Der auf dem Post-it zusammengestellte Satz zählt ebenfalls zum Limit.',
    errMessageTooLong: 'Deine Nachricht überschreitet das Limit von {{max}} Zeichen. Kürze einen Teil und sende sie erneut.',
    errRecipientRequired: 'Wähle die Person aus, die du nominieren möchtest, bevor du sendest.',
    errFundamentalRequired: 'Wähle mindestens einen Grundwert aus, bevor du sendest.',
    errSessionUnknown: 'Wir konnten deine Sitzung nicht identifizieren. Schließe die App, melde dich erneut an und versuche es noch einmal.',
    errRecipientWithoutCampaign_one: '{{names}} hat keine aktive Kampagne und kann diese Nominierung daher nicht erhalten. Entferne diese Person aus dem Versand, um fortzufahren.',
    errRecipientWithoutCampaign_few: '{{names}} haben keine aktive Kampagne und können diese Nominierung daher nicht erhalten. Entferne diese Personen aus dem Versand, um fortzufahren.',
    errRecipientWithoutCampaign_other: '{{names}} haben keine aktive Kampagne und können diese Nominierung daher nicht erhalten. Entferne diese Personen aus dem Versand, um fortzufahren.',
    errDelegateNotAllowed: 'Du hast nicht die Berechtigung „Im Namen einer anderen Person anerkennen“. Sende die Anerkennung in deinem Namen.',
    errDelegateOtherUnit: 'Du kannst nur im Namen von Personen deiner eigenen Einheit anerkennen. Wähle eine andere Person als Absender.',
    errDelegateNotOperational: 'Du kannst nur im Namen von operativem Personal anerkennen. Wähle eine andere Person als Absender.',
    errDelegateNotFound: 'Die als Absender gewählte Person existiert nicht oder ist nicht mehr aktiv. Wähle eine andere Person.',
    errDelegateRequesterWithoutUnit: 'Deinem Profil ist keine Einheit zugewiesen, daher kannst du nicht im Namen einer anderen Person anerkennen.',
    errDelegateNotEligible: 'Du kannst nicht im Namen dieser Person anerkennen. Wähle eine andere Person als Absender.',
    errDelegateCheckUnavailable: 'Die als Absender gewählte Person konnte nicht überprüft werden. Versuche es in ein paar Minuten erneut.',
    send: 'Senden',
    sending: 'Wird gesendet…',
    sentTitle: 'Nominierung gesendet!',
    sentSubtitle: 'Sichtbar für das Team und die Führungskraft.',
    sendErrorGeneric: 'Die Nominierung konnte nicht gesendet werden. Bitte versuche es erneut.',
    legalHint: 'Du musst die geltenden rechtlichen Bedingungen akzeptieren, bevor Du eine Nominierung aussprechen kannst.',
    sendingDisabledHint: 'Das Senden von Nominierungen ist vorübergehend deaktiviert.',
    scheduleRestrictedHint: 'Das Versenden von Nominierungen ist für deinen Standort derzeit außerhalb der freigegebenen Zeiten.',
    weeklyLimitHint: 'Für deinen Standort gilt ein Limit von {{count}} Nominierungen pro Woche.',
    missingRecipientsHint: 'Wähle mindestens eine Person aus, die Du nominieren möchtest.',
    missingFundamentalHint: 'Wähle mindestens einen Grundwert aus.',
    messageMinCharsHint: 'Deine Nachricht muss mindestens {{count}} Zeichen enthalten.',
    missingBehaviorForHabitHint: 'Wähle eine Verhaltensweise aus, um die verfügbaren täglichen Verhaltensweisen anzuzeigen.',
    noHabitsAvailableHint: 'Für diesen Grundwert sind keine täglichen Verhaltensweisen hinterlegt. Bitte wähle einen anderen aus.',
    groupTag: 'Team',
    delegateTitle: 'Sendemodus',
    modeSelfTab: 'In meinem Namen',
    modeOnBehalfTab: 'Im Namen einer anderen Person',
    delegateLabel: 'Im Namen von',
    delegateSubtitle: 'Du kannst Nominierungen im Namen von Mitarbeitenden senden.',
    delegatePlaceholder: 'Mitarbeitenden suchen…',
    onBehalfActiveBanner: 'Du nominierst im Namen von {{name}}.',
  },
  profile: {
    title: 'Mein Anerkennungsprofil',
    subtitle: 'Deine Anerkennungsaktivität und deine Serie.',
    received: 'Erhalten',
    sent: 'Gesendet',
    streak: 'Serie',
    empty: 'Sie haben noch keine Anerkennungsaktivität.',
    weeksStreak: 'Wochen in Serie',
    monthsStreak: 'Monate Serie',
    record: 'Rekord',
    totalSent: 'Gesendet',
  },
  catalog: {
    title: 'Grundprinzipien',
    empty: 'Der Katalog der Grundprinzipien ist leer.',
  },
  notifications: {
    title: 'Benachrichtigungen',
    close: 'Benachrichtigungen schließen',
    placeholder: 'Der Benachrichtigungseingang wird in Kürze verfügbar sein.',
    unread: '{{count}} ungelesen',
    markAllRead: 'Alle als gelesen markieren',
    markRead: 'Als gelesen markieren',
    readState: 'Lesestatus',
    inviteToRecognize: 'Zur Nominierung einladen',
    markUnread: 'Als ungelesen markieren',
    loadMore: 'Frühere Benachrichtigungen anzeigen',
    recognitionUnavailable: 'Diese Anerkennung ist nicht mehr verfügbar.',
    unsavedTitle: 'Du hast ungespeicherte Änderungen',
    unsavedDesc: 'Wenn Du jetzt gehst, gehen deine bisherigen Eingaben verloren.',
    unsavedConfirm: 'Ohne Speichern verlassen',
    unsavedCancel: 'Hier bleiben',
    campaignInactive: 'Die Kampagne, zu der diese Nominierung gehört, ist bereits beendet. Daher kann sie nicht mehr geöffnet werden.',
    campaignUnavailable: 'Diese Kampagne ist bereits beendet. Daher kann sie nicht mehr geöffnet werden.',
    unavailable: 'Der Posteingang ist derzeit nicht verfügbar.',
    empty: 'Du hast keine Benachrichtigungen.',
  },
  // ── WP-12/WP-13 (D4) — Strahlen+Nominieren, Bibliothek, Profil, Wrapped ──
  home: {
    sent: 'Gesendete Nominierungen', received: 'Erhaltene Nominierungen', recognizeCta: 'Jetzt nominieren', recent: 'Aktuelle Nominierungen',
    active: 'Aktive Kampagne',
    ended: 'Kampagne beendet',
    daysLeft: 'Noch {{count}} Tage',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Jetzt nominieren',
    // Demo-Parität (D1/D2) — Hero von /app/reconocer, aus HomePage.tsx der Demo übernommen.
    titleLine1: 'Nominiere die Person, die',
    titleVive: 'unsere Grundwerte lebt',
    subtitle: 'Nominiere eine/n Kolleg:innen, die oder der andere inspiriert, indem sie bzw. er unsere Grundwerte lebt.',
    cta: '✨ Jemanden nominieren',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: 'Du hast noch niemanden nominiert!',
    emptyReceived: 'Lebe weiterhin unsere Grundwerte und schon bald wirst Du nominiert!',
  },
  streak: {
    title: 'Deine Nominierungsserie',
    subtitle: 'Würdige jede Woche und bleib am Ball!',
    subtitleMonthly: 'Würdige jeden Monat und strahle weiter!',
    weeks: 'Wo.',
    months: 'Monate',
    month: 'Monat',
    monthsMany: 'Monate',
    record: 'Rekord',
    total: 'Nominierungen',
    activeDays: '{{count}} aktive Tage diese Woche',
    currentLevel: 'AKTUELLES LEVEL',
    atRisk: 'Deine Serie ist diese Woche gefährdet',
    atRiskMonthly: 'Deine Serie ist diesen Monat gefährdet',
    // PHASE 7 (Demo-Parität, H-91) — vereinheitlichte .streak-*-Familie.
    current: 'Aktuelle Serie',
    thisWeek: 'Diese Woche',
    days: 'Tage',
    today: 'Heute!',
    nudgeDone: 'Du hast heute schon nominiert! 🌟',
    nudgeTodo: 'Würdige heute und halte deine Serie! 🚀',
    periodProgress: '{{sent}} von {{min}} diese Woche',
    periodProgressDone: 'Wochenziel erreicht! ({{sent}} von {{min}})',
    periodProgressMonthly: '{{sent}} von {{min}} diesen Monat',
    periodProgressDoneMonthly: 'Monatsziel erreicht! ({{sent}} von {{min}})',
    provisionalNote: 'Einschließlich dieser Woche · wird zum Abschluss bestätigt',
    provisionalNoteMonthly: 'Einschließlich dieses Monats · wird zum Abschluss bestätigt',
    badgeProvisional: 'ZUM ABSCHLUSS',
    badgeProvisionalTooltip: 'Du hast das Minimum für diesen Zeitraum bereits erreicht: Das Abzeichen wird schon angezeigt und beim Abschluss des Zeitraums offiziell bestätigt.',
    badgesTitle: 'Abzeichen',
    celebration: {
      title: 'Abzeichen freigeschaltet!',
      message: 'Mach weiter so, deine Beständigkeit fällt positiv auf!',
      cta: 'Klasse!',
    },
    badgeWeek: '{{count}} Woche',
    badgeWeeks: '{{count}} Wochen',
    badgeWeeksMany: '{{count}} Wochen',
    badgeMonth: '{{count}} Monat',
    badgeMonths: '{{count}} Monate',
    badgeMonthsMany: '{{count}} Monate',
    note: '* Die Serie wird aus den gesendeten Nominierungen berechnet',
    day: { mon: 'M', tue: 'D', wed: 'M', thu: 'D', fri: 'F', sat: 'S', sun: 'S' },
  },
  // 2026-08-10 — nur `crossOu` wird noch verwendet (von NominarView). Der Rest gehörte zum
  // "Aktivitäts-Feed" von Brillamos Juntos (`BrillamosFeed`, auf Kundenwunsch aus dem Baum entfernt).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Alle Sprachen",
    title: 'Kampagnendokumente',
    download: 'Herunterladen',
    loadError: 'Dokument konnte nicht geladen werden.',
    cat: {
      howto: 'So nominieren Sie',
      awards: 'Preise',
      legal: 'Teilnahmebedingungen',
      privacy: 'Datenschutzerklärung',
      cookies: 'Cookie-Richtlinie',
      notice: 'Impressum',
    },
  },
  library: {
    title: 'Die Grundprinzipien',
    subtitle: 'Die Basis dafür, wie wir bei Sigma arbeiten, zusammenarbeiten und wachsen.',
    watchVideo: 'Video ansehen',
    behaviorsCount: '{{count}} Haltungen und Verhaltensweisen',
    dailyHabits: 'Tägliche Gewohnheiten',
    micrositeSpace: 'Bereich der Kultur-Microsite',
  },
  nominate: {
    back: 'Shine Together',
    thanksTo: 'Danke an {{name}} für',
    demonstrating: 'indem {{fundamental}} vorgelebt wurde',
    defaultMessage: 'Nominierung gesendet',
    sentTitle: 'Nominierung gesendet!',
    sentSubtitle: 'Danke, dass Du {{name}} sichtbar machst.',
    redirecting: 'Zurück zur Kampagne…',
    yourRecognition: 'Deine Anerkennung / deine Wertschätzung',
    thanksWord: 'Danke an',
    slotWho: 'Wer?',
    forWord: 'für',
    slotWhat: 'Was hat die Person getan?',
    demonstratingWord: 'durch das Vorleben von',
    slotFund: 'Welcher Grundwert?',
    elements: '{{done}}/3 Elemente',
    eyebrow: 'Nominierung erstellen',
    title: 'Bitte fülle alle drei Felder aus',
    field1: 'Markiere deine Kolleg:innen',
    searchPlaceholder: 'Name der Kollegin / des Kollegen…',
    noResults: 'Wir haben niemanden mit diesem Namen gefunden.',
    field2: 'Welcher Grundwert wurde vorgelebt?',
    field3: 'Was hat die Person getan?',
    noActions: 'Für diesen Grundwert sind keine Verhaltensweisen hinterlegt.',
    pickFundFirst: 'Wähle zuerst einen Grundwert aus.',
    completeMessage: 'Vervollständige deine Nachricht',
    personalizeTitle: 'Personalisiere deine Nachricht',
    personalizeSub: 'Ergänze Deine persönliche Botschaft. Alles andere ist bereits vorbereitet.',
    messagePlaceholder: 'Beschreibe die konkrete Situation, die Du beobachtet hast …',
    charCount: '{{count}} Zeichen',
    idealRange: '30–80 Zeichen empfohlen',
    nudgeText: 'Deine Nachricht wirkt noch persönlicher, wenn Du einen eigenen Satz hinzufügst.',
    addLine: 'Zeile hinzufügen',
    sendAnyway: 'Trotzdem senden',
    send: 'Nominierung senden',
  },
  wrapped: {
    readyTitle: 'Dein Recap ist fertig', readySubtitle: 'Erlebe die Momente noch einmal, die dein {{year}} zum Strahlen gebracht haben.', open: 'Mein Recap ansehen',
    introHint: 'Ein Blick auf dein Jahr des Anerkennens.',
    topReceptor: 'Wen Sie am häufigsten anerkannt haben',
    topEmisor: 'Dein Fan Nr. 1',
    topFundamentalHint: 'Das, was Sie am meisten gefeiert haben.',
    bottomFundamentalHint: 'Das, was du am wenigsten gefeiert hast. Deine Herausforderung für dieses Jahr.',
    crossOuValue: '{{count}} Cross-OU-Anerkennungen',
    messageFrom: 'Von {{name}}',
    winnerYear: 'Jahr {{anio}}',
    winnerPosition: 'Platz {{position}}',
    sinceMonth: 'Deine Zusammenfassung beginnt im {{month}}.',
    streakValue: '{{count}} Wochen',
    streakValueOne: '{{count}} Woche',
    streakValueMany: '{{count}} Wochen',
    streakValueMonth: '{{count}} Monate',
    streakValueMonthOne: '{{count}} Monat',
    streakValueMonthMany: '{{count}} Monate',
    unavailable: 'Dein Wrapped ist noch nicht verfügbar.',
    // RF-130-Korrektur F1 (H-06) — das Backend liefert einen STABILEN SCHLÜSSEL
    // (`GetRecognitionWrappedQueryHandler.cs`), keinen Text. `WrappedModal.tsx` löst ihn gegen diese
    // drei auf, mit einer Whitelist: niemals `t(rohesSchlüssel)`.
    generosityTag: {
      generoso: 'Großzügig',
      muyGeneroso: 'Sehr großzügig',
      superGeneroso: 'Super großzügig',
    },
  },
  prof: {
    myFolders: 'Meine erhaltenen Anerkennungen, gefiltert nach Fundamental',
    viewingTitle: 'Profil von {{name}}',
    backToMine: 'Mein Profil',
    myTeam: 'Team',
    searchColleague: 'Kolleg:innen suchen…',
    campaignBannerSub: 'Die Kampagne ist aktiv. Wechsel zu Shine Together',
    ctaRecognize: 'Jemanden nominieren',
    myWrapped: 'Meine Zusammenfassung {{year}}',
    brillamosFolder: 'Shine Together',
    emptySent: 'Du hast noch keine Nominierungen gesendet.',
    emptyBrillamos: 'Hier gibt es noch keine Nominierungen aus Shine Together.',
    folderEmpty: 'In diesem Ordner gibt es noch keine Nominierungen.',
    recognizeName: '{{name}} nominieren',
    // PHASE 6 (Demo-Parität, H-75/H-77/H-78) — Profil `.rp2-*`.
    thisWeek: 'Diese Woche',
    weekdayInitials: 'M,D,M,D,F,S,S',
    badges: 'Abzeichen · Shine Together',
    recap: 'Zusammenfassung {{year}}',
    sigmaMsg: '"Danke, dass Du die Kultur von Sigma lebst"',
    sigmaFrom: '— Sigma · {{year}}',
    sigmaNote: 'Im Jahr {{year}} keine Nominierungen erhalten. Diese Nominierung erinnert daran, welchen wertvollen Beitrag Du für das Team leistest.',
    sigmaNoteSent: 'Keine gesendeten Nominierungen in {{year}}. Diese Nominierung ist eine Erinnerung an deinen Wert für das Team.',
  },
  time: {
    moment: 'Gerade eben',
    hours: 'Vor {{n}} Std.',
    yesterday: 'Gestern',
    days: 'Vor {{n}} Tagen',
  },
  // ── WP-11 REQ-104 — Interaktives Post-it / Word Builder ──
  builder: {
    modeLabel: 'Anerkennungsmodus',
    modeClassic: 'Klassisch',
    modeInteractive: 'Interaktiv',
    previewLabel: 'Vorschau der Anerkennung',
    thanksWord: 'Ich erkenne an',
    forWord: 'für',
    demonstratingWord: 'und zeigt damit',
    slotWho: 'wen?',
    slotWhat: 'was hat er/sie getan?',
    slotFund: 'Grundprinzip?',
    stepOf: 'Schritt {{step}} von {{total}}',
    step1Title: 'Wen erkennen Sie an?',
    step3Title: 'Welches Verhalten oder welche Gewohnheit?',
    step4Title: 'Füge deine Nachricht hinzu',
    complementPlaceholder: 'Beschreiben Sie den konkreten Moment, den Sie beobachtet haben…',
    noActions: 'Für dieses Grundprinzip sind weder Verhaltensweisen noch Gewohnheiten konfiguriert.',
    back: 'Zurück',
    next: 'Weiter',
  },
  ri: {
    bankLabel: 'Wortbank',
    bankTitle: 'Wähle deine Wörter',
    bankHint: 'Tippe unten auf ein Wort, um dein Post-it zu vervollständigen 👇',
    forWhom: 'Für wen',
    searchPlaceholder: 'Name der Kollegin / des Kollegen…',
    catAccion: 'Grundprinzipien',
    catComportamiento: 'Verhaltensweisen',
    catHabito: 'Gewohnheiten',
    catImpacto: 'Wirkung',
    msgLabel: 'Deine Nachricht',
    msgTitle: 'Baue deine Anerkennung',
    words: 'Elemente',
    clear: 'Leeren',
    clickToRemove: 'Zum Entfernen klicken',
    clickHint: 'Klicke auf ein Wort aus der Wortbank',
    pickFundFirst: '👆 Wähle ein Grundprinzip, um seine Verhaltensweisen zu sehen',
    pickBehaviorFirst: '👆 Wähle ein Verhalten, um seine Gewohnheiten zu sehen',
    noHabitsForFund: '👆 Für dieses Grundprinzip sind keine Gewohnheiten konfiguriert',
    howLabel: 'Wie funktioniert das?',
    howTitle: 'Drei einfache Schritte',
    step1: '<strong>Fahre mit der Maus</strong> über ein Wort, und das Zielfeld leuchtet auf.',
    step2: '<strong>Klicke</strong> auf das Wort, um es in die Nachricht einzufügen.',
    step3: '<strong>Klicke auf das Feld</strong> des Post-its, um ein eingesetztes Wort zu entfernen.',
    quote: 'Anerkennen heißt, das Unsichtbare zu benennen. Wenn wir jemandem sagen, was wir in ihm sehen, weben wir Gemeinschaft.',
    cta: 'Vervollständige deine Nachricht',
    ctaDone: 'Vervollständige deine Nachricht →',
    popupTitle: 'Füge die persönliche Note hinzu',
    popupChars: '30-80 Zeichen ideal',
    nudgeMsg: 'Ihre Nachricht wirkt stärker, wenn Sie eine eigene Zeile hinzufügen 💛',
    nudgeAdd: 'Zeile hinzufügen',
    nudgeSkip: 'Trotzdem senden',
    sent: 'Anerkennung gesendet!',
    sentIntro: 'Danke an meine:n',
    continueBtn: 'Weiter →',
    seeRecognition: 'Meine Anerkennung ansehen →',
    clearReset: 'Leeren und neu beginnen',
    wStep: 'Schritt {{step}} von {{total}}',
    wQPersona: 'Wen erkennen Sie an?',
    wQFund: 'Welches Grundprinzip hat er/sie gelebt?',
    wQBehavior: 'Welches Verhalten hat er/sie gezeigt?',
    wQHabit: 'Welche Gewohnheit war es?',
    wQImpact: 'Welche Wirkung hatte das?',
    templateThanks: 'Ich erkenne an',
    templateForLiving: 'für das Leben von',
    templateWith: 'mit',
    templateShowing: ', und zeigt damit, dass',
    templateThat: '. Das',
    slotPersona: 'Person',
    slotAccion: 'Grundprinzip',
    slotComportamiento: 'Verhalten',
    slotHabito: 'Gewohnheit',
    slotImpacto: 'Wirkung',
    impact1: 'inspiriert uns',
    impact2: 'lässt uns wachsen',
    impact3: 'richtet uns aus',
    impact4: 'bringt das Team voran',
    tooltipFundamental: 'Ein Fundamental ist der Wert, den die Person gelebt hat.',
    tooltipComportamiento: 'Das konkrete Verhalten, das diesen Wert gezeigt hat.',
    tooltipHabito: 'Die tägliche Gewohnheit, in der sich dieses Verhalten zeigt.',
    tooltipImpacto: 'Die Wirkung, die es auf das Team hatte.',
    guideStep1Title: 'Wähle deine Wörter',
    guideStep1Text: 'Hier wählst du das Fundamental, das Verhalten, die Gewohnheit und die Wirkung, die du anerkennen möchtest.',
    guideStep2Title: 'Dein Post-it entsteht',
    guideStep2Text: 'Jedes gewählte Wort füllt eine Lücke im Satz deiner Anerkennung.',
    guideStep3Title: 'Füge deine persönliche Note hinzu',
    guideStep3Text: 'Diese Nachricht macht ihre Anerkennung noch besonderer.',
    guideStep4Title: 'Sende deine Anerkennung',
    guideStep4Text: 'Sobald alles vollständig ist, wird dieser Button aktiv und du kannst senden.',
    guideReopen: 'Anleitung erneut ansehen',
    guideNext: 'Weiter',
    guideSkip: 'Überspringen',
    guideDone: 'Verstanden',
    progressLabel: '{{value}} von {{total}} Schritten abgeschlossen',
  },
  // ── WP-11 REQ-106 — CSV-Massenimport ──
  bulk: {
    or: 'oder',
    open: 'Massen-Upload',
    title: 'Massen-Upload von Anerkennungen',
    subtitle: 'Lade eine CSV mit mehreren Anerkennungen auf einmal hoch, prüfe und korrigiere vor der Bestätigung.',
    stepInstructions: 'Anleitung',
    stepUpload: 'Datei hochladen',
    stepReview: 'Prüfen',
    stepConfirm: 'Bestätigen',
    stepOf: 'Schritt {{step}} von {{total}}',
    next: 'Weiter',
    back: 'Zurück',
    instructionsIntro: 'Lade die Vorlage herunter, fülle sie mit einer Person pro Zeile aus und lade sie hoch, um sie zu validieren und im Batch zu laden.',
    matchByIdentity: 'Suche die Person über ihre registrierte E-Mail-Adresse oder ihre Personalnummer — eines von beidem genügt. Kennst du die E-Mail nicht? Die Personalnummer funktioniert genauso gut.',
    onePersonPerRowWarning: 'Wichtig: Jede Zeile der Datei steht für GENAU EINE Person. Trage nicht mehrere E-Mail-Adressen oder Personalnummern in dieselbe Zelle ein — wenn du mehrere Personen nominieren möchtest, füge für jede Person eine eigene Zeile hinzu.',
    // colRequired/colOptional: gemeinsam mit adminBulkUsers/StepInstructions.tsx genutzt
    // (Europa/USA-Verzeichnis) — dieser Wizard verwendet sie nicht mehr (seine festen Spalten
    // tragen kein Pflicht-/Optional-Tag). Bei einer Bereinigung hier nicht entfernen, ohne vorher
    // diesen anderen Verbraucher zu prüfen.
    colRequired: 'Pflichtfeld',
    colOptional: 'Optional',
    colNameNombre: 'Name',
    colNameCorreoNomina: 'E-Mail oder Personalnummer',
    colNameFundamental: 'Grundwert',
    colReceptorEmailDesc: 'E-Mail der Person, die die Anerkennung erhält.',
    colMensajeDesc: 'Anerkennungsnachricht. Je nach Organisationseinheit ggf. Pflichtfeld.',
    colEmisorEmailDesc: 'E-Mail des Absenders. Pflicht: diese E-Mail oder die Personalnummer.',
    colReceptorNominaDesc: 'Personalnummer der empfangenden Person (AD, SuccessFactors oder das Europa-Verzeichnis). Alternative zur E-Mail — ersetzt sie nicht, dient für Personen ohne E-Mail oder ohne Registrierung.',
    colEmisorNominaDesc: 'Personalnummer des Absenders. Pflicht: diese Nummer oder die E-Mail.',
    markColumnsTitle: 'Und je eine Spalte für jeden Grundwert, jedes Verhalten und jede tägliche Verhaltensweise',
    markColumnsIntro: 'Nach diesen festen Spalten siehst du eine Spalte für jedes davon — markiere die passende mit einem X (oder einem beliebigen Zeichen wie „ja"). Kein Code zum Eintippen.',
    markFundamentalHint: 'Markiere einen oder mehrere Grundwerte pro Zeile — bis zu dem Limit, das deine Organisationseinheit erlaubt.',
    markBehaviorHint: 'Das Verhalten ist optional — du kannst mehrere markieren.',
    markHabitHint: 'Die täglichen Verhaltensweisen sind optional — du kannst mehrere markieren.',
    markColumnsOutro: 'Die Spalte Mensaje ist die letzte Spalte in der Datei, nach allen Markierungsspalten.',
    downloadTemplate: 'Vorlage herunterladen',
    templateError: 'Vorlage konnte nicht heruntergeladen werden.',
    catalogError: 'Der Katalog der Grundwerte konnte nicht geladen werden. Bitte versuche es erneut — ohne den Katalog kann die Datei nicht validiert werden.',
    upload: 'CSV hochladen',
    dragDropHint: 'Ziehe deine CSV-Datei hierher oder klicke, um sie auszuwählen.',
    invalidFileType: 'Es werden nur CSV-Dateien akzeptiert.',
    emptyFile: 'Die Datei enthält keine Datenzeilen.',
    parseError: 'CSV-Datei konnte nicht gelesen werden.',
    uploadError: 'Massen-Upload konnte nicht verarbeitet werden.',
    validRows: '{{count}} gültige Zeilen',
    invalidRows: '{{count}} mit Fehlern',
    reviewHint: 'Korrigiere die rot markierten Zeilen direkt in der Tabelle; jede Änderung wird erneut geprüft.',
    colLine: '#',
    colReceptor: 'Empfänger',
    colFundamental: 'Fundamental',
    colMensaje: 'Nachricht',
    colReceptorNomina: 'Personalnr.',
    colBehavior: 'Verhalten',
    colHabits: 'Daily Habits',
    colStatus: 'Status',
    ok: 'Gültig',
    expandRow: 'Details zu Zeile {{line}} anzeigen',
    collapseRow: 'Details zu Zeile {{line}} ausblenden',
    habitsCount_one: '{{count}} tägliche Verhaltensweise',
    habitsCount_other: '{{count}} tägliche Verhaltensweisen',
    revalidating: 'Wird erneut geprüft…',
    downloadErrors: 'Fehler herunterladen (CSV)',
    confirmSummary: 'Es werden {{count}} Anerkennungen erstellt. Fehlerhafte Zeilen werden übersprungen.',
    confirm: '{{count}} gültige laden',
    committed: '{{created}} Anerkennungen wurden erstellt. {{skipped}} Zeilen wurden übersprungen.',
    duplicatesSkipped_one: '1 Nominierung wurde nicht gesendet: Sie wurde bereits zuvor mit derselben Nachricht gesendet.',
    duplicatesSkipped_other: '{{count}} Nominierungen wurden nicht gesendet: Sie wurden bereits zuvor mit derselben Nachricht gesendet.',
    notFoundTitle: 'In der Adressliste nicht gefundene E-Mails:',
    errors: {
      receptorRequired: 'Die E-Mail des Empfängers ist erforderlich.',
      receptorNotFound: 'Diese E-Mail existiert nicht in der Adressliste.',
      emisorMissing: 'Absender fehlt: Gib die E-Mail oder Personalnummer der anerkennenden Person an.',
      emisorOtherUnit: 'Absender außerhalb deiner Einheit: Du kannst nur im Namen von Personen deiner eigenen Einheit hochladen.',
      emisorStaff: 'Absender mit Firmenkonto (Staff): Hochladen ist nur im Namen von operativem Personal möglich.',
      delegateCheckUnavailable: 'Die Absender der Datei konnten nicht überprüft werden, es wurde nichts hochgeladen. Versuche es in ein paar Minuten erneut.',
      multiplePeopleNotSupported: 'Diese Spalte darf nur eine Person enthalten (eine E-Mail-Adresse oder eine Personalnummer). Um mehrere Personen anzuerkennen, füge eine Zeile pro Person hinzu.',
      fundamentalInvalid: 'Der Fundamental-Wert ist erforderlich, oder die Nachricht erfüllt nicht die Vorgaben deiner Organisationseinheit.',
      selfRecognition: 'Du kannst dich nicht selbst anerkennen.',
      blockedWord: 'Die Nachricht enthält ein nicht zulässiges Wort.',
      weeklyCapExceeded: 'Der Absender hat sein wöchentliches Limit an Anerkennungen erreicht.',
      duplicateInFile: 'Diese Zeile ist in der Datei mehrfach vorhanden.',
      behaviorInvalid: 'Das Verhalten ist für das Fundamental dieser Zeile nicht gültig.',
      habitInvalid: 'Einer der Daily Habits ist für das Fundamental dieser Zeile nicht gültig.',
      campaignClosed: 'Die Kampagne ist nicht aktiv.',
      notAllowedForCampaign: 'Diese Zeile ist für die Kampagne dieses Stapels nicht zulässig.',
      maxFundamentalsExceeded: 'Für diese Nominierung können keine weiteren Grundwerte ausgewählt werden: das Limit ergibt sich aus der Konfiguration der Organisationseinheit des Absenders.',
      generic: 'Diese Zeile konnte nicht validiert werden.',
    },
  },
  // ── WP-11 REQ-107 — Post-it-Aktionen ──
  actions: {
    // RF-086 / RN-M06 — der Gründe-Katalog (`reportReasons`) entfiel: der Grund ist Freitext.
    reportCharsLeft: 'Noch {{n}} Zeichen',
    edit: 'Bearbeiten',
    report: 'Melden',
    delete: 'Löschen',
    saveEdit: 'Speichern',
    editError: 'Die Anerkennung konnte nicht bearbeitet werden.',
    editMinChars: 'Die Nachricht muss mindestens {{min}} Zeichen enthalten ({{count}}/{{min}}).',
    reportReason: 'Grund der Meldung',
    reportPlaceholder: 'Beschreibe das Problem kurz…',
    reportError: 'Die Meldung konnte nicht gesendet werden.',
    reportSent: 'Meldung gesendet. Unser Team wird sie prüfen.',
    sendReport: 'Meldung senden',
    deleteConfirm: 'Möchten Sie diese Anerkennung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteError: 'Die Anerkennung konnte nicht gelöscht werden.',
    confirmDelete: 'Ja, löschen',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Massenimport der Personalliste (Europa und USA)',
      descLong: 'Anlage und Aktualisierung der Personalliste Europa/USA über eine CSV mit 24 Spalten, plus der Region der Datei (Europa oder USA), die beim Hochladen ausgewählt wird. Der Import ist inkrementell: Wer nicht in der Datei vorkommt, bleibt unverändert; Austritte werden über die Spalte EMPLOYEE DELETED markiert. Bei Austritten kann die E-Mail geleert oder geändert werden, und die E-Mail einer ausgetretenen Person steht anderen wieder zur Verfügung. Alle anderen Regionen synchronisiert SuccessFactors automatisch.',
      importHint: 'Vorlage herunterladen, ausfüllen und hochladen. Beim Hochladen wird zuerst eine Vorschau angezeigt, die nichts speichert. Datumsformat MM/dd/jjjj.',
      openWizard: 'Massenimport öffnen',
      wizardSubtitle: 'CSV der Personalliste hochladen, Ergebnis prüfen und bestätigen — es wird erst im letzten Schritt gespeichert.',
      confirm: 'Import bestätigen',
      downloadErrors: 'Fehler herunterladen (CSV)',
      received: 'Zeilen',
      created: 'Angelegt',
      updated: 'Aktualisiert',
      deactivated: 'Deaktiviert',
      skipped: 'Übersprungen',
      disabled: 'Der Massenimport Europa/USA ist in den Quelleinstellungen deaktiviert.',
      previewNotice: 'Vorschau: Es wurde noch nichts gespeichert. Dies sind die Zahlen, die der echte Import liefern wird.',
      allOk: 'Alle Zeilen wurden ohne Fehler verarbeitet.',
      blockingErrorsNotice: 'Es gibt Fehler, die eine Fortsetzung verhindern. Korrigiere die Datei und lade sie erneut hoch.',
      importError: 'Die Datei konnte nicht verarbeitet werden.',
      importErrorTimeout: 'Der Server hat zu lange für eine Antwort gebraucht. Der Import ist serverseitig möglicherweise trotzdem abgeschlossen worden — bitte die Personalliste prüfen, bevor du es erneut versuchst. Referenz: {{correlationId}}',
      ignoredColumnsNotice: 'Diese Spalten Ihrer Datei werden nicht erkannt und ignoriert: {{columns}}',
      confirmRecap: 'Es werden {{total}} Zeilen verarbeitet: {{created}} neu, {{updated}} aktualisiert, {{deactivated}} deaktiviert.',
      committed: 'Import abgeschlossen: {{created}} neu, {{updated}} aktualisiert, {{deactivated}} deaktiviert, {{skipped}} übersprungen.',
      committedErrorsNotice: 'Bei einigen Zeilen gab es Probleme während des Imports. Prüfe die Details, bevor du diesen Daten vertraust.',
      paginationPage: 'Seite {{page}} von {{total}}',
      errorColumn: 'Spalte',
      errorDetail: 'Fehler-/Auslassungsdetail',
      ouLabel: 'Region der Datei',
      ouPlaceholder: 'Region auswählen',
      ouEuropa: 'Europa',
      ouUsa: 'USA',
      ouCentral: 'Central',
      ouHint: 'Gilt für alle Zeilen der Datei. Wird nicht mehr pro Zeile in der CSV erfasst, um Tipp- oder Sprachfehler zu vermeiden.',
      ouRequired: 'Wähle die Region, bevor du die Datei hochlädst.',
      errorCode: {
        'email-in-use-active': 'E-Mail wird bereits von einer aktiven Person verwendet, bitte eine andere gültige E-Mail eingeben.',
        'reactivation-email-in-use': 'Nicht reaktiviert: Die E-Mail wird von einer aktiven Person verwendet, bitte eine andere gültige E-Mail eingeben.',
        'import-audit-failed': 'Der Import wurde durchgeführt, konnte aber nicht im Importprotokoll erfasst werden. Bitte den Support informieren.',
        'user-audit-failed': 'Der Import wurde durchgeführt, aber es konnte nicht erfasst werden, wer einige Personen importiert hat. Bitte den Support informieren.',
        'cache-not-cleared': 'Der Import wurde durchgeführt, aber der Cache konnte für einige Personen nicht geleert werden: Ihre Daten können bis zu einer Stunde veraltet erscheinen.',
        'row-write-failed': 'Diese Zeile konnte nicht gespeichert werden; wenn das Problem weiterhin besteht, bitte den Support kontaktieren.',
      },
      col: {
        employeeDeleted: '1 deaktiviert die Person; 0 oder leer lässt sie aktiv. Wird jemand deaktiviert, wird die E-Mail für andere Benutzer frei; wird die Person reaktiviert (0) und ihre E-Mail wird bereits von einem aktiven Benutzer verwendet, wird sie nicht reaktiviert und die Zeile wird gemeldet.',
        localId: 'Personalnummer des Mitarbeiters. Das ist der Schlüssel — ohne ihn kann die Zeile nicht verarbeitet werden.',
        firstName: 'Vorname.',
        lastName: 'Nachname.',
        secondLastName: 'Zweiter Nachname (optional).',
        completeName: 'Vollständiger Anzeigename. Wenn leer, wird er aus den drei vorherigen Feldern gebildet.',
        email: 'E-Mail des Mitarbeiters. Kann leer sein — der Datensatz bleibt in der Liste, bis sich die Person registriert. In AUSTRITTS-Zeilen (EMPLOYEE DELETED = 1) löscht eine leere Zelle die E-Mail der Person (sie hat dann keine E-Mail), und eine neue E-Mail ersetzt sie, sofern kein anderer aktiver Benutzer sie verwendet; in Zeilen ohne Austritt ändert eine leere Zelle nichts.',
        bu: 'Geschäftseinheit.',
        siteId: 'Standort-/Werk-ID.',
        site: 'Standort-/Werksname.',
        orgDirectionId: 'ID der Organisationsdirektion.',
        orgDirection: 'Name der Organisationsdirektion.',
        funcDirectionId: 'ID der Funktionsdirektion.',
        funcDirection: 'Name der Funktionsdirektion.',
        departmentId: 'Abteilungs-ID.',
        department: 'Abteilungsname.',
        jobPosition: 'Position des Mitarbeiters.',
        manager: 'Name des direkten Vorgesetzten (nur informativ).',
        managerId: 'Personalnummer des direkten Vorgesetzten. Verknüpft die Hierarchie; der Vorgesetzte muss bereits in der Liste existieren.',
        managerEmail: 'E-Mail des direkten Vorgesetzten (nur informativ).',
        hireDate: 'Eintrittsdatum, Format MM/dd/jjjj.',
        birthDate: 'Geburtsdatum, Format MM/dd/jjjj.',
        notification: "YES oder NO: ob die Person Benachrichtigungen erhält. Leer bedeutet 'nicht festgelegt', nicht NO.",
        country: 'Land der Person. Optional, aber ohne dieses Feld fällt die Person aus dem Zuständigkeitsbereich der Länderadministratoren.',
      },
    },
    title: 'Verwaltung',
    subtitle: 'Konfigurieren Sie das Anerkennungsprogramm.',
    denied: 'Sie haben keine Berechtigung für diesen Bereich.',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    saved: 'Änderungen gespeichert',
    saveError: 'Die Änderungen konnten nicht gespeichert werden.',
    rowsPerPage: 'Zeilen pro Seite',
    fundPanelTitle: 'Admin Grundprinzipien — Anerkennung',
    fundPanelSubtitle: 'Jedes Modul ist unabhängig. Aktiviere oder deaktiviere es je nach den Anforderungen deiner Organisation.',
    pager: {
      showing: '{{range}} von {{total}} werden angezeigt',
      perPage: '{{size}} pro Seite',
      all: 'Alle',
      prev: 'Vorherige Seite',
      next: 'Nächste Seite',
      pageSize: 'Ergebnisse pro Seite',
    },
    nav: {
      roles: 'Rollen und Berechtigungen konfigurieren',
      points: 'Punkte',
      moderation: 'Moderation',
      winners: 'Gewinner:innen',
      campaigns: 'Kampagnen',
      reports: 'Berichte',
      team: 'Team',
      dashboard: 'Übersicht',
      management: 'Steuerung',
      notifications: 'Benachrichtigungen',
      views: 'Ansichten',
      docs: 'Dokumentation',
      recap: 'Recap',
    },
    roles: {
      title: 'Rollen und Berechtigungen konfigurieren',
      desc: 'Verwalten Sie Administrator:innen, ihren Geltungsbereich nach OU/Land und ihre Berechtigungsmatrix.',
      searchEmail: 'Nach E-Mail suchen…',
      empty: 'Es gibt keine Administrator:innen zum Anzeigen.',
      colAdmin: 'Administrator:in',
      colRole: 'Rolle',
      colScope: 'Geltungsbereich',
      colStatus: 'Status',
      allScopes: 'Alle',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      edit: 'Bearbeiten',
      remove: 'Entfernen',
      removeConfirmTitle: 'Brillamos-Administrator:in entfernen',
      removeConfirmMsg: '"{{name}}" als Brillamos-Administrator:in entfernen? Das Konto bleibt als Standard-Mitarbeiter bestehen.',
      removeConfirm: 'Ja, entfernen',
      removeError: 'Die Administratorrolle konnte nicht entfernt werden. Versuchen Sie es erneut.',
      status: 'Status',
      permMatrix: 'Berechtigungsmatrix',
      readOnlyConflict: '„Nur Lesen“ kann nicht mit Schreibrechten kombiniert werden (RN-R03). Aktuell aktiv: {{permisos}}. Sobald Sie ein Kästchen ändern, wird es aufgelöst; so gespeichert lehnt der Server es ab.',
      addAdmin: 'Administrator:in hinzufügen',
      addTitle: 'Administrator:in hinzufügen',
      editTitle: 'Administrator:in bearbeiten — {{name}}',
      searchPersonLabel: 'Mitarbeiter:in suchen',
      searchPersonPlaceholder: 'Name oder E-Mail der Mitarbeiter:in…',
      alreadyAdminNote: 'Diese Person ist bereits Anerkennung-Administrator:in — bearbeiten Sie ihre Daten unten.',
      cannotEditGlobal: 'Diese Person hat bereits die Rolle Admin Allgemein. Diese Rolle wird nicht von hier aus verwaltet.',
      selectRolePlaceholder: 'Rolle auswählen…',
      selectRoleFirst: 'Wählen Sie eine Rolle, bevor Sie speichern.',
      accountActive: 'Konto aktiv (Zugang zur Plattform)',
      accountActiveHint: 'Das ist das Konto der Person, nicht ihre Administratorrolle. Ausgeschaltet kann sie sich nicht anmelden.',
      deactivateAccountTitle: 'Konto deaktivieren',
      deactivateAccountMsg: '{{name}} kann sich nicht mehr bei der Plattform anmelden. Die Rolle bleibt erhalten: Das Konto wird deaktiviert. Fortfahren?',
      deactivateAccountConfirm: 'Ja, Konto deaktivieren',
      peopleLabel: 'Personen',
      peopleHint: 'Fügen Sie so viele Personen hinzu, wie Sie brauchen: Suchen Sie sie und fügen Sie sie nacheinander hinzu, oder fügen Sie mehrere E-Mail-Adressen getrennt durch Semikolon oder Komma ein. Alle erhalten dieselbe Rolle, denselben Bereich und dieselben Berechtigungen.',
      peopleCount: 'Ausgewählte Personen: {{count}}',
      removeAllPeople: 'Alle entfernen',
      removePerson: '{{name}} entfernen',
      alreadyAdminTag: 'Bereits Administrator',
      alreadyAdminBulkNote: '{{count}} dieser Personen sind bereits Brillamos-Administratoren: Beim Speichern werden ihre Rolle und Berechtigungen durch die unten stehenden ersetzt.',
      globalSkipped: '{{names}} wurde nicht hinzugefügt: Rolle Admin Allgemein, die hier nicht verwaltet wird.',
      resolvingEmails: '{{count}} E-Mail-Adressen werden gesucht…',
      emailsNotFound: 'Zu diesen E-Mail-Adressen wurde niemand gefunden: {{emails}}',
      bulkProgress: '{{done}} von {{total}} werden gespeichert…',
      bulkDone: 'Rolle allen {{count}} Personen zugewiesen.',
      bulkPartial: '{{ok}} von {{total}} zugewiesen. Die fehlgeschlagenen bleiben in der Liste; prüfen Sie den Grund und speichern Sie erneut:',
      saveForPeople: 'Für {{count}} Personen speichern',
      saveForbidden: 'Sie haben keine Berechtigung für diese Änderung.',
      role: {
        AdminGlobal: 'Admin Allgemein',
        AdminBrillamos: 'Admin Anerkennung',
        AdminOUBrillamos: 'Admin OU Anerkennung',

        AdminOU: 'Admin OU Pulse',
      },
    },
    perm: {
      manageUsers: 'Benutzer:innen verwalten',
      manageRecognitions: 'Anerkennungen verwalten',
      manageNotifications: 'Benachrichtigungen verwalten',
      manageDocuments: 'Dokumente verwalten',
      manageWinners: 'Gewinner:innen verwalten',
      viewAnalytics: 'Analytics ansehen',
      viewReports: 'Berichte ansehen',
      exportData: 'Daten exportieren',
      configureViews: 'Ansichten konfigurieren',
      bulkCsv: 'Massenversand (CSV)',
      moderateContent: 'Inhalte moderieren',
      manageCampaigns: 'Kampagnen verwalten',
      createCampaigns: 'Kampagnen erstellen und verwalten',
      readOnly: 'Nur Lesen',
      approveNominations: 'Gewinner:innen bestätigen',
      managePoints: 'Steuerung',
      manageRoles: 'Rollen und Berechtigungen konfigurieren',
      manageBlockedWords: 'Gesperrte Wörter verwalten',
      managePointsConfig: 'Punkte',
      manageRecap: 'Jahres-Recap bearbeiten',
      delegateRecognition: 'Im Namen einer anderen Person anerkennen',
      accessCatalogFundamentals: 'Katalog Fundamentals',
      accessCatalogOus: 'Katalog OUs',
    },
    points: {
      title: 'Punkte',
      desc: 'Punkte pro Kriterium konfigurieren (0-9), gespiegelt für Staff/Frontline. Punkte sind für Mitarbeitende nie sichtbar.',
      empty: 'Keine Punktekriterien konfiguriert.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Aktiv',
      segmentActiveHint: 'Wenn deaktiviert, vergibt diese Tabelle (Staff oder Frontline) keine Punkte, auch wenn Kriterien konfiguriert sind.',
      lockedCampaign: 'Die Konfiguration ist nach Kampagnenstart nicht mehr bearbeitbar.',
      campaignActiveWarning: 'Die Punktekonfiguration kann nicht bearbeitet werden, solange in dieser Organisationseinheit eine Kampagne aktiv ist.',
      colCategory: 'Kategorie',
      colCriterion: 'Kriterium',
      colPoints: 'Punkte',
      colActive: 'Aktiv',
      criterionActiveHint: 'Wenn deaktiviert, vergibt dieses Kriterium keine Punkte, auch wenn es erfüllt ist.',
      colAccumulated: 'Gesamtsumme',
      accumulatedFooter: 'Bewertete Nominierungen',
      resetAccumulated: 'Auf 0 zurücksetzen',
      resetAccumulatedConfirmTitle: 'Kumulierten Gesamtwert zurücksetzen',
      resetAccumulatedConfirmMessage: 'Der Zähler "Kumuliert gesamt" dieser OE und dieses Segments wird auf 0 zurückgesetzt. Der Nominierungsverlauf wird NICHT gelöscht; er wird ab jetzt nur nicht mehr gezählt. Diese Aktion kann nicht rückgängig gemacht werden.',
      resetAccumulatedSuccess: 'Der kumulierte Gesamtwert wurde auf 0 zurückgesetzt.',
      resetAccumulatedError: 'Der kumulierte Gesamtwert konnte nicht zurückgesetzt werden.',
      accumulatedError: 'Die Nominierungszahl konnte nicht geladen werden.',
      accumulatedDisabledHint: 'Bei deaktivierten Punkten bewertet die Engine nicht, daher bleibt die Summe null, auch wenn es Anerkennungen gibt.',
      globalToggle: 'Punkte gelten (global)',
      globalToggleHint: 'Schaltet das Punktesystem für ALLE Organisationseinheiten ein oder aus, unabhängig von der individuellen Konfiguration jeder einzelnen.',
      visibleToEmployees: 'Für Mitarbeitende sichtbar',
      visibleToEmployeesHint: 'Zeigt auf dem Post-it die Punkte jeder Anerkennung dieser OU. Niemals den Gesamtstand einer Person.',
      visibleUnknown: 'Der Zustand des Schalters konnte nicht gelesen werden. Bis dahin ändert sich nichts.',
      visibleGdprBlocked: 'Diese OU unterliegt der DSGVO: Punkte werden auch bei eingeschaltetem Schalter nicht angezeigt.',
      globalOffHint: 'Der globale Schalter ist aus: keine OU vergibt Punkte, auch wenn ihre Tabelle aktiv ist.',
      ouPicker: 'Organisationseinheit',
      ouPickPlaceholder: 'Einheit auswählen…',
      pickOuFirst: 'Wählen Sie eine Organisationseinheit, um ihre Punktekonfiguration zu sehen und zu bearbeiten.',
      accumulatedNoKey: 'Dieses Kriterium hat keinen kanonischen Schlüssel und lässt sich daher nicht zuordnen.',
      globalOverriddenHint: 'Diese Einheit hat eine eigene Ausnahme: hier ist der Schalter {{estado}}, unabhängig vom globalen Wert.',
      globalOn: 'ein',
      globalOff: 'aus',

      globalUnknown: 'Der globale Schalter konnte nicht gelesen werden; sein tatsächlicher Zustand ist unbekannt.',
      noOuInProfile: 'Ihrem Profil ist keine Organisationseinheit zugewiesen, daher gibt es keine Punktekonfiguration. Wenden Sie sich an den globalen Administrator.',
      exportReport: 'Punktebericht herunterladen',
      exporting: 'Wird heruntergeladen…',
      exportError: 'Der Punktebericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      exportEmpty: 'In diesem Bereich gibt es keine Punktezeilen zum Exportieren.',
      exportTruncated: 'Der Bericht wurde bei {{tope}} Zeilen abgeschnitten; grenzen Sie den Bereich ein, um alles zu exportieren.',
      exportNamesUnresolved: 'Einige Namen konnten nicht aufgelöst werden; diese Zeilen enthalten stattdessen die Kennung.',
      exportColPerson: 'Person',
      exportColOu: 'Organisationseinheit',
      exportColPoints: 'Punkte'
    },
    placeholder: {
      soon: 'Dieser Bereich ist bald verfügbar.',
      tracked: 'Nachverfolgung: {{req}}',
    },
    recognitions: {
      title: 'Anerkennungen',
      descLong: 'Verwalten Sie den Katalog der Grundprinzipien/Gewohnheiten: anlegen, bearbeiten, aktivieren/deaktivieren, mit Kampagne und Microsite verknüpfen.',
      tabActive: 'Grundprinzipien',
      tabTrash: 'Papierkorb',
      tabHabits: 'Daily Habits',
      newHabit: 'Neuer Daily Habit',
      habitSearchPlaceholder: 'Habit suchen…',
      habitsEmpty: 'Es gibt keine Daily Habits im Katalog.',
      colColor: 'Farbe',
      colNameEs: 'Name (ES)',
      colNameEn: 'Name (EN)',
      colParent: 'Übergeordnetes Fundament',
      colOuVisibility: 'Sichtbarkeit nach OE',
      ouInherited: 'Vom Fundament geerbt',
      habitStatusAll: 'Alle',
      habitStatusActive: 'Aktiv',
      habitStatusInactive: 'Inaktiv',
      deleteHabitConfirm: 'Diesen Daily Habit aus dem Katalog löschen?',
      newHabitTitle: 'Neuer Daily Habit',
      editHabitTitle: 'Daily Habit bearbeiten',
      new: 'Neues Grundprinzip',
      searchPlaceholder: 'Nach Code oder Name suchen…',
      empty: 'Der Katalog ist leer.',
      colCode: 'Code',
      colName: 'Name',
      colHabits: 'Gewohnheiten',
      colBrillamos: 'Wir strahlen',
      colMicrosite: 'Microsite',
      colStatus: 'Status',
      inBrillamos: 'In Wir strahlen',
      notInBrillamos: 'Außerhalb',
      openMicrosite: 'Öffnen',
      edit: 'Bearbeiten',
      deleteConfirm: 'Dieses Grundprinzip in den Papierkorb verschieben?',
      trashEmpty: 'Der Papierkorb ist leer.',
      newTitle: 'Neues Grundprinzip',
      editTitle: '{{code}} bearbeiten',
      needAllLangs: 'Füllen Sie den Namen in allen 7 Sprachen aus.',
      fieldCode: 'Code',
      fieldOrder: 'Reihenfolge',
      fieldName: 'Name',
      fieldShortName: 'Kurzname',
      fieldColor: 'Farbe',
      fieldMicrosite: 'URL der Microsite',
      fieldCampaignScope: 'Verknüpfte Kampagne',
      campaignScopeHint: 'Kampagnen-Id (leer = globaler Katalog)',
      fieldBrillamos: 'Nimmt an Gemeinsam Strahlen teil',
      legacyCatalogWarning: 'Dieser Katalog ist vorübergehend: Änderungen hier wirken sich noch nicht auf das aus, was Mitarbeitende beim Anerkennen sehen (P2-010).',
    },
    moderation: {
      desc: 'Gesperrte Wörter und Meldungs-Posteingang.',
      title: 'Moderation',
      descLong: 'Meldungs-Posteingang mit Weiterleitung, Katalog gesperrter Wörter und Moderationsschalter.',
      contentTitle: 'Inhaltsmoderation',
      wordsTitle: 'Gesperrte Wörter',
      wordsDesc: 'Sie werden beim Senden einer Anerkennung automatisch erkannt und gesperrt.',
      wordsCounted: 'gesperrte Wörter',
      manageWords: 'Verwalten',
      wordsManagerDesc: 'Wörter je Sprache hinzufügen, bearbeiten oder löschen. Geeignet für mehr als 100 Wörter.',
      newWord: 'Neues Wort',
      region: 'Land/Region',
      regionGlobal: 'Global (alle)',
      regionHint: 'Dieselbe Sprache kann je nach Land oder Region unterschiedliche Wörter haben.',
      allRegions: 'Alle Regionen',
      searchWord: 'Suchen…',
      editWord: 'Wort bearbeiten',
      word: 'Wort',
      wordPlaceholder: 'z. B. unangemessen…',
      language: 'Sprache',
      addWord: 'Hinzufügen',
      wordsEmpty: 'Keine Wörter entsprechen dem Filter.',
      langOther: 'Sonstige',
      // RF-082 — Tabelle Land→Sprachen, die bestimmt, welcher Katalog fuer wen gilt.
      countryLanguagesTitle: 'Länder und Sprachen',
      countryLanguagesDesc: 'Legen Sie fest, welche Sprachen in jedem Land gesprochen werden. Ein mehrsprachiges Land (Belgien: nl und fr) wendet die Wörter aller seiner Sprachen an, ohne sie doppelt zu erfassen. Länder in ISO-3166 (MX, ES, BE) und Sprachen aus den 7 der Plattform (es, en, pt, fr, de, nl, ro). Um ein Wort auf ein bestimmtes Land zu begrenzen, nutzen Sie dessen Feld Land/Region.',
      countryLanguagesEmpty: 'Die Tabelle der Länder und Sprachen ist leer.',
      regionsTitle: 'Regionen',
      regionMembers: 'Länder darin',
      countryLanguagesInvalid: 'Prüfen Sie diese Codes vor dem Speichern: {{codes}}. Das Land steht als 2-stelliger ISO-Code (MX), und die Sprache muss eine der 7 der Plattform sein (es, en, pt, fr, de, nl, ro), ohne Ländervariante.',
      countryLanguagesUnreadable: 'Die Tabelle konnte nicht gelesen werden und lässt sich daher nicht speichern: Beim Speichern wird sie vollständig ersetzt und alles nicht Angezeigte ginge verloren.',
      country: 'Land',
      languages: 'Sprachen',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Land hinzufügen',
      countryPlaceholder: 'MX',
      autoTitle: 'Einstellungen der Auto-Moderation',
      aiAutoBlock: 'Automatische KI-Sperre',
      aiAutoBlockHint: 'Wenn aktiviert, wird jede Anerkennungsnachricht beim Senden per KI (Azure AI Content Safety) geprüft und blockiert, falls sie beleidigend ist.',
      helpAria: 'Hilfe',
      aiHelp: 'Prüft jede Nachricht beim Senden per KI (Azure AI Content Safety) und erkennt Toxizität im Kontext (Hass, Drohungen, Belästigung). Ergänzt den Katalog gesperrter Wörter: beide können gleichzeitig aktiv sein. Erfordert, dass „Moderation aktiv (global)" eingeschaltet ist; ist der globale Schalter aus, greift diese Ebene nicht.',
      globalHelp: 'Hauptschalter der Moderation. Ist er aus, wird NICHTS moderiert: weder die KI-Sperre noch der Katalog gesperrter Wörter, und es werden keine Meldungen angenommen. Schalten Sie ihn ein, damit die anderen Ebenen funktionieren.',
      wordsHelp: 'Sperrt exakte Wörter beim Senden, unabhängig vom Kontext. Ergänzt die KI-Sperre (die Toxizität im Kontext erkennt). Beide Ebenen erfordern, dass „Moderation aktiv (global)" eingeschaltet ist.',
      hideThreshold: 'Meldungsschwelle zum Ausblenden',
      notifyReporter: 'Meldende Person benachrichtigen',
      aiPendingNote: 'Bei aktivierter automatischer KI-Sperre werden Anerkennungsnachrichten beim Senden von Azure AI Content Safety geprüft und abgelehnt, wenn sie gegen die Verhaltensregeln verstoßen. Sie ergänzt den Katalog gesperrter Wörter.',
      hideThresholdHint: 'Wie viele Meldungen nötig sind, um eine Anerkennung automatisch auszublenden. Der Wert 1 entspricht der geltenden Regel: Ausblenden bereits bei der ersten Meldung.',
      notifyReporterHint: 'Speichert die Einstellung und übermittelt sie mit dem Moderationsereignis. Die E-Mail an die meldende Person versendet NotificationService, sobald diese Benachrichtigung existiert.',
      advanced: 'Erweiterte Einstellungen',
      globalEnabled: 'Moderation aktiv (global)',
      reportEnabledGlobal: 'Melden standardmäßig aktiviert',
      dailyReportLimit: 'Tägliches Meldungslimit',
      // RF-084 — Ausnahmen fuer "Melden erlauben" je Knoten, Kaskade Site -> BU -> OU -> global.
      overridesTitle: 'Melden nach Einheit (Kaskade)',
      overridesDesc: 'Ausnahmen vom globalen Wert. Es gilt der spezifischste Knoten: Site, dann BU, dann OU und deren übergeordnete Einheiten. Eine Einheit ohne Ausnahme erbt die der übergeordneten Einheit.',
      overridesNode: 'Einheit, BU oder Site',
      overridesNodePlaceholder: 'OU auswählen oder BU-/Site-ID eingeben',
      overridesAllow: 'Erlaubt',
      overridesBlock: 'Gesperrt',
      overridesEmpty: 'Keine Ausnahmen: alle Einheiten verwenden den globalen Wert.',
      overridesDuplicate: 'Für „{{node}}“ existiert bereits eine Ausnahme. Bezeichner unterscheiden nicht zwischen Groß- und Kleinschreibung: bearbeite oder entferne die vorhandene.',
      inboxTitle: 'Meldungs-Posteingang',
      inboxDesc: 'Meldungen von Nutzenden. Beim Ausblenden verschwindet die Anerkennung von der Pinnwand der empfangenden Person und aus den gesendeten Anerkennungen der sendenden Person; sie wird außerdem aus dem Medaillenspiegel entfernt und ihre Punkte werden storniert.',
      searchName: 'Nach Namen suchen…',
      filterAll: 'Alle',
      filterOu: 'OU: Alle',
      filterBu: 'BU: Alle',
      filterSite: 'Standort: Alle',
      filterFrom: 'Von',
      filterTo: 'Bis',
      filterType: 'Typ: Alle',
      type: { fundamentales: 'Grundprinzipien', brillamos: 'Gemeinsam Strahlen', diario: 'Tägliche Anerkennung' },
      uiStatus: { pendiente: 'Ausstehend', restaurado: 'Wiederhergestellt', eliminado: 'Gelöscht' },
      uiStatusPlural: { pendiente: 'Ausstehende', restaurado: 'Wiederhergestellte', eliminado: 'Gelöschte' },
      status: { Publicado: 'Veröffentlicht', Pendiente: 'Ausstehend', Resuelto: 'Gelöst', Desestimado: 'Abgewiesen' },
      reportsEmpty: 'Keine Meldungen entsprechen dem Filter.',
      colReportedBy: 'Gemeldet von',
      colRecognitionFrom: 'Anerkennung von',
      colTo: 'Für',
      colDetail: 'Detail',
      colReason: 'Grund',
      colDate: 'Datum',
      colStatus: 'Status',
      colActions: 'Aktionen',
      // RF-090 — Umschlag-Schaltflaeche: eskaliert den Fall an den OU-/Landes-Admin, ohne Wartezeit.
      notifyAdmin: 'Admin benachrichtigen',
      notifyAdminHint: 'Sendet sofort einen Hinweis an die Administration der Einheit dieser Anerkennung, ohne auf den Wochenbericht zu warten.',
      notifyAdminConfirm: 'Einen Hinweis an die Administration der Einheit von {{name}} senden? Die E-Mail geht sofort raus.',
      notifyAdminSent: 'Hinweis an die Administration gesendet.',
      notifyAdminError: 'Der Hinweis an die Administration konnte nicht gesendet werden.',
      // RF-090 — Vorschau der Empfänger: Die Umschlag-Schaltfläche meldete „gesendet“, auch wenn niemand es erhielt.
      notifyPreviewTitle: 'Dieser Hinweis erreicht:',
      notifyPreviewLoading: 'Empfänger werden ermittelt…',
      notifyPreviewEmpty: 'Es konnte kein Empfänger ermittelt werden.',
      notifyPreviewError: 'Es konnte nicht geprüft werden, wen der Hinweis erreichen würde.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Für diese Einheit ist keine Administration hinterlegt, und es gibt keine globale Administration, an die der Fall eskaliert werden könnte.',
        'escalado-a-globales': 'Die Einheit hat keine eigene Administration: Der Fall wird an die globale Administration eskaliert.',
        'admin-sin-correo': 'Für die Administration ist im Verzeichnis keine nutzbare E-Mail-Adresse hinterlegt, daher lässt sich niemand anschreiben.',
        'directorio-no-responde': 'Das Benutzerverzeichnis hat nicht geantwortet: Es lässt sich nicht feststellen, wer benachrichtigt werden müsste.',
        'suprimido-por-allowlist': 'Der Versand würde verworfen: Diese Adresse steht nicht auf der Liste zugelassener Empfänger des Benachrichtigungsdienstes.',
        'allowlist-desconocida': 'Die Liste zugelassener Empfänger konnte nicht geprüft werden; der Versand könnte spurlos verworfen werden.',
        desconocido: 'Der Hinweis kann aus einem Grund nicht gesendet werden, den der Dienst nicht erklären konnte.',
      },
      deleteLabel: 'Löschen',
      hideHint: 'Blendet die Anerkennung von der Pinnwand aus, entfernt sie aus dem Medaillenspiegel und storniert ihre Punkte.',
      restore: 'Wiederherstellen',
      reopen: 'Wieder öffnen',
      reopenHint: 'Stellt den Fall als Offen zurück in die Warteschlange und blendet die Anerkennung wieder aus.',
      viewDetail: 'Details ansehen',
      detailTitle: 'Details der Meldung',
      whoReported: 'Wer gemeldet hat',
      whoWasReported: 'Wer gemeldet wurde',
      reportedRecognition: 'Gemeldete Anerkennung',
      messageUnavailable: 'Text nicht verfügbar.',
      // RF-087 — Weiterleitung des Falls: E-Mail und OU werden immer gezeigt, mit Platzhalter wenn sie fehlen.
      dataUnavailable: 'Nicht verfügbar',
      detailLoading: 'Wird geladen…',
      detailError: 'Die aktuellen Kontaktdaten konnten nicht geladen werden; angezeigt werden die zum Zeitpunkt der Meldung gespeicherten.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
      colCampaign: 'Kampagne',
      filterCampaign: 'Kampagne: Alle',
    },
    winners: {
      // Task 2.5 — Kartenraster für Kampagnen-Abzeichen in Gewinner (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Kampagnen-Abzeichen',
        permanenceNote: 'Diese Abzeichen sind dauerhaft: Sie werden nicht wie Serien-Abzeichen aktiviert oder deaktiviert, sondern bleiben an die Kampagne und das Jahr gebunden, für das sie vergeben wurden.',
        empty: 'Noch keine Kampagnen-Abzeichen vorhanden.',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        deleteConfirm: 'Kampagnen-Abzeichen „{{name}}“ löschen? Name in allen 7 Sprachen, Symbol und Jahr gehen verloren. Dies kann nicht rückgängig gemacht werden.',
        add: '+ Abzeichen hinzufügen',
        editTitle: 'Kampagnen-Abzeichen bearbeiten',
        fieldTitle: 'Titel',
        fieldYearSubtitle: 'Jahr / Untertitel',
        fieldYear: 'Jahr der Auszeichnung',
        yearNone: 'Ohne Jahr',
        fieldYearHint: 'Wird bei der Vergabe geprüft: Ein Abzeichen aus einem Jahr kann nicht in einer Kampagne eines anderen Jahres vergeben werden. "Ohne Jahr" deaktiviert die Prüfung.',
        fieldImage: 'Bild',
        imageUploadHintNew: 'Speichern Sie das Abzeichen zuerst, um sein Bild hochladen zu können.',
        imageFormatInvalid: 'Das Bildformat ist ungültig. Verwenden Sie PNG, JPG, WEBP oder SVG.',
        previewTitle: 'Vorschau',
      },
      bulkTitle: 'Sammelbestätigung',
      bulkSelected: '{{count}} ausgewählt',
      bulkConfirm: '{{count}} bestätigen',
      bulkConfirming: 'Wird bestätigt…',
      bulkClear: 'Auswahl aufheben',
      bulkSelectAll: 'Alle offenen dieser Seite auswählen',
      bulkSelectOne: '{{name}} auswählen',
      bulkFailed: '{{count}} konnten nicht bestätigt werden. Die übrigen schon; versuche es nur mit diesen erneut.',
      editTitle: 'Gewinner bearbeiten — {{nombre}}',
      actionError: 'Die Aktion konnte nicht abgeschlossen werden.',
      badExtension: 'Format nicht unterstützt. Zulässig: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Position',
      colDepto: 'Abteilung',
      colFundamental: 'Fundamental',
      colStatus: 'Status',
      colUser: 'Nutzer',
      colUserNomina: 'Personalnummer: {{nomina}}',
      colSite: "Site",
      colEmail: "E-Mail",
      exportSheetName: "Gewinner",
      exportTitle: "Gewinner",
      exportSubtitle: "Erfasste Gewinner mit den angewendeten Filtern",
      colYear: 'Jahr',
      colBadge: 'Abzeichen',
      badgeNone: 'Kein Abzeichen',
      exportFiltered: 'Die Gewinner der aktuellen Filter als Excel herunterladen',
      exportEmpty: 'Mit diesen Filtern gibt es keine Gewinner zum Exportieren',
      exporting: 'Wird exportiert…',
      exportError: 'Der Download konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      confirmAction: 'Als Gewinner bestätigen',
      confirmDelete1: '{{nombre}} aus der Gewinnerliste entfernen?',
      confirmDelete2: 'Das lässt sich nicht rückgängig machen und wird protokolliert. Bestätigen?',
      deleteTitle: 'Gewinner entfernen',
      deleteConfirm: 'Entfernen',
      countryAll: 'Land: Alle',
      editAction: 'Bearbeiten',
      editClosed: 'Außerhalb des Bearbeitungszeitraums.',
      editWindowNote: 'Sie können einen Gewinner bis zu 1 Monat nach dem Hochladen bearbeiten. Der General-Admin kann jeden Gewinner der letzten 3 Jahre bearbeiten.',
      exportNominations: 'Nominierungen exportieren',
      exportWinners: 'Gewinner exportieren',
      exportNominationsEmpty: 'Für diese Kampagne gibt es keine Nominierungen zum Exportieren.',
      exportPending: 'Der Export wird im nächsten Paket angebunden.',
      filterCountry: 'Land',
      filterFundamental: 'Fundamental',
      filterYear: 'Jahr',
      filtersToggle: 'Filter',
      flowHint: 'Gewinner werden per Datei hochgeladen. Ablauf: Vorlage hochladen → erscheint hier → als endgültigen Gewinner bestätigen.',
      fundamentalAll: 'Fundamental: Alle',
      fundamentalNone: 'Kein Fundamental',
      importErrorsTitle: 'Abgelehnte Zeilen',
      importSummary: '{{importados}} von {{total}} Zeilen importiert · {{rechazados}} abgelehnt.',
      manageTitle: 'Gewinnerverwaltung',
      moduleHint: 'Aktivieren, um das Hochladen von Gewinnern und die Vergabe von Abzeichen zu ermöglichen.',
      moduleOffWarn: 'Gewinner-Modul deaktiviert. Diese Einstellung wird vorerst nur gespeichert und ändert noch nichts für die Nutzer.',
      moduleSaveError: 'Die Änderung am Gewinner-Modul konnte nicht gespeichert werden. Bitte erneut versuchen.',
      moduleTitle: 'Gewinner-Modul',
      needsCsv: 'Dies ist eine binäre Excel-Mappe und kann nicht gelesen werden. Öffnen und als CSV (UTF-8) speichern, dann erneut hochladen.',
      noResults: 'Keine Gewinner entsprechen dem Filter.',
      ouAll: 'OU: Alle',
      pagerInfo: 'Seite {{page}} von {{paginas}} · {{total}} Gewinner',
      searchByName: 'Nach Namen suchen…',
      statusConfirmed: '✓ Bestätigt',
      statusPending: '⏳ Ausstehend',
      uploadFile: 'Excel hochladen',
      uploadCampaign: 'Kampagne der Liste',
      uploadMode: 'Ausgabe der Liste',
      uploadModeCurrent: 'Aktuell',
      uploadModeHistoric: 'Historisch',
      uploadOpen: 'Liste hochladen',
      uploadOpenHint: 'Öffnet den Assistenten zum Hochladen der Gewinnerliste, aktuell oder historisch.',
      uploadModalTitle: 'Gewinnerliste hochladen',
      uploadModalToggleHint: 'Wählen Sie „Aktuell“, wenn die Liste zu einer Kampagne gehört, die auf der Website aktiv ist. Wählen Sie „Historisch“, um Auszeichnungen aus früheren Jahren hochzuladen, die nicht als Kampagne dokumentiert sind.',
      uploadBadge: 'Abzeichen',
      uploadBadgeHint: 'Jede Zeile der Datei erhält DIESES Abzeichen. Wähle es aus, bevor du die Datei hochlädst.',
      uploadBadgePick: 'Abzeichen auswählen…',
      uploadBadgeClarify: 'Das Abzeichen ist keine Kampagne: Es ist das Bild, das die Person als gewonnene Auszeichnung sieht (zum Beispiel eine Medaille oder eine Trophäe).',
      pickBadgeFirst: 'Wählen Sie zuerst das Abzeichen aus, das die Gewinner dieser Datei erhalten sollen.',
      uploadHistoricWarning: 'Historische Daten werden direkt gespeichert, ohne Verknüpfung zu einer Kampagne. Prüfen Sie Name, E-Mail und Abzeichen, bevor Sie hochladen.',
      helpOpen: 'Hilfe zum Hochladen der Liste',
      helpModalTitle: 'Wie lade ich die Gewinnerliste hoch?',
      helpIntroVigente: 'Aktuell: Verwenden Sie diesen Modus, wenn die Auszeichnung zu einer Kampagne gehört, die auf der Website existiert und gerade aktiv ist. Sie wählen die Kampagne und das Abzeichen (das Bild, das als gewonnene Auszeichnung angezeigt wird) aus und laden die Vorlage herunter: Sie fragt nur nach der E-Mail-Adresse oder Personalnummer der Person. Name, Jahr und OE/Standort kennt das System bereits — die müssen Sie nicht eintragen.',
      helpIntroHistorico: 'Historisch: Verwenden Sie diesen Modus, wenn die Auszeichnung aus einer alten Kampagne stammt, die es auf der Website nicht mehr gibt, oder von der Sie keine Aufzeichnung haben. Sie wählen KEINE Kampagne aus: Stattdessen wählen Sie EIN Abzeichen aus (das Bild, das als gewonnene Auszeichnung angezeigt wird, kein Kampagnenname), das JEDER Person in der Datei vergeben wird. Laden Sie die Vorlage mit 2 Spalten (Name und E-Mail oder Personalnummer) herunter, füllen Sie sie aus und laden Sie sie hoch.',
      helpDirectorio: 'Die E-Mail-Adresse oder die Personalnummer muss im Firmenverzeichnis eingetragen sein. Wird keines von beiden gefunden, wird nur diese Zeile abgelehnt, der Rest der Datei wird trotzdem geladen. Hat die Person keine E-Mail-Adresse (zum Beispiel Werkspersonal), tragen Sie die Personalnummer in dieselbe Spalte ein — die E-Mail-Adresse ist dann nicht nötig.',
      helpNoDownload: 'Wenn Sie versuchen, eine Datei herunterzuladen, und es keine Daten zum Anzeigen gibt, wird nichts heruntergeladen: Sie erhalten stattdessen eine Meldung auf dem Bildschirm.',
      downloadTemplateHint: 'Laden Sie eine leere Excel-Datei mit den passenden Spalten für diesen Modus in Ihrer Sprache herunter.',
      downloadTemplateCurrent: 'Aktuelle Vorlage herunterladen',
      downloadTemplateHistoric: 'Historische Vorlage herunterladen',
      uploadFileHint: 'Laden Sie die ausgefüllte Excel-Datei mit den Daten der Liste hoch.',
      importWizard: {
        subtitle: 'Liste hochladen, Ergebnis vor dem Bestätigen prüfen und Fehler herunterladen, falls etwas schiefgeht.',
        colNombreDesc: 'Name des Gewinners, so wie er angezeigt wird.',
        colNombreDescVigente: 'Name des Gewinners. Du kannst das Feld leer lassen: Wenn du nichts einträgst, wird der Name verwendet, der für diese Person bereits gespeichert ist.',
        colEmailDesc: 'E-Mail ODER Personalnummer der Person — eines der beiden reicht; identifiziert, wer den Preis erhält.',
        colFundamentalDesc: 'Nominierter Grundsatz (Name in beliebiger Sprache oder Katalogcode). Wird ignoriert, wenn er mit keinem übereinstimmt.',
        badgePreviewHint: 'So sieht das Abzeichen aus — genau das, was jeder Gewinner dieser Datei erhalten wird.',
        dropHint: 'Ziehe deine Excel- oder CSV-Datei hierher, oder klicke, um sie auszuwählen.',
        reviewHint: 'Dies ist nur eine VALIDIERUNG: Es wird noch nichts gespeichert. Prüfe die Zusammenfassung und gehe bei Bedarf zurück, um eine korrigierte Datei zu wählen.',
        previewPending: 'Datei wird validiert…',
        noErrors: 'Keine Fehler — alle Zeilen sind gültig.',
        fileLevelError: 'Datei/Auswahl',
        confirmPending: 'Wird gespeichert…',
      },
      filterEstado: 'Status',
      estadoAll: 'Status: Alle',
      uploadCampaignPick: 'Kampagne auswählen…',
      pickCampaignFirst: 'Wählen Sie zuerst die Kampagne aus, zu der die Liste gehört.',
      exportNominationsCatalogError: 'Der Katalog der Grundwerte und täglichen Verhaltensweisen konnte nicht geladen werden: Der Export könnte unvollständig sein. Bitte versuche es erneut.',
      yearAll: 'Jahr: Alle',
      desc: 'Register der Gewinner:innen von Gemeinsam Strahlen.',
      title: 'Gewinner:innen',
      descLong: 'Gewinner:innen nach Kampagne/OU. Manuelle Anlage und CSV-Import der Historie mit Rückmeldung je Zeile.',
      filterCampaign: 'Kampagne',
      campaignIdHint: 'Kampagnen-Id',
      filterOu: 'OU',
      ouHint: 'OU-Id',
      add: 'Gewinner:in hinzufügen',
      addTitle: 'Neue:r Gewinner:in',
      fieldCampaign: 'Kampagne',
      fieldUser: 'Benutzer:in',
      fieldName: 'Name',
      fieldOuName: 'OU',
      fieldCountry: 'Land',
      fieldPosition: 'Platzierung',
      save: 'Speichern',
      importTitle: 'CSV-Import',
      importHint: 'Laden Sie die Vorlage herunter, füllen Sie sie aus und laden Sie sie hoch. Der Import ist idempotent pro Kampagne + Benutzer:in.',
      downloadTemplate: 'Vorlage herunterladen',
      uploadCsv: 'CSV hochladen',
      templateError: 'Die Vorlage konnte nicht heruntergeladen werden.',
      importError: 'Der Import konnte nicht verarbeitet werden.',
      deleteError: 'Dieser Gewinner konnte nicht entfernt werden.',
      totalRows: 'Zeilen gesamt',
      imported: 'Importiert',
      rejected: 'Abgelehnt',
      row: 'Zeile',
      reason: 'Grund',
      empty: 'Für diese Filter gibt es keine Gewinner:innen.',
      colPosition: 'Platzierung',
      colName: 'Name',
      colOu: 'OU',
      colCountry: 'Land',
      colCrossed: 'Gekreuzter Ursprung',
      colDate: 'Registriert',
      // Task 16 — Spaltenüberschriften des rohen Nominierungs-Exports (i18n, kein festes Spanisch mehr).
      nominationsExport: {
        // Die `nominee*`-Schlüssel enthalten die Person, die NOMINIERT HAT (der Block Nominee_* des
        // DTOs stammt aus Recognition.EmisorSnapshot). Die nominierte Person steht im Block
        // `candidate*` weiter unten.
        nomineeName: 'Nominierender: Name',
        nomineeEmail: 'Nominierender: E-Mail',
        nomineeEmployeeId: 'Nominierender: Personalnr.',
        nomineeOu: 'Nominierender: OU',
        nomineeBu: 'Nominierender: BU',
        nomineeSite: 'Nominierender: Site',
        nomineeDepartment: 'Nominierender: Position',
        onBehalfOfName: 'Im Namen von: Name',
        onBehalfOfEmail: 'Im Namen von: E-Mail',
        onBehalfOfEmployeeId: 'Im Namen von: Personalnr.',
        onBehalfOfOu: 'Im Namen von: OU',
        onBehalfOfBu: 'Im Namen von: BU',
        onBehalfOfSite: 'Im Namen von: Site',
        onBehalfOfDepartment: 'Im Namen von: Position',
        candidateName: 'Kandidat: Name',
        candidateEmail: 'Kandidat: E-Mail',
        candidateEmployeeId: 'Kandidat: Personalnr.',
        candidateOu: 'Kandidat: OU',
        candidateBu: 'Kandidat: BU',
        candidateSite: 'Kandidat: Site',
        candidateDepartment: 'Kandidat: Position',
        date: 'Datum',
        year: 'Jahr',
        month: 'Monat',
        habitPrefix: 'Gewohnheit',
        comment: 'Kommentar',
        streakBadge: 'Serienabzeichen',
        fromDayToDay: 'Kommt aus dem Alltag',
        status: 'Status',
        type: 'Typ',
        audienceNominee: 'Zielgruppe des Nominierenden',
        audienceCandidate: 'Zielgruppe des Kandidaten',
        points: 'Punkte',
        retiredHabitsGroup: 'Sonstige / entfernte Verhaltensweisen',
      },
    },
    campaigns: {
      desc: 'Assistent für Anerkennungskampagnen.',
      statusDivider: 'Kampagnenstatus',
      title: 'Kampagnen',
      descLong: 'Liste der Kampagnen und Assistent in 5 Schritten: Info, Zielgruppe, Konfiguration, Dokumente und Veröffentlichung.',
      filterAll: 'Alle',
      status: {
        Borrador: 'Entwurf', Activa: 'Aktiv', Finalizada: 'Beendet', PendienteAprobacion: 'Genehmigung ausstehend',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Aktiv · außerhalb des Zeitraums',
        ActivaPorIniciar: 'Aktiv · noch nicht gestartet',
        // ADR 0014 — estado visible de la pestaña Brillamos (Activa con inicio futuro).
        PorIniciar: 'Noch nicht gestartet',
        ActivaVencidaHint: 'Die Kampagne ist weiterhin als aktiv markiert, ihr Zeitraum ist jedoch abgelaufen: Mitarbeitende im Geltungsbereich sehen sie nicht.',
        ActivaPorIniciarHint: 'Die Kampagne ist aktiv, aber ihr Startdatum ist noch nicht erreicht.',
      },
      approvals: 'Genehmigungen',
      new: 'Neue Kampagne',
      empty: 'Es gibt keine Kampagnen.',
      colName: 'Name',
      colType: 'Typ',
      colStatus: 'Status',
      colScope: 'Geltungsbereich',
      allScopes: 'Alle OUs',
      editBtn: 'Bearbeiten',
      duplicate: 'Duplizieren',
      panic: 'Kampagne stoppen',
      deactivateConfirmTitle: 'OU-Ausnahme stoppen',
      deactivateConfirmMsg: 'Diese OU-Ausnahme jetzt stoppen? Sie gilt danach sofort nicht mehr für ihren Bereich.',
      panicConfirm: 'Diese Kampagne sofort stoppen?',
      type: { Fundamentales: 'Grundprinzipien', Brillamos: 'Wir strahlen', Personalizada: 'Individuell' },
      wizardEditTitle: 'Kampagne bearbeiten',
      wizardNewTitle: 'Neue Kampagne',
      wizardSub: 'Führen Sie die 6 Schritte aus, um die Kampagne zu erstellen oder zu bearbeiten.',
      backToList: 'Zurück zur Liste',
      step: { info: 'Info', design: 'Design', audience: 'Zielgruppe', config: 'Konfiguration', documents: 'Dokumente', publish: 'Veröffentlichen' },
      tabFundamentales: 'Fundamentals',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Individuell',
      fundActiveTitle: 'Immer aktiv',
      fundRules: 'Sende-Regeln',
      fundActiveDesc: 'Fundamentals ist die Basis des Anerkennungsprogramms. Es kann nicht deaktiviert, nur seine Regeln konfiguriert werden.',
      fundConfigNote: 'Detaillierte Sende-Regeln und Limits werden im Bereich Verwaltung verwaltet.',
      globalPanic: 'Alle Kampagnen stoppen',
      globalPanicConfirm: 'Alle aktiven Shine-Together-Kampagnen sofort beenden? Diese Aktion kann nicht rückgängig gemacht werden.',
      globalPanicDone: '{{count}} Kampagne(n) beendet.',
      docCategoria: 'Kategorie',
      docCatNone: 'Keine Kategorie',
      fieldType: 'Kampagnentyp',
      fieldName: 'Name',
      fieldDescription: 'Beschreibung',
      fieldSlug: 'Slug der Landingpage',
      fieldScope: 'Geltungsbereich (OUs)',
      fieldExclusions: 'Ausschlüsse',
      fieldStart: 'Startdatum',
      fieldEnd: 'Enddatum',
      fieldTimezone: 'Zeitzone',
      fieldStreakMinimum: 'Serien-Minimum der Kampagne',
      streakMinimumInherit: 'Globalen Wert verwenden',
      streakMinimumHint: 'Sendungen, die diese Kampagne im Zeitraum für die Serie verlangt (1-20). Leer = es gilt das globale Minimum aus der Verwaltung.',
      streakMinimumLocked: 'Die Kampagne läuft bereits: Das Serien-Minimum kann sich nicht ändern, ohne den laufenden Zeitraum neu zu bewerten.',
      fieldRecognitionsLimitOwn: 'Sende-Limit der Kampagne',
      recognitionsLimitOwnInherit: 'Globalen Wert verwenden',
      recognitionsLimitNotApplicable: 'Nicht zutreffend (kein Sende-Limit)',
      recognitionsLimitNotApplicableShort: 'Kein Limit',
      fieldSameFundamentalLimit: 'Mal gleiches Fundamental an dieselbe Person',
      sameFundamentalInherit: 'Globalen Wert verwenden',
      sameFundamentalNotApplicable: 'Nicht zutreffend (kein Limit)',
      sameFundamentalNotApplicableShort: 'Kein Limit',
      recognitionsLimitOwnHint: 'Anerkennungen, die diese Kampagne pro Zeitraum erlaubt. Leer = das globale Gestión-Limit gilt. Jederzeit änderbar, auch wenn die Kampagne bereits aktiv ist.',
      visibility: 'Sichtbarkeit',
      postSendTitle: 'Bearbeitung und Anti-Spoiler',
      visSender: 'Absender anzeigen',
      visFundamental: 'Grundprinzip anzeigen',
      visText: 'Text anzeigen',
      visHabit: 'Gewohnheit anzeigen',
      visSent: 'Zähler der gesendeten',
      visReceived: 'Zähler der erhaltenen',
      visAnonymous: 'Anonyme zulassen',
      visBulk: 'CSV-Massenimport',
      visReactions: 'Reaktionen (👏❤️😊🎉👍)',
      visCampaignTag: 'Kampagnen-Label anzeigen',
      visFromFundamentals: 'Senden aus den Fundamentals erlauben',
      visSendingDisabled: 'Versand von Anerkennungen deaktivieren',
      anonymousOverrideLabel: 'Anonyme Anerkennungen',
      anonymousOverrideInherit: 'Von Gestión übernehmen',
      anonymousOverrideAllow: 'Erlauben',
      anonymousOverrideDeny: 'Nicht erlauben',
      anonymousOverrideHint: 'Gilt NUR für diese Kampagne. Bei "Von Gestión übernehmen" verwendet diese Kampagne die globale Einstellung.',
      points: 'Punkte',
      pointsLocked: 'Die Punkte sind unveränderlich: die Kampagne ist bereits gestartet.',
      pointsHint: 'Nur Europa; das Frontend zeigt die Punkte nie an.',
      applyPoints: 'Die Kampagne vergibt Punkte',
      brillamosRecurringDesc: 'Wiederkehrende Nominierungskampagne auf Basis der Fundamentals.',
      paisScheduleTitle: 'Zeiten und Daten nach Land',
      paisScheduleIntro: 'Konfiguriere unterschiedliche Zeiten oder Daten pro Land. Ohne Angabe gilt das globale Fenster.',
      paisScheduleInfoIntro: "Zeigt die aktuellen Daten und Zeiten der aktiven Kampagnen jeder OU, damit klar ist, wann OU-übergreifende Anerkennung möglich ist. Nur zur Information.",
      paisStateOn: "Aktiv",
      paisStateOff: "Gestoppt",
      paisStateNoCampaign: "Keine Kampagne",
      paisCol: 'Land',
      paisOpen: 'Öffnungszeit',
      paisClose: 'Schließzeit',
      paisActive: 'Aktiv',
      paisClearHours: 'Zeitfenster leeren',
      paisOverrideBadge: 'OE-Kampagne',
      paisOverrideWins: 'Hat Vorrang vor dieser Zeile: {{alcance}}.',
      paisOverrideNoSend: 'Versand deaktiviert',
      paisOverrideDates: 'Daten {{inicio}} → {{fin}}',
      paisOverrideHours: 'Uhrzeit {{inicio}}–{{fin}}',
      paisScheduleNoActive: "Es gibt keine aktive Brillamos-Juntos-Kampagne: Sobald es eine gibt, erscheinen hier ihre Daten und Zeiten pro Land.",
      saveDraftFirst: 'Speichern Sie den Entwurf, um seine Dokumente zu verwalten.',
      saveDraft: 'Entwurf speichern',
      saveDraftLater: 'Der Entwurf wird gespeichert, sobald die Konfiguration abgeschlossen ist. Nutzen Sie „Weiter“, um durch die Schritte zu gehen.',
      dates: 'Daten',
      publishRequirements: 'Erfordert einen Namen in allen 7 Sprachen, mindestens eine OU im Geltungsbereich sowie Start- und Enddatum. Speichern wird aktiv, sobald die Konfiguration vollständig ist.',
      valNameAllLangs: 'Geben Sie den Namen in allen 7 Sprachen ein.',
      valScope: 'Wählen Sie mindestens eine Organisationseinheit im Geltungsbereich aus.',
      scopeConflict: "Diese Einheiten sind bereits in einer aktiven Kampagne: {{campanas}}. Entfernen Sie sie aus dem Geltungsbereich oder beenden Sie diese Kampagne.",
      valScopeConflict: "Der Geltungsbereich steht im Konflikt mit einer aktiven Kampagne: {{campanas}}.",
      scopeConflictPartial: "Es gibt mehr aktive Kampagnen als überprüft werden konnten: die Konfliktprüfung kann unvollständig sein.",
      scopeEmpty: "Sie haben keine Organisationseinheiten in Ihrem Bereich, um Kampagnen zu erstellen. Bitten Sie einen globalen Administrator, Ihnen einen Bereich zuzuweisen.",
      outOfScopeHint: "Diese Kampagne umfasst Organisationseinheiten außerhalb Ihres Bereichs: Nur ein Administrator, der alle abdeckt, kann sie bearbeiten.",
      valScopeExcludesOwn: "Sie können Ihre eigene Organisationseinheit nicht aus dem Geltungsbereich ausschließen.",
      valStart: 'Geben Sie das Startdatum der Kampagne ein.',
      valEnd: 'Geben Sie das Enddatum der Kampagne ein.',
      valTimezone: 'Wählen Sie die Zeitzone der Kampagne aus.',
      valDateOrder: 'Das Enddatum muss nach dem Startdatum liegen.',
      valPastDate: "Die Kampagnendaten dürfen nicht vor dem heutigen Tag liegen.",
      designMenu: 'Symbol und Titel im Seitenmenü',
      designMenuHint: 'So erscheint die Kampagne in der Seitenleiste der Plattform für die Nutzer.',
      designIcon: 'Symbol',
      designMenuTitle: 'Menütitel',
      designMenuTitlePh: 'z. B. LATAM Innovation',
      designSections: 'Landing-Abschnitte',
      designSectionsHint: 'Das Banner und das Nominierungsformular sind immer vorhanden. Aktivieren Sie die optionalen Abschnitte.',
      designShowStreak: 'Anerkennungsserie',
      designShowRecent: 'Neueste Anerkennungen',
      designBrillamosLocked: 'Die Identität von Shine Together ist unveränderlich: Ihr Design kann nicht bearbeitet werden.',
      approvalSent: 'Genehmigungsanfrage gesendet.',
      submitApproval: 'Zur Genehmigung einreichen',
      submitApprovalConfirmTitle: 'Zur Genehmigung einreichen',
      submitApprovalConfirmMsg: 'Diese Kampagne zur Genehmigung einreichen? Der Admin General muss sie prüfen, bevor sie aktiv wird.',
      prev: 'Zurück',
      next: 'Weiter',
      docLang: 'Sprache',
      docUrl: 'URL des Dokuments',
      docTitle: 'Titel',
      addDoc: 'Dokument hinzufügen',
      docCategoryRequired: 'Wähle eine Kategorie, bevor du das Dokument hinzufügst.',
      docTitleRequired: 'Vervollständige den Titel in allen 7 Sprachen, bevor du das Dokument hinzufügst.',
      docsEmpty: 'Es gibt keine Dokumente.',
      docsFallbackNote: 'Werden hier keine Dokumente hochgeladen, zeigt diese Kampagne die Dokumente aus dem Bereich Dokumentation der Verwaltung an.',
      approvalsTitle: 'Ausstehende Genehmigungen',
      approvalsSub: 'Kampagnen, die auf Ihre Genehmigung warten (AdminGlobal).',
      approvalsEmpty: 'Es gibt keine ausstehenden Genehmigungen.',
      colCampaign: 'Kampagne',
      requestedBy: 'Beantragt von',
      approve: 'Genehmigen',
      approveConfirmTitle: 'Kampagne genehmigen',
      approveConfirmMsg: 'Diese Kampagne genehmigen? Sie wird aktiv und für ihren Bereich sichtbar.',
      reject: 'Ablehnen',
      rejectReason: 'Grund der Ablehnung (erforderlich)',
      rejectConfirm: 'Ablehnung bestätigen',
      viewDetail: 'Details ansehen',
      bannerDesign: 'Banner-Design',
      bannerScopeLabel: 'Dieser Banner gilt nur für diese Kampagne; ohne Konfiguration wird der globale Banner des Programms übernommen.',
      bannerDesignHint: 'Wechseln Sie oben die Sprache, um Titel, Untertitel und Logo dieser Sprache zu bearbeiten — die Vorschau wird live aktualisiert.',
      bannerTitle1: 'Titel (Zeile 1)',
      bannerTitle2: 'Titel (Zeile 2)',
      bannerSubtitle: 'Untertitel',
      bannerLogoNote: 'Der Upload des Logobilds (PNG je Sprache) folgt in Kürze.',
      bannerLogo: 'Logo (Bild für diese Sprache)',
      bannerLogoUpload: 'PNG hochladen',
      bannerLogoReset: 'Auf Standard zurücksetzen',
      bannerLogoHint: 'Empfohlen: transparentes PNG ~4:3. Standardmäßig wird das Fundamentals-Logo angezeigt.',
      bannerLogoErrPng: 'Das Logo muss ein PNG sein.',
      bannerLogoErrSize: 'Das PNG darf 500 KB nicht überschreiten.',
      bannerPreview: 'Vorschau',
      bannerPreviewEmpty: 'Banner-Titel',
      bannerCta: 'Jemanden würdigen',
      brillamosBannerTitle: 'Shine-Together-Banner',
      brillamosBannerHint: 'Passe Untertitel und Logo des Shine-Together-Heros je Sprache an. Die Vorschau aktualisiert sich live.',
      brillamosBannerLogoHint: 'Empfohlen: transparentes PNG. Standardmäßig wird das Shine-Logo angezeigt.',
      entryPoints: 'Anerkennungsmodus (Entry Points)',
      entry: { A: 'Entry A — Klassisches Formular', B: 'Entry B — Interaktives Post-it (Word Builder)', both: 'Beide sichtbar (A/B-Test)' },
      commentRequired: 'Kommentar erforderlich',
      vista: 'Ansicht:',
      vistaGlobal: 'Globaler Admin',
      vistaOu: 'OU-Admin / Botschafter',
      rulesTitle: 'Sende-Regeln',
      brillamosRulesIntro: 'Diese Regeln gelten nur fuer Shine Together. Ein leeres Feld erbt den globalen Wert aus der Verwaltung.',
      ruleMultiPersona: 'Mehrere Personen',
      ruleMultiFundamental: 'Mehrere Fundamentals',
      ruleBulkCsv: 'CSV-Massenupload',
      ruleReactions: 'Reaktionen an der Wand',
      ruleSendingDisabled: 'Senden deaktivieren',
      ruleAnonymousEnabled: 'Anonyme Anerkennungen zulassen',
      anonymousGestionHint: 'Gilt für alles (Fundamentals, Brillamos und individuelle Kampagnen), außer eine Kampagne legt im Konfigurationsschritt des Assistenten eine eigene Einstellung fest. Betrifft nicht die automatische DSGVO-Anonymisierung in Europa.',
      ruleMinChars: 'Min. Zeichen',
      moderationTitle: 'Moderation',
      modPostEdit: 'Bearbeiten nach dem Senden',
      modPostEditDescription: 'Bearbeiten nach dem Senden: Wer sendet, kann seine Anerkennungen bearbeiten oder löschen, solange die Kampagne offen ist.',
      moderationNote: 'Die Melden-Schaltfläche und der Wortfilter werden im Bereich Moderation verwaltet.',
      postEditPerCampaignNote: '„Bearbeiten nach dem Senden“ wird in jeder Kampagne (Schritt 5 des Assistenten) und für die Grundprinzipien in deren Tab eingestellt. Es gibt keine Frist mehr.',
      modAntiSpoiler: 'Anti-Spoiler-Modus',
      modAntiSpoilerDescription: 'Anti-Spoiler-Modus: blendet erhaltene Anerkennungen bis zum Ende der Kampagne aus. Nur wer sie gesendet hat, sieht sie.',
      antiSpoilerPerCampaignNote: '„Anti-Spoiler-Modus“ wird in jeder Kampagne (Schritt 5 des Assistenten) eingestellt und schützt nicht mehr, sobald die Kampagne geschlossen wird. Für die Grundprinzipien in deren Tab; dort wird er manuell ausgeschaltet.',
      multiEnvioPerCampaignNote: '„Mehrere Personen“, „Mehrere Fundamentals“ und „Fundamentals pro Anerkennung“ werden in jeder Kampagne eingestellt (Schritt 5 des Assistenten).',
      multiEnvioEuropaAviso: 'Diese Kampagne umfasst OUs in Europa (DSGVO): Mehrere Personen oder mehrere Fundamentals zuzulassen, liegt in der Verantwortung der Person, die die Kampagne konfiguriert.',
      multiEnvioNoLimitHint: 'Ist „Fundamentals pro Anerkennung“ ausgeschaltet, gibt es keine Begrenzung der Fundamentals.',
      entryPointsPerCampaignNote: 'Der Anerkennungsmodus wird in jeder Kampagne eingestellt (Schritt 5 des Assistenten).',
      resetToGlobal: 'Zurücksetzen (vom globalen Wert übernehmen)',
      streakTitle: 'Serien-Einstellungen (Fundamente)',
      streakActive: 'Serie aktiv',
      streakSentNote: 'Die Serie wird anhand GESENDETER Anerkennungen berechnet.',
      streakInProfile: 'Serie im Profil anzeigen',
      badgesActive: 'Abzeichen aktiv',
      streakPeriod: 'Zeitraum',
      periodWeekly: 'Wöchentlich',
      periodMonthly: 'Monatlich',
      periodDaily: 'Täglich',
      limitsTitle: 'Limits (Limit-Verwaltung)',
      limitsActive: 'Limits aktiv',
      limitName: 'Name',
      limitDescription: 'Beschreibung',
      limitRecognitionsDesc: 'Maximale Anerkennungen',
      limitFundamentalsDesc: 'Max. auswählbar pro Sendung',
      limitValue: 'Limit',
      limitFrequency: 'Häufigkeit',
      limitActiveCol: 'Aktiv',
      limitRecognitions: 'Anerkennungen pro Zeitraum',
      limitFundamentals: 'Fundamentals pro Anerkennung',
      perSubmission: 'Pro Sendung',
      readonlyTitle: 'Allgemeine Konfiguration — Fundamentals (standardmäßig angewendet)',
      readonlyBadge: 'Nur Lesen',
      readonlyNote: 'Wenn Sie eine Ausnahme nach OU hinzufügen möchten, wird sie vom globalen Admin genehmigt.',
      colDate: 'Datum',
      exc: {
        title: 'Ausnahmen nach OU',
        intro: 'Punktuelle Ausnahmen zur Basiskonfiguration für einen bestimmten OU/BU/Site-Geltungsbereich. Jede durchläuft die Genehmigung des globalen Admins.',
        new: 'Neue Ausnahme nach OU',
        colException: 'Ausnahme',
        colScope: 'OU / BU / Site',
        colState: 'Status der Ausnahme',
        fullOu: 'Gesamte OU',
        sites: '{{count}} Sites',
        scopePopTitle: 'Sites im Geltungsbereich',
        stateActive: 'Aktiv',
        stateInactive: 'Inaktiv',
        toggleHint: 'Nur eine genehmigte Ausnahme kann aktiviert oder deaktiviert werden.',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        empty: 'Noch keine Ausnahmen nach OU.',
        deleteTitle: 'Ausnahme löschen',
        deleteMsg: 'Diese Ausnahme nach OU wird dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteConfirm: 'Löschen',
        summaryTope: 'Limit: {{max}} Recos / {{freq}}',
        summaryDisable: 'Senden deaktivieren',
        disableTitle: 'Senden deaktivieren (Override)',
        disableNote: 'Blockiert vorübergehend das Senden von Anerkennungen für den gewählten Bereich, ohne das Programm zu deaktivieren. Erfordert die Freigabe des globalen Admins.',
        summarySchedule: 'Eingeschränkte Zeiten',
        summaryVisibility: 'Sichtbarkeit',
        summaryBanner: 'Banner',
        approvalsTitle: 'Genehmigungen',
        approvalsColSolicitante: 'Antragsteller',
        approvalsColAprobador: 'Genehmiger',
        approvalsColFecha: 'Datum',
        approvalsColEstado: 'Status',
        approved: 'Genehmigt',
        pending: 'Ausstehend',
        rejected: 'Abgelehnt',
        approvalsEmpty: 'Noch keine Ausnahmen zu genehmigen.',
        pendingBanner: 'Sie haben {{count}} Ausnahme(n), die auf Ihre Genehmigung warten.',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        rejectReason: 'Ablehnungsgrund (erforderlich)',
        rejectConfirm: 'Ablehnung bestätigen',
        back: 'Ausnahmen nach OU',
        wizardTitle: 'Ausnahme nach OU — Fundamentals',
        wizardTitleBrillamos: 'OU-Ausnahme — Gemeinsam Glänzen',
        stepScope: 'Geltungsbereich',
        stepSchedule: 'Zeitplan',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Basiskampagne',
        baseCampaignHint: 'Eine OU-Ausnahme funktioniert nicht allein: sie ÜBERSCHREIBT Teile einer aktiven Kampagne für deinen Geltungsbereich. Deckt keine aktive Kampagne diese OUs ab, hat diese Ausnahme keinerlei Wirkung. Wenn du eine eigene vollständige Kampagne für die OU brauchst, erstelle sie unter Kampagnen, nicht hier.',
        baseCampaignLabel: 'Überschriebene Kampagne',
        baseCampaignNone: 'Nicht angegeben (gilt für die aktive Kampagne, die den Bereich abdeckt)',
        baseCampaignNinguna: 'Es gibt keine aktive Kampagne von Gemeinsam Glänzen. Erstelle und aktiviere zuerst eine, sonst gilt diese Ausnahme für niemanden.',
        baseCampaignRequerida: 'Wähle die Basiskampagne, um speichern zu können: ohne sie würde die Ausnahme für niemanden gelten.',
        baseCampaignVentana: 'Die Basiskampagne läuft vom {{inicio}} bis {{fin}}. Diese Daten gehören zur Kampagne und werden hier nicht bearbeitet.',
        baseCampaignSinVentana: 'Für die Basiskampagne ist kein Zeitraum festgelegt.',
        scheduleWindow: 'Lokales Datum und Uhrzeit der Ausnahme',
        scheduleStart: 'Beginn der Ausnahme',
        scheduleEnd: 'Ende der Ausnahme',
        scheduleTz: 'Zeitzone',
        scheduleRestrictTitle: 'Anerkennungen deaktivieren',
        scheduleRestrictNote: 'Wenn aktiv, können außerhalb des für diesen Bereich konfigurierten Datums und der Uhrzeit keine Anerkennungen gesendet werden. Erfordert die Freigabe des globalen Admins.',
        scheduleWindowNota: 'Wenn du ein Zeitfenster festlegst, werden Sendungen in diesem Bereich darauf beschränkt. Leer lassen, um nichts einzuschränken.',
        scheduleInvalid: 'Das Zeitfenster erfordert Start- und Enddatum/-zeit, und das Ende muss nach dem Start liegen.',
        bannerTitle: 'Shine-Together-Banner (Override)',
        bannerIntro: 'Überschreibt Untertitel und Logo des Shine-Together-Banners nur für den Geltungsbereich dieser Ausnahme. Wenn Sie hier keine Sprache bearbeiten, bleibt der globale Banner unverändert.',
        bannerScopeLabel: 'Dieser Banner gilt nur für den Geltungsbereich dieser Ausnahme, nicht für den globalen Shine-Together-Banner.',
        stepDocs: 'Dokumente',
        stepVisibility: 'Sichtbarkeit',
        scopeIntro: 'Legen Sie den organisatorischen Geltungsbereich fest.',
        docsIntro: 'Fügen Sie spezifische Dokumente für diese Ausnahme nach OU hinzu.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Aktivierte Sendewege (Override)',
        entryPointModeApp: 'Nur Formular',
        entryPointModePostit: 'Nur interaktives Post-it',
        entryPointModeAmbos: 'Beide',
        reglasEnCampanaNote: 'In Brillamos werden „Anerkennungsmodus“, „Mehrere Personen“ und „Mehrere Fundamentals“ in jeder Kampagne eingestellt (Schritt 5 des Assistenten) und haben Vorrang vor dieser Ausnahme.',
        visTitle: 'Sichtbarkeit der Anerkennung (Override)',
        visIntro: 'Legen Sie fest, welche Informationen dem Nutzer beim Empfang oder Anzeigen einer Anerkennung gezeigt werden.',
        visText: 'Text/Kommentar der Anerkennung anzeigen',
        visFundamental: 'Zugewiesenen Fundamental anzeigen',
        visSender: 'Namen des Absenders anzeigen',
        visHabit: 'Ausgewähltes Daily Habit anzeigen',
        visRanking: 'Ranking anderer OUs anzeigen',
        visMultiFund: 'Mehrere Fundamentals pro Anerkennung zulassen',
        maxFundamentales: 'Max. Fundamentals pro Anerkennung',
        rulesTitle: 'Senderegeln (Override)',
        ruleMultiPersona: 'Mehrere Personen',
        ruleComment: 'Kommentar erforderlich',
        ruleMinChars: 'Min. Zeichen',
        ruleCsv: 'CSV-Upload',
        modTitle: 'Moderation (Override)',
        modReport: 'Melden-Schaltfläche',
        modEditDelete: 'Bearbeiten- und Löschen-Schaltflächen (nur gesendete)',
        streakTitle: 'Serie (Override)',
        streakMin: 'Min. Sendungen/Woche',
        streakPeriod: 'Zeitraum',
        limitsTitle: 'Limits (Override)',
        limitMax: 'Max. Recos',
        limitFreq: 'Häufigkeit',
        approvalRequiredTitle: 'Genehmigung erforderlich',
        approvalRequiredMsg: 'Alle Änderungen müssen vom globalen Admin genehmigt werden, bevor sie wirksam werden.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Haufigkeit',
      frecuenciaPlaceholder: 'z. B. Monatlich, Alle 3 Meetings…',
      frecuencia: {
        mensual: 'Monatlich',
        trimestral: 'Vierteljahrlich',
        cadaNReuniones: 'Alle 3 Meetings',
        porEvento: 'Pro Ereignis',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Kampagne reaktivieren',
      // Ticket 04 — borrar borradores y pendientes de aprobación (Brillamos).
      deleteBtn: 'Löschen',
      deleteConfirmTitle: 'Kampagne löschen?',
      deleteConfirm: '„{{name}}“ wird gelöscht. Dies kann nicht rückgängig gemacht werden.',
      deleteConfirmPending: '„{{name}}“ wird gelöscht und die Genehmigungsanfrage zurückgezogen. Dies kann nicht rückgängig gemacht werden.',
      deleteDone: 'Kampagne gelöscht.',
      approvalCampaignGone: 'Diese Kampagne existiert nicht mehr.',
      undoPanicConfirm: 'Diese Kampagne wird reaktiviert und in ihrem Bereich wieder sichtbar. Nur innerhalb von 24 h moglich. Fortfahren?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Teilnehmerziel",
      metaParticipantesInherit: "Kein Ziel",
      metaParticipantesHelp: "Unterschiedliche Personen, die teilnehmen — anerkennend oder anerkannt. Leer = kein Ziel.",
      tooltip: {
        entryPoints: 'Wie Mitarbeitende jemanden anerkennen können: klassisches Formular, interaktives Post-it oder beides gleichzeitig.',
        ruleMultiPersona: 'Ermöglicht es, mehr als eine Person als Empfänger in derselben Anerkennung einzuschließen.',
        ruleMultiFundamental: 'Ermöglicht es, mehr als ein Fundamental in derselben Anerkennung zu markieren.',
        commentRequired: 'Erfordert einen Kommentar, um die Anerkennung senden zu können.',
        ruleBulkCsv: 'Aktiviert den Massenimport von Anerkennungen per CSV-Datei.',
        ruleReactions: 'Ermöglicht es anderen Personen, mit Emojis auf eine Anerkennung zu reagieren.',
        ruleSendingDisabled: 'Schaltet den Versand von Anerkennungen für diesen Bereich vollständig ab, ohne bereits gesendete zu beeinträchtigen.',
        ruleAnonymousEnabled: 'Ermöglicht es, eine Anerkennung zu senden, ohne den Namen der absendenden Person anzuzeigen.',
        modPostEdit: 'Erlaubt es, eine gesendete Anerkennung zu bearbeiten oder zu löschen. In einer Kampagne nur, solange sie offen ist; Administratoren können es immer. Praktisch, um einen Fehler im Text ohne Hilfe zu korrigieren.',
        modAntiSpoiler: 'Solange die Kampagne offen ist, sieht die Anerkennungen, die ihre Teilnehmenden erhalten, nur, wer sie gesendet hat: weder die empfangende Person noch ihre Kolleginnen und Kollegen, egal aus welcher Kampagne sie kommen. Er endet, wenn die Kampagne geschlossen wird. Nutze ihn, wenn die Kampagne die meistanerkannten Personen auszeichnet: So weiß niemand vor der Preisverleihung, wie viele er hat.',
        antiSpoiler: 'Solange er eingeschaltet ist, sieht Anerkennungen ohne Kampagne nur, wer sie gesendet hat. Er endet nicht von selbst: Er muss manuell ausgeschaltet werden.',
        streakActive: 'Aktiviert die wöchentliche Serienzählung von Anerkennungen für diese Kampagne.',
        dailyHabitsMandatory: 'Erfordert die Markierung einer täglichen Gewohnheit, damit die Anerkennung für die Serie zählt.',
        streakInProfile: 'Zeigt die aktuelle Serie im öffentlichen Profil der Nutzerin bzw. des Nutzers an.',
        badgesActive: 'Aktiviert die Vergabe von Abzeichen für das Erreichen von Serienzielen.',
        limitsActive: 'Aktiviert die unten festgelegten Versandgrenzen, sowohl für Anerkennungen als auch für Fundamentals.',
        recognitionsLimitActive: 'Wendet die Obergrenze für Anerkennungen pro Zeitraum auf diesen Bereich an.',
        recognitionsLimitDisabled: 'Aktivieren Sie „Nicht zutreffend“, damit diese Kampagne KEIN Gesamt-Sendelimit hat: eine Person kann im Zeitraum beliebig viele Anerkennungen senden, unabhängig vom globalen Limit in der Verwaltung. Deaktiviert lassen (und das Feld leer), um das globale Limit zu verwenden.',
        streakMinimum: 'Mindestanzahl an Anerkennungen, die eine Person im Zeitraum SENDEN muss, damit dieser für ihre Serie zählt (1-20). Überschreibt das globale Minimum aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. Nach dem Start der Kampagne nicht mehr änderbar.',
        recognitionsLimitOwn: 'Maximale GESAMTZAHL an Anerkennungen, die eine Person im Zeitraum senden kann (an beliebige Personen, beliebiges Fundamental). Überschreibt das globale Limit aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. Jederzeit änderbar, auch nach dem Start der Kampagne.',
        sameFundamentalLimit: 'Wie oft eine Person eine andere zum GLEICHEN Fundamental im Zeitraum anerkennen kann (an dieselbe Person). Überschreibt den globalen Wert aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. In Europa bleibt das gesetzliche Minimum (DSGVO) erhalten.',
        sameFundamentalLimitDisabled: 'Aktivieren Sie „Nicht zutreffend“, um dasselbe Fundamental an dieselbe Person OHNE Limit zu wiederholen, unabhängig vom globalen Wert. Deaktiviert lassen (und das Feld leer), um das globale zu verwenden. In Europa bleibt das gesetzliche Limit auch bei Aktivierung erhalten.',
        fundamentalsLimitActive: 'Wendet die Obergrenze für Fundamentals pro Versand auf diesen Bereich an.',
        designShowStreak: 'Zeigt den Serien-Block auf der Landingpage dieser Kampagne an.',
        designShowRecent: 'Zeigt aktuelle Anerkennungen auf der Landingpage dieser Kampagne an.',
        visSender: 'Zeigt den Namen der Person an, die die Anerkennung sendet.',
        visFundamental: 'Zeigt das in der Anerkennung zugewiesene Fundamental an.',
        visText: 'Zeigt den Text bzw. Kommentar der Anerkennung an.',
        visHabit: 'Zeigt das ausgewählte Daily Habit an, sofern zutreffend.',
        visSent: 'Zeigt den Tab für gesendete Anerkennungen an.',
        visReceived: 'Zeigt den Tab für erhaltene Anerkennungen an.',
        visBulk: 'Aktiviert den CSV-Massenimport nur für diese Kampagne.',
        visReactions: 'Aktiviert Emoji-Reaktionen nur für diese Kampagne.',
        visCampaignTag: 'Zeigt das Etikett mit dem Kampagnennamen auf jedem Post-it an.',
        visFromFundamentals: 'Ermöglicht es, diese Anerkennung von der Fundamentals-Seite aus zu starten.',
        visSendingDisabled: 'Schaltet den Versand von Anerkennungen nur für diese Kampagne ab.',
        applyPoints: 'Anerkennungen in dieser Kampagne vergeben einlösbare Punkte. Kann nicht mehr abgeschaltet werden, sobald die Kampagne gestartet ist.',
        visRanking: 'Zeigt das Ranking im Vergleich zu anderen OUs an.',
        visMultiFund: 'Ermöglicht es, mehr als ein Fundamental zu markieren, als Ausnahme für diese OU.',
        modReport: 'Ermöglicht es, eine unangemessene Anerkennung zu melden.',
        modEditDelete: 'Aktiviert das Bearbeiten und Löschen einer bereits gesendeten Anerkennung, nur für diese OU. Das Backend behandelt beide Berechtigungen als einen einzigen Schalter.',
        scheduleEnabled: 'Beschränkt den Versand von Anerkennungen auf das oben festgelegte Zeitfenster.',
        disableSend: 'Blockiert den Versand von Anerkennungen für diesen konkreten Bereich.',
        paisActive: 'Wenn deaktiviert, ist die Kampagne für dieses Land nicht mehr aktiv, selbst wenn das konfigurierte Datum und Zeitfenster noch gültig sind.',
        paisApplySchedule: 'Ausgeschaltet bleiben Datum und Uhrzeit dieser Zeile gespeichert, werden aber NICHT angewendet: das Land hat keine zeitliche Einschränkung. Praktisch, um ein Fenster vorzubereiten und später einzuschalten, ohne es neu zu erfassen.',
        gestStreakEnabled: "Globaler Wert: aktiviert die Zählung der Anerkennungsserie. Jedes Programm und jede Kampagne kann einen eigenen Wert festlegen.",
        gestWrappedByOu: "Hauptschalter für den Jahresrückblick (Wrapped). Ausgeschaltet sieht ihn niemand; eingeschaltet sieht ihn jede OU innerhalb des Sichtbarkeitsfensters ihrer Konfiguration im Rückblick.",
        gestAllowPromote: "Erlaubt, eine Anerkennung aus Fundamentals auch an Brillamos zu senden: zeigt das Kontrollkästchen in Anerkennen und das ⭐ auf der Pinnwand und im Profil.",
        gestStreakPerPersonCap: "Begrenzt, wie viele 1:1-Anerkennungen an dieselbe Person für die Serie zählen (Missbrauchsschutz). Gruppenanerkennungen zählen immer. Das Maximum wird unten festgelegt.",
        gestAvatarEnabled: "Erlaubt Personen, die über die Web-App einsteigen, einen farbigen Avatar anzupassen. Wer über Teams einsteigt, behält das Profilfoto.",
        gestAvatarSelector: "Zeigt die Avatar-Auswahl direkt nach der Registrierung. Setzt voraus, dass der anpassbare Avatar aktiv ist.",
        gestPanic: "Globaler Kill-Switch: stoppt sofort das Senden von Anerkennungen in allen aktiven Kampagnen (Brillamos Juntos und Fundamentals), ohne bereits gesendete zu beeinflussen. Er lässt sich nur einschalten, wenn mindestens eine Brillamos-Kampagne aktiv ist.",
      },
      tooltipAria: 'Hilfe',
    },
    reports: { desc: 'Berichte und Analytics des Programms.' },
    translate: {
      button: 'In die anderen Sprachen übersetzen',
      buttonFrom: 'Von {{lang}} in die anderen Sprachen übersetzen',
      loading: 'Übersetzen…',
      hint: 'Geben Sie mindestens eine Sprache ein, um zu übersetzen.',
      error: 'Die automatische Übersetzung ist fehlgeschlagen.',
      sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte lade die Seite neu und melde dich erneut an.',
    },
    misSolicitudes: {
      title: "Meine Kampagnenanträge",
      desc: "Der Status Ihrer Vorschläge. Sie können einen Antrag zurückziehen, solange er aussteht, und ihn erneut einreichen, wenn er abgelehnt wurde.",
      empty: "Sie haben noch keine Anträge gesendet.",
      colCampana: "Kampagne",
      colFecha: "Antragsdatum",
      colEstado: "Status",
      colComentario: "Kommentar",
      colAcciones: "Aktionen",
      editar: "Bearbeiten",
      retirar: "Antrag zurückziehen",
      reenviar: "Erneut einreichen",
      estado: {
        pendiente: "Ausstehend",
        aprobada: "Genehmigt",
        rechazada: "Abgelehnt",
      },
    },
    management: {
      desc: 'Versandregeln, Obergrenzen und Serie.',
      title: 'Steuerung',
      descLong: 'Globale Einstellungen: Seriendescription ×7, Abzeichen, globale Schalter und Freeze. Atomares Speichern.',
      fixValidation: 'Beheben Sie die Validierungen vor dem Speichern.',
      streakDescription: 'Beschreibung der Serie',
      fundamentalsTitle: 'Verfügbare Fundamentals',
      fundamentalsDesc: 'Welche Fundamentals beim Anerkennen angeboten werden. Eines zu entfernen löscht es nicht aus dem Katalog: es erscheint nur in diesem Programm nicht mehr.',
      fundamentalsLastOne: 'Das ist das letzte verfügbare: Wird es entfernt, könnte niemand mehr eine Anerkennung senden.',
      avatarTitle: 'Avatar-Einstellungen (Frontline)',
      avatarDesc: 'Frontline-Nutzende, die über die Webapp einsteigen, können einen Farbavatar anpassen. Wer über Teams kommt, behält sein Profilbild.',
      avatarEnabled: 'Anpassbarer Avatar aktiv',
      avatarSelector: 'Auswahl nach der Registrierung zeigen',
      avatarColors: 'Verfügbare Avatare:',
      placeholderTitle: 'Konfigurierbare Beschreibung des Textfelds',
      placeholderDesc: 'Der Hilfetext des Nachrichtenfelds beim Anerkennen. Jede leer gelassene Sprache nutzt den Produkttext.',
      placeholderLabel: 'Hilfetext der Nachricht',
      panicTitle: 'Notaus-Schalter — Brillamos Juntos',
      panicDesc: 'Deaktiviert sofort das Senden von Anerkennungen in allen aktiven Kampagnen. Gilt sowohl für Shine Together als auch für Anerkennen (Fundamentals). Nur General-Admin.',
      panicToggle: 'Globaler Kill-Switch Brillamos',
      panicActiveHint: 'Das Senden ist DEAKTIVIERT: Derzeit kann niemand Anerkennungen senden.',
      panicSameSwitchHint: 'Dies ist ein globaler Schalter: solange er aktiv ist, kann keine Einstellung pro Programm oder pro Kampagne das Senden wieder aktivieren.',
      panicNoActiveCampaign: 'Dieser Schalter wird verfügbar, sobald mindestens eine Shine Together-Kampagne aktiv ist (RN-C08). Derzeit gibt es keine, also auch keine Kampagnen-Einsendungen zum Stoppen.',
      needAllLangs: 'Füllen Sie alle 7 Sprachen aus.',
      globalToggles: 'Globale Schalter',
      streakEnabled: 'Serie aktiv',
      multinomination: 'Mehrfachnominierung',
      dailyHabitsMandatory: 'Tägliche Gewohnheiten verpflichtend',
      antiSpoiler: 'Anti-Spoiler',
      antiSpoilerTitle: 'Anti-Spoiler-Modus (Preisverleihung)',
      antiSpoilerDesc: 'Blendet während der jährlichen Preisverleihung vorübergehend fremde Profile und Anerkennungen aus, damit die Gewinner nicht verraten werden.',
      antiSpoilerActivo: 'Anti-Spoiler aktiv',
      antiSpoilerFrom: 'Von',
      antiSpoilerTo: 'Bis',
      antiSpoilerHint: 'Solange er aktiv ist, sehen Mitarbeitende weder Profile von Kolleginnen und Kollegen noch die Details fremder Anerkennungen.',
      antiSpoilerSinVentana: 'Ohne Datumsangaben schützt er, solange der Schalter an ist.',
      antiSpoilerVentanaInvertida: '„Von“ liegt nach „Bis“: so schützt das Zeitfenster nie. Bitte korrigieren, um speichern zu können.',
      wrappedByOu: 'Wrapped pro OU',
      reactionsEnabled: 'Reaktionen (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Senden an Brillamos erlauben',
      allowPostEdit: 'Bearbeitung nach dem Senden',
      postEditTitle: 'Bearbeitung gesendeter Anerkennungen',
      postEditDesc: 'Erlaubt es der sendenden Person, den Text einer bereits gesendeten Anerkennung zu bearbeiten. Standardmäßig aus.',
      postEditWindow: 'Bearbeitungsfenster',
      postEditWindowOpt: { '24h': '24 Stunden', '48h': '48 Stunden', '7d': '7 Tage', unlimited: 'Ohne Begrenzung' },
      streakPerPersonCapEnabled: 'Obergrenze pro Person (Serie)',
      streakPerPersonCap: 'Max. pro Person (Serie)',
      weeklyMinimum: 'Minimum pro Zeitraum',
      periodicity: 'Periodizität',
      period: { weekly: 'Wöchentlich', monthly: 'Monatlich' },
      periodicityHint: 'Das Minimum gilt für den gewählten Zeitraum: bei Monatlich wächst oder reißt die Serie pro Kalendermonat, nicht pro Woche.',
      periodicityMonthlyWarning: 'Bei Monatlich zählt die Serie aufeinanderfolgende MONATE, und die App zeigt das bereits so (Widget, Profil, Wrapped und Schwellen). ZWEI Produktentscheidungen stehen vor der Aktivierung in der Produktion aus: RF-038 definiert die Abzeichen-Schwellen in Wochen (1/4/8/12/20), das 4er-Abzeichen käme also nach 4 Monaten; und die Missbrauchsgrenze von 2 Anerkennungen pro Person gilt statt pro Woche nun pro Monat, was ein hohes Minimum in kleinen Teams unerreichbar machen kann.',
      freezeFrom: 'Freeze ab',
      freezeTo: 'Freeze bis',
      badges: 'Abzeichen',
      noBadges: 'Es sind keine Abzeichen konfiguriert.',
      badge: 'Abzeichen',
      weeksRequired: '{{count}} Wochen',
      weeksRequiredOne: '{{count}} Woche',
      weeksRequiredMany: '{{count}} Wochen',
      badgeName: 'Name des Abzeichens',
      badgeIcon: 'Symbol',
      badgeColor: 'Farbe',
      weeks: 'Erforderliche Wochen',
      notApplicable: 'Nicht zutreffend',
      iconFormatInvalid: 'Ungültiges Bildformat. Verwenden Sie PNG, JPG, WEBP oder SVG.',
      addBadge: '+ Abzeichen hinzufügen',
      editBadge: 'Bearbeiten',
      deleteBadge: 'Löschen',
      deleteBadgeConfirm: 'Abzeichen „{{name}}“ löschen? Name in allen 7 Sprachen, Symbol und Schwellenwert gehen verloren. Die Löschung wird beim Speichern wirksam.',
      badgeActive: 'Aktiv',
      badgeInactive: 'Inaktiv',
      imageUploadHintNew: 'Speichern Sie das Abzeichen zuerst, um das Symbol hochladen zu können.',
      previewTitle: 'Vorschau',
      saveBadgeChanges: 'Änderungen speichern',
    },
    // PHASE 7 (Demo-Parität, H-93/H-94/H-95) — Admin › Benachrichtigungen (REQ-135).
    notifications: {
      title: 'Benachrichtigungseinstellungen',
      desc: 'Legen Sie fest, welche E-Mail-Hinweise gesendet werden und auf welcher Organisationsebene. Auf dieser Ebene nicht definierte Werte werden von der nächsten geerbt.',
      precedenceTitle: 'Wie die Konfiguration aufgelöst wird',
      precedence1: 'Vorrang: Site > BU > OU > Global. Es gilt der Wert der spezifischsten Ebene.',
      precedence2: 'Ein Schalter auf «Geerbt» ist nicht ausgeschaltet: Er übernimmt den Wert der darunterliegenden Ebene. Gespeichert wird nur, was Sie hier definieren.',
      precedence3: 'Jede Person kann ihre eigenen E-Mails zusätzlich im Profil abbestellen; diese Einstellung reaktiviert nie, was hier ausgeschaltet wurde.',
      scopeTitle: 'Konfigurationsebene',
      scopeUnit: 'Einheit',
      scopePick: 'Einheit auswählen…',
      scopeRequired: 'Wählen Sie eine Einheit, um ihre Konfiguration zu sehen und zu bearbeiten.',
      scopeOuContext: 'OU der Einheit',
      scopeOuFirst: 'Zuerst eine OU auswählen…',
      unsavedLock: 'Es gibt ungespeicherte Änderungen; die Ebene bleibt fest, bis Sie speichern oder verwerfen.',
      discard: 'Änderungen verwerfen',
      scope: { global: 'Global (gesamter Tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-Mail', categories: 'Hinweistypen', summary: 'Periodische Zusammenfassung', blocked: 'Gesperrte E-Mails' },
      blocked: {
        desc: 'Adressen, die keine E-Mail des Programms erhalten, unabhängig von ihren persönlichen Einstellungen.',
        scopeWarning: 'Die Sperre gilt für den GESAMTEN Tenant, nicht nur für diese Ebene: eine hier gesperrte Adresse ist in allen OUs gesperrt. Sie sticht auch den Hauptschalter.',
        placeholder: 'name@unternehmen.com',
        add: 'Sperren',
        remove: 'Sperre für {{email}} aufheben',
        empty: 'Keine gesperrten E-Mails.',
      },
      design: {
        title: 'E-Mail-Design',
        desc: 'So sehen sie heute aus: Die Fundamentals nutzen einen warmen Stil, Shine Together einen dunklen mit Sternen. Das Design jeder E-Mail wird direkt in der Vorlage festgelegt, nicht hier.',
        fund: { name: 'Fundamentals', style: 'Warmer Stil · Creme/Orange' },
        shine: { name: '✨ Shine Together', style: 'Dunkler Stil · Sterne/Violett' },
      },
      broadcast: {
        title: 'Systemmeldungen',
        desc: 'Für Wartungen, Ausfälle oder einmalige Hinweise. Wird mit der bereits gestalteten Vorlage gesendet: schreib nur die Nachricht.',
        overridesHint: '🔴 Diese Meldung erreicht ALLE, auch wer seine Benachrichtigungen abgeschaltet hat. Sie ist kein Programminhalt, sondern Information über das Werkzeug.',
        kindLabel: 'Art der Meldung',
        kind: { maintenance: 'Geplante Wartung', suspension: 'Vorübergehende Störung', restored: 'Dienst wiederhergestellt', general: 'Allgemeiner Hinweis' },
        subject: 'Betreff',
        subjectPlaceholder: 'Geplante Wartung — Samstag 2 Uhr',
        message: 'Nachricht',
        messagePlaceholder: 'Nachricht für die Nutzenden...',
        everyone: 'Alle',
        singleOu: 'Eine bestimmte OU',
        chooseOu: 'OU auswählen',
        send: 'Meldung jetzt senden',
        error: 'Die Meldung konnte nicht gesendet werden.',
        sentSummary: 'An {{sent}} von {{recipients}} Personen gesendet.',
        skipped: '· {{count}} ohne auflösbare Identität haben sie nicht erhalten.',
      },
      channel: { inapp: 'Glocke', email: 'E-Mail', teams: 'Teams' },
      tables: {
        shine: '✨ Benachrichtigungen — Shine Together',
        admin: '🛡️ Benachrichtigungen — Admin',
        colType: 'Typ',
        colSubject: 'Betreff (ES)',
        colLanguages: 'Sprachen',
        editSubject: 'Betreff von „{{row}}“ in allen 7 Sprachen bearbeiten',
        subjectByLanguage: 'Betreff nach Sprache',
        close: 'Schließen',
        saveSubject: 'Betreff speichern',
        nineRows: 'Neun Zeilen statt dreizehn: vier der im Mockup gezeichneten entsprechen keiner Benachrichtigung, die das System heute sendet.',
        rows: {
          'campaign-new': { name: 'Neue Kampagne gestartet', trigger: 'Ein Admin aktiviert eine Kampagne' },
          'campaign-ending': { name: 'Kampagne endet bald', trigger: 'Letzte Tage zum Nominieren' },
          'recognition-sent': { name: 'Anerkennung an Shine Together gesendet', trigger: 'Bestätigung, dass sie zur Kampagne zählt' },
          'ranking-position': { name: 'Position im Ranking', trigger: 'Du steigst im Leaderboard auf' },
          'campaign-approval': { name: 'Kampagnenantrag einer Einheit', trigger: 'Ein OU-Admin stellt einen Antrag → Global-Admin' },
          'moderation-case-alert': { name: 'Moderationsmeldung', trigger: 'Eine neue Meldung wartet auf den OU-Admin' },
          'moderation-educational': { name: 'Gemeldete Nachricht, Hinweis an den Absender', trigger: 'Informiert die Person, die die Anerkennung gesendet hat' },
          'low-participation-alert': { name: 'Warnung bei geringer Beteiligung', trigger: 'Eine Kampagne liegt unter dem Beteiligungsschwellenwert' },
          'pending-nomination-manager': { name: 'Offene Nominierung (Führungskraft)', trigger: 'Eine Nominierung muss genehmigt werden' },
        },
      },
      master: {
        label: 'E-Mail-Benachrichtigungen',
        desc: 'Hauptschalter: Ist er aus, wird in diesem Bereich keine Programm-E-Mail versendet. Betrifft weder Teams noch die Glocke.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Erhaltene Anerkennungen', desc: 'Hinweis an die Person, wenn sie jemand anerkennt.' },
        streakAndBadgesEnabled: { label: 'Serien und Abzeichen', desc: 'Serien-Erinnerungen und freigeschaltete Abzeichen.' },
        campaignsEnabled: { label: 'Kampagnen', desc: 'Neue Kampagne, endende Kampagne, Gewinner und Freigaben.' },
        digestEnabled: { label: 'Wöchentliche Zusammenfassung', desc: 'Digest mit der gesammelten Aktivität der Woche.' },
      },
      monthly: {
        label: 'Monatliche Zusammenfassung',
        desc: 'Standardmäßig aus. Nur aktivieren, wenn diese Einheit zusätzlich eine monatliche Zusammenfassung wünscht.',
      },
      masterOffHint: 'Die einzelnen Typen wirken nur bei eingeschaltetem Hauptschalter.',
      inherited: 'Geerbt',
      inApp: { label: 'In-App-Benachrichtigungen (Glocke)', desc: 'Die Glocke im Portal. Sie hängt nicht vom E-Mail-Schalter ab: es ist ein eigener Kanal.' },
      teams: { label: 'Teams Activity Feed', desc: 'Der Hinweis im Teams-Aktivitätsfeed, für Personen mit Firmenkonto.' },
      frequency: {
        label: 'Sendefrequenz (E-Mail)',
        desc: 'Wie oft Hinweise zu einer Zusammenfassung gebündelt werden. E-Mails pro Ereignis sind nicht betroffen.',
        opt: {
          immediate: 'Sofort (pro Ereignis)',
          daily: 'Tägliche Zusammenfassung',
          weekly: 'Wöchentliche Zusammenfassung',
          biweekly: 'Zweiwöchentliche Zusammenfassung',
        },
        immediateHint: 'Mit „Sofort“ wird keine Zusammenfassung verschickt, auch wenn die Kategorie aktiv bleibt: jeder Hinweis geht einzeln raus.',
      },
      resetToInherited: 'Zurück auf geerbt',
      active: 'aktiv',
      saved: 'Änderungen gespeichert!',
      loadError: 'Die Konfiguration dieser Ebene konnte nicht geladen werden.',
      saveError: 'Die Konfiguration konnte nicht gespeichert werden. Bitte erneut versuchen.',
    },
    views: {
      title: 'Benutzeransichten',
      desc: 'Für Mitarbeitende sichtbare Ansichten und Microsites.',
      descLong: 'Welche Ansichten jede OU ihren Mitarbeitenden anbietet. Desktop + mobil.',
      scope: 'Konfigurationsebene',
      scopeGlobal: 'Global (alle OUs)',
      unsavedLock: 'Speichern oder verwerfen Sie die Änderungen, bevor Sie die Ebene wechseln.',
      cancelChanges: 'Änderungen abbrechen',
      infoAria: 'Hilfe zu {{label}}',
      micrositesTitle: 'Microsite-URLs pro Fundamental',
      micrositesDesc: 'Externer Link mit mehr Infos zu jedem Fundamental. Leer lassen, wenn es keine Microsite gibt.',
      card: {
        medallero: { label: 'Medaillenspiegel', desc: 'Gesendet + erhalten' },
        perfilUsuario: { label: 'Benutzerprofil', desc: 'Erhalten neu→alt' },
        enviarReconocimiento: {
          label: 'Anerkennung senden', desc: 'Gemäß Admin-Konfiguration',
          tooltip: 'Zeigt die Schaltfläche und das Formular, um einen Kollegen anzuerkennen. Kombiniert sich mit dem allgemeinen Sende-Schalter: Ist dieser deaktiviert, erscheint diese Ansicht nicht, selbst wenn sie hier aktiviert ist.',
        },
        historicoPorAnio: {
          label: 'Verlauf nach Jahr', desc: 'Aktuelles Jahr zuerst',
          tooltip: 'Zeigt den Anerkennungsverlauf gruppiert nach Jahr, aktuelles Jahr zuerst. Hängt außerdem davon ab, dass die aktive Kampagne den Verlauf aktiviert hat.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Rangliste',
          tooltip: 'Zeigt die Rangliste der Personen mit den meisten gesendeten oder erhaltenen Anerkennungen. Sie ist die einzige Ansicht, die standardmäßig deaktiviert ist.',
        },
        feedActividad: { label: 'Aktivitäts-Feed', desc: 'Aktuelle Timeline' },
        resumenMensual: {
          label: 'Monatsrückblick', desc: 'Wrap-up im Spotify-Stil',
          tooltip: 'Aktiviert den Rückblick im „Wrapped“-Stil mit den Zahlen des Zeitraums für jede Person. Wird nur angezeigt, wenn Wrapped für die OU aktiviert ist und die Kampagne bereits abgeschlossen ist.',
        },
        busquedaCompaneros: {
          label: 'Kollegensuche', desc: 'Medaillenspiegel anderer ansehen',
          tooltip: 'Ermöglicht die Suche nach anderen Kollegen und das Ansehen ihres Medaillenspiegels. Wird während des aktiven Anti-Spoiler-Modus automatisch ausgeblendet, damit vor einer Preisverleihung nichts verraten wird.',
        },
        vistaFundamentales: {
          label: 'Fundamentals-Ansicht', desc: 'Infos zu jedem Fundamental',
          tooltip: 'Zeigt die Konstellation mit den Informationen zu jedem Kultur-Fundamental innerhalb des Brillamos-Juntos-Bildschirms.',
        },
        banderaReportar: {
          label: 'Melde-Flagge', desc: 'Unangemessene Anerkennungen melden',
          tooltip: 'Fügt eine Schaltfläche hinzu, mit der Mitarbeitende eine unangemessene Anerkennung melden können. Hängt außerdem davon ab, dass die Melde-Flagge unter Moderation aktiviert ist.',
        },
        recordatorioDiario: { label: 'Tägliche Erinnerung', desc: 'Täglicher Anstoß zum Anerkennen' },
        verATuEquipo: {
          label: 'Dein Team ansehen', desc: 'Nur für Führungskräfte',
          tooltip: 'Ermöglicht Führungskräften und Managern, die Anerkennungen der von ihnen geführten Personen zu sehen. Gilt nur für Personen, die im Organigramm als Führungskraft geführt werden und die Team-Kennzahlen-Berechtigung besitzen.',
        },
      },
      compose: {
        sending: 'Hängt zusätzlich vom Notaus-Schalter ab: bei deaktiviertem Senden erscheint diese Ansicht nicht, auch wenn sie hier aktiv ist.',
        campaign: 'Hängt zusätzlich vom Verlaufs-Toggle der aktiven Kampagne ab (RN-PR09).',
        wrapped: 'Hängt zusätzlich davon ab, dass die OU Wrapped aktiviert hat und ihre Kampagne beendet ist.',
        antiSpoiler: 'Hängt zusätzlich vom Anti-Spoiler-Modus ab: solange dessen Fenster aktiv ist, bleibt die Ansicht verborgen.',
        report: 'Hängt zusätzlich vom Toggle „Melde-Button“ im Bereich Moderation ab.',
        manager: 'Hängt zusätzlich davon ab, Führungskraft im Organigramm zu sein und die Team-Metriken-Berechtigung zu haben.',
      },
    },
    docs: {
      desc: 'Unternehmens- und Rechtsdokumente.',
      legalTab: 'Rechtsgrundlagen',
      privacyTab: 'Datenschutzhinweis',
      corpTab: 'Unternehmen',
      pillsTab: 'Benutzer-Pills',
      bibliotecaTab: 'Bibliothek',
      legalesTab: 'Rechtsdokumente',
      gestionTitle: 'Dokumentenverwaltung',
      gestionDesc: 'Konfigurieren Sie die Benutzer-Schnellzugriffe, verwalten Sie die Dateibibliothek und die obligatorischen Rechtsdokumente.',
      pills: {
        nueva: 'Pille hinzufügen',
        sectionTitle: 'Schnellzugriff (Pills)',
        sectionSubtitle: 'Schnellzugriff-Kapseln, die in der Benutzeroberfläche sichtbar sind. Lege Name, Symbol, Farbe und den Inhalt fest, den sie beim Klick öffnen.',
        editar: 'Pille bearbeiten',
        titulo: 'Titel',
        tipo: 'Typ',
        tipos: { documento: 'Dokument', url: 'Link', video: 'Video' },
        icono: 'Symbol',
        color: 'Farbe',
        orden: 'Reihenfolge',
        documento: 'Unternehmensdokument',
        elegirDocumento: 'Dokument wählen…',
        sinDocumentos: 'Keine Unternehmensdokumente verfügbar. Laden Sie sie im Tab „Unternehmen“ hoch.',
        url: 'Ziel-URL',
        visibilidad: 'Sichtbarkeit nach OE',
        visibilidadHint: 'Keine OE ausgewählt = für alle Einheiten sichtbar.',
        activa: 'Aktive Pille (im Rail sichtbar)',
        activaSi: 'Aktiv',
        activaNo: 'Inaktiv',
        estado: 'Status',
        vistaPrevia: 'Vorschau',
        nombre: 'Name',
        tipoContenido: 'Inhaltstyp',
        documentoColumna: 'Verknüpftes Dokument',
        documentoNoEncontrado: 'Dokument nicht gefunden',
        documentoAlcanceIncompleto: 'Deckt nicht alle OUs dieser Pill ab',
        sinTitulo: 'Ohne Titel',
        todas: 'Alle',
        vacio: 'Noch keine Schnellzugriffe konfiguriert.',
        eliminar: 'Pille löschen',
        eliminarConfirm: 'Diesen Schnellzugriff aus dem Rail entfernen?',
        errorCargar: 'Schnellzugriffe konnten nicht geladen werden.',
        errorGuardar: 'Schnellzugriff konnte nicht gespeichert werden.',
        errorEliminar: 'Schnellzugriff konnte nicht gelöscht werden.',
      },
      corp: {
        firstLogin: 'Erster Login',
        versionEs: 'Version ES',
        versionEn: 'Version EN',
        subirVersion: 'Hochladen',
        reemplazar: 'Ersetzen',
        verVersion: 'Version ansehen',
        quitarVersion: 'Version entfernen',
        triggerUpdate: 'Update auslösen',
        ousActivas: 'Aktive OUs',
        nombre: 'Dokumentname',
        tipo: 'Typ',
        visibilidad: 'Sichtbarkeit nach OE',
        idiomas: 'Sprachen',
        idiomasHint: 'Keine Auswahl = alle Sprachen.',
        versionesPorIdioma: 'Versionen pro Sprache',
        versionesPorIdiomaCount: 'Versionen ({{count}}/{{total}})',
        archivo: 'PDF-Datei',
        elegirArchivo: 'PDF auswählen…',
        subir: 'Dokument hochladen',
        agregarDocumento: 'Dokument hinzufügen',
        subirArchivo: 'Datei hochladen',
        libType: { todos: 'Alle', pdf: 'PDF', video: 'Video', imagen: 'Bild' },
        filterType: 'Typ',
        nombreArchivo: 'Dateiname',
        idioma: 'Sprache',
        pillAsignado: 'Zugewiesene Pille',
        subido: 'Hochgeladen',
        documento: 'Dokument',
        actualizado: 'Aktualisiert',
        mediaKind: 'Dateityp',
        externalUrl: 'Externe URL',
        externalUrlHint: 'Füge den Video- oder Bildlink ein (Teams, SharePoint usw.).',
        requiereUrl: 'Gib eine gültige externe URL ein.',
        abrir: 'Öffnen',
        dropMain: 'Dateien hierher ziehen oder zum Hochladen klicken',
        dropSub: 'PDF · Max. 25 MB pro Datei',
        subidoOk: 'Dokument hochgeladen.',
        errorSubir: 'Das Dokument konnte nicht hochgeladen werden.',
        lista: 'Hochgeladene Dokumente',
        listaCount: '{{count}} Dokumente konfiguriert',
        legalInfo: 'Diese Dokumente werden im obligatorischen Akzeptanz-Dialog angezeigt. Erster Login aktiviert sie beim ersten Zugriff. Aktualisierung auslösen zeigt sie erneut an, auch wenn der Benutzer sie bereits akzeptiert hat. Eine ausdrückliche Zustimmung ist zum Fortfahren erforderlich.',
        searchPlaceholder: 'Datei suchen…',
        filterLang: 'Nach Sprache filtern',
        filterLangAll: 'Alle Sprachen',
        noResults: 'Keine Dokumente entsprechen dem Filter.',
        vacio: 'Es gibt noch keine Unternehmensdokumente.',
        fecha: 'Datum',
        acciones: 'Aktionen',
        descargar: 'Herunterladen',
        editar: 'Bearbeiten',
        eliminar: 'Löschen',
        guardar: 'Änderungen speichern',
        cancelar: 'Abbrechen',
        eliminarConfirm: 'Dieses Dokument aus dem Repository löschen?',
        errorEliminar: 'Das Dokument konnte nicht gelöscht werden.',
        errorActualizar: 'Das Dokument konnte nicht aktualisiert werden.',
        errorCargar: 'Die Liste konnte nicht geladen werden.',
        soloPdf: 'Nur PDF bis 25 MB ist zulässig.',
        requiereNombre: 'Namen eingeben.',
        requiereOu: 'Mindestens eine OE auswählen.',
        requiereArchivo: 'PDF-Datei auswählen.',
        tipos: {
          PoliticaPrivacidad: 'Datenschutzrichtlinie',
          BasesLegales: 'Rechtliche Grundlagen',
          GuiaUsuario: 'Benutzerhandbuch',
          Premios: 'Preise',
          CookiesPolicy: 'Cookie-Richtlinie',
          LegalNotice: 'Impressum',
        },
      },
      currentVersion: 'Aktuelle Version',
      noVersionYet: 'Es wurde noch keine Version veröffentlicht',
      newVersionLabel: 'Neue zu veröffentlichende Version',
      loadError: 'Der Entwurf konnte nicht geladen werden.',
      titleLabel: 'Titel',
      sectionHeading: 'Überschrift',
      sectionBody: 'Inhalt',
      addSection: 'Abschnitt hinzufügen',
      removeSection: 'Abschnitt entfernen',
      saveDraft: 'Entwurf speichern',
      publish: 'Veröffentlichen',
      publishConfirm: 'Du bist dabei, eine neue Version zu veröffentlichen. Alle Nutzer müssen sie erneut akzeptieren, bevor sie Anerkennungen aussprechen können. Fortfahren?',
      missingLanguages: 'Fehlende Sprachen: {{languages}}',
      draftSaved: 'Entwurf gespeichert',
      published: 'Version veröffentlicht',
      saveError: 'Der Entwurf konnte nicht gespeichert werden.',
      publishError: 'Die Version konnte nicht veröffentlicht werden.',
    },
    recap: {
      title: 'Jahres-Recap',
      desc: 'Konfigurieren Sie das Recap-Erlebnis pro Ausgabe. Hintergründe und Symbole sind pro Slide konfigurierbar; die Nutzerdaten (Anerkennungen, meistempfangenes Grundprinzip, Fan Nr. 1, Serie) werden automatisch von der Plattform eingefügt.',
      deniedRole: 'Die Verwaltung des Recap ist Admin Allgemein und Admin Grundprinzipien vorbehalten.',
      fixValidation: 'Füllen Sie die Pflichttexte vor dem Speichern aus.',
      noEditions: 'Es gibt noch keine Recap-Ausgaben.',
      createFirst: 'Erste Ausgabe erstellen',
      edition: 'Ausgabe',
      editionName: 'Für Benutzer:innen sichtbarer Name',
      newEdition: 'Neue Ausgabe',
      newConfig: 'Neue Konfiguration',
      newConfigName: 'Recap {{year}} · neue Konfiguration',
      newEditionTitle: 'Neue Ausgabe des Rückblicks',
      newEditionYear: 'Jahr der Ausgabe',
      newEditionYearRange: 'Wähle ein Jahr zwischen {{min}} und {{max}}.',
      newEditionFutureWarn: 'Eine Ausgabe für {{year}} sieht niemand vor diesem Jahr.',
      newEditionExisting: 'Für {{year}} gibt es bereits Konfigurationen: Es wird eine weitere, inaktive erstellt.',
      newEditionCreate: 'Ausgabe erstellen',
      delete: 'Löschen',
      deleteAria: 'Konfiguration {{name}} löschen',
      deleteTitle: 'Konfiguration löschen',
      deleteConfirm: '„{{name}}“ ({{year}}) wird gelöscht und verschwindet aus dem Verlauf und der Auswahl. Fortfahren?',
      deleteBlockedActive: 'Löschen nicht möglich: Sie ist aktiv. Zuerst deaktivieren und speichern.',
      deleteBlockedNotified: 'Löschen nicht möglich: Die Mitarbeitenden wurden bereits benachrichtigt.',
      deleteError: 'Die Konfiguration konnte nicht gelöscht werden.',
      vistasOff: 'Der Rückblick ist in Ansichten für {{ous}} ausgeschaltet: Schalte ihn ein, damit er sichtbar ist.',
      gestionOff: 'Der Rückblick ist in Verwaltung („Rückblick pro OU“) ausgeschaltet: Schalte ihn ein, damit er sichtbar ist.',
      configsHint: 'Jede Konfiguration hat ihren eigenen OE-Geltungsbereich, Status, Zeitraum und ihre eigene Benachrichtigung. Mehrere können gleichzeitig aktiv sein, solange sie keine OEs teilen; liegt eine OE innerhalb einer anderen (MEXICO und eines seiner Werke), sieht jede:r Mitarbeitende die spezifischste für die eigene OE.',
      openConfig: 'Konfiguration {{name}} öffnen',
      scope: 'OU-Geltungsbereich',
      scopeGlobal: 'Global (alle)',
      active: 'Recap aktiv',
      activeOn: 'Aktiv',
      activeOff: 'Inaktiv',
      visibleFrom: 'Beginn der Sichtbarkeit',
      visibleTo: 'Ende der Sichtbarkeit',
      notification: 'Benachrichtigung',
      notifiedAt: 'Gesendet {{date}}',
      neverNotified: 'Nicht benachrichtigt',
      difusionLockHint: 'Dieses Recap wurde bereits angekündigt. Sie können Geltungsbereich und Sichtbarkeitsfenster ERWEITERN, aber nicht verkleinern: Eine OU zu entfernen oder die Fristen zu verkürzen würde bereits benachrichtigte Personen ausschließen. Alles Übrige bleibt bearbeitbar.',
      slidesTitle: 'Slide-Konfiguration ({{count}} Slides)',
      slidesHint: 'Die Symbole der Grundprinzipien und die Nutzerdaten werden automatisch eingefügt. Hier konfigurieren Sie nur die visuelle Ebene und die Texte.',
      i18nHint: 'Mehrsprachig: der Titel jedes Slides wird über die Schaltfläche Bearbeiten in allen 7 Sprachen erfasst.',
      slidesFor: 'Folien konfigurieren für',
      slidesForGlobal: 'Global (alle OUs)',
      slidesForGlobalNote: 'Basiskonfiguration: Sie gilt für alle OUs ohne eigene Konfiguration.',
      slidesForCustomNote: '{{ou}} hat eine eigene Folienkonfiguration; sie gilt auch für ihre Unter-OUs ohne eigene.',
      slidesForInheritedNote: '{{ou}} verwendet die Konfiguration von {{from}}. Wenn Sie eine Folie ein- oder ausschalten, wird eine Konfiguration nur für {{ou}} erstellt.',
      slidesForRemoveCustom: 'Eigene Konfiguration entfernen',
      customizedOus: 'OUs mit eigener Konfiguration:',
      customizedOuCount: '{{count}} Folien',
      lastSlideOn: 'Mindestens eine Folie muss eingeschaltet bleiben.',
      colSlide: 'Slide',
      colPreview: 'Vorschau',
      colTitle: 'Titel',
      colActive: 'Aktiv',
      colActions: 'Aktionen',
      edit: 'Bearbeiten',
      titleMissing: 'Ohne Titel',
      needAllLangs: 'Es fehlen noch Sprachen (alle 7 sind erforderlich).',
      slides: {
        portada:    { name: 'Titelseite',                  hint: 'Begrüßungsbildschirm' },
        numeros:    { name: 'Ihr Jahr in Zahlen',          hint: 'Erhalten + gesendet' },
        define:     { name: 'Was Sie ausmacht',            hint: 'Meistempfangenes Grundprinzip (automatischer Wert)' },
        mensaje:    { name: 'Die Nachricht',               hint: 'Längste Anerkennung (automatischer Wert)' },
        quienes:    { name: 'Wer Sie anerkannt hat',       hint: 'Summen und Personen (automatischer Wert)' },
        red:        { name: 'Ihr Netzwerk',                hint: 'Verschiedene Bereiche, die Sie anerkannt haben (automatischer Wert)' },
        constancia: { name: 'Ihre Beständigkeit',          hint: 'Wochenserie (automatischer Wert)' },
        reto:       { name: 'Ihre Herausforderung fürs nächste Jahr', hint: 'Am wenigsten gezeigtes Grundprinzip und Handlungsaufruf' },
        ganador:    { name: 'Jahresgewinner:in',           hint: 'Wenn die Person gewonnen hat: echtes Abzeichen aus dem Bereich Gewinner:innen' },
      },
      notifyTitle: 'Recap-Benachrichtigung',
      notifyDesc: 'Informieren Sie die Mitarbeitenden im gewählten Geltungsbereich, dass ihr Recap {{year}} bereit ist.',
      preview: 'Vorschau',
      send: 'Benachrichtigung senden',
      notifyNeedsActive: 'Aktivieren Sie die Ausgabe, um sie benachrichtigen zu können.',
      notifyError: 'Die Benachrichtigung konnte nicht gesendet werden.',
      previewNote: 'So wird die Ausgabe durchlaufen: nur die aktiven Slides, mit ihren Hintergründen und Titeln. Die Zahlen stammen von der Person, die sie öffnet.',
      genericTitle: 'Generische Nachricht (Rückfall)',
      genericDesc: 'Wird angezeigt, wenn die Person im Zeitraum keine Anerkennungen hat oder eintritt, bevor das Recap sichtbar ist.',
      genericTitleLabel: 'Titel der generischen Nachricht',
      genericDescLabel: 'Untertitel / Beschreibung',
      genericNote: 'Diese Nachricht ist der Rückfall: wer Daten hat, sieht sein personalisiertes Recap.',
      imageUrlPlaceholder: 'URL des Bildes (PNG / JPG)',
      historyTitle: 'Recap-Historie und Jahresgewinner:innen',
      historyDesc: 'Registrierte Ausgaben und die jeweils zugeordneten Jahresgewinner:innen.',
      colEdition: 'Ausgabe',
      colYear: 'Jahr',
      colScope: 'Geltungsbereich',
      colSlides: 'Slides',
      colWinners: 'Jahresgewinner:innen',
      colStatus: 'Status',
      winnersCount: '{{count}} Gewinner:innen',
      status: { activa: 'Aktiv', completada: 'Abgeschlossen', borrador: 'Entwurf', programada: 'Geplant' },
      editorTitle: 'Slide {{index}} bearbeiten',
      editorDescData: 'Konfigurieren Sie den Titel (7 Sprachen), den Hintergrund und den Text, der den dynamischen Wert begleitet. Die Vorschau aktualisiert sich beim Schreiben.',
      editorDescIcon: 'Konfigurieren Sie den Titel (7 Sprachen), den Hintergrund und das Symbol des Slides. Die Vorschau aktualisiert sich beim Schreiben.',
      titleLangs: 'Titel (7 Sprachen)',
      titlePlaceholder: 'Titel auf {{lang}}',
      autoIcon: 'Das Symbol dieses Slides ist automatisch: es verwendet das echte Abzeichen der gewinnenden Person aus dem Bereich Gewinner:innen.',
      icon: 'Symbol',
      iconPlaceholder: 'Emoji oder Bild-URL',
      numberLabels: 'Text unter den Zahlen',
      numberLabelsHint: 'Die Zahlen berechnet die Plattform; hier legen Sie das Wort darunter fest.',
      numberLabelPlaceholder: 'z. B.: erhalten',
      background: 'Hintergrund',
      uploadPhoto: 'Foto hochladen',
      uploadingPhoto: 'Wird hochgeladen…',
      removePhoto: 'Foto entfernen',
      photoHint: 'PNG · empfohlene Größe 1080 × 1920 px · max. 5 MB. Das Foto liegt über der Farbe, die als Ersatz bleibt.',
      photoErrPng: 'Der Hintergrund muss ein PNG-Bild sein.',
      photoErrSize: 'Das Bild ist größer als 5 MB.',
      photoErrUpload: 'Das Bild konnte nicht hochgeladen werden. Versuche es erneut.',
      photoErrNotPng: 'Die Datei hat die Endung .png, ist aber eigentlich {{formato}}. Speichere sie als PNG und lade sie erneut hoch.',
      photoErrRejected: 'Der Server hat das Bild abgelehnt: {{motivo}}',
      photoErrUnavailable: 'Das Hochladen von Hintergründen ist in dieser Umgebung noch nicht verfügbar (404). Wende dich an den Support.',
      photoErrForbidden: 'Du hast keine Berechtigung, Recap-Hintergründe hochzuladen.',
      photoErrUploadCode: 'Das Bild konnte nicht hochgeladen werden (Code {{codigo}}). Versuche es erneut; wende dich sonst an den Support.',
      previewLabel: 'Vorschau',
      previewDataNote: 'Die angezeigten Zahlen stammen von der Person, die ihr Recap öffnet.',
      apply: 'Anwenden',
    },
  },
  // ── WP-16 REQ-140 — Rechtliche Modale ──
  legal: {
    privacy: 'Datenschutzerklärung',
    legal: 'Teilnahmebedingungen des Programms',
    reachedEnd: 'Sie haben das Ende erreicht!',
    scrollHint: 'Scrolle bis zum Ende, um zu akzeptieren',
    accept: 'Ich akzeptiere',
    acceptError: 'Wir konnten deine Zustimmung nicht speichern. Prüfe deine Verbindung und versuche es erneut; besteht das Problem weiter, wende dich an den Support.',
    loadError: 'Das Dokument konnte nicht geladen werden.',
    pdfError: 'Das PDF-Dokument konnte nicht angezeigt werden.',
    retry: 'Erneut versuchen',
    openInNewTab: 'In neuem Tab öffnen',
  },
  // ── WP-16 REQ-139 — Standalone-Registrierung Frontline ──
  register: {
    backToLogin: '← Zurück zur Anmeldung',
    entraTitle: 'Hast du bereits eine geschäftliche E-Mail?',
    entraSub: 'Du musst dich nicht registrieren — melde dich direkt mit deinem Sigma-Konto an.',
    title: 'Registrierung',
    subtitle: 'Erstelle deinen Zugang zum Nominierungsprogramm.',
    fullName: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    ou: 'Organisationseinheit (OU)',
    selectOu: 'Wähle deine Organisationseinheit (OU) aus',
    startDate: 'Eintrittsdatum bei Sigma',
    employeeId: 'Personalnummer',
    bu: 'Geschäftsbereich',
    site: 'Standort',
    department: 'Abteilung',
    selectBu: 'Wähle deinen Geschäftsbereich aus',
    selectSite: 'Wähle deinen Standort aus',
    selectDepartment: 'Wähle deine Abteilung aus',
    errName: 'Bitte gib deinen vollständigen Namen ein.',
    errEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    errOu: 'Bitte wähle deine Organisationseinheit (OU) aus.',
    errCatalogs: 'Bitte vervollständige die Angaben zu Geschäftsbereich, Standort und Abteilung.',
    errStartDate: 'Bitte gib dein Eintrittsdatum ein.',
    errEmployeeId: 'Bitte gib deine Personalnummer ein.',
    catalogsError: 'Die Kataloge konnten nicht geladen werden.',
    submit: 'Registrieren',
    submitError: 'Die Registrierung konnte nicht abgeschlossen werden.',
    checkEmailTitle: 'Überprüfe dein E-Mail-Postfach',
    checkEmailSub: 'Wir haben einen Bestätigungslink an {{email}} gesendet.',
    verified: 'E-Mail-Adresse bestätigt',
    allSet: 'Alles bereit!',
    allSetSub: 'Dein Konto ist eingerichtet. Du kannst jetzt deine Kolleg:innen nominieren.',
    password: 'Passwort (mind. 8 Zeichen)',
    confirmPassword: 'Passwort bestätigen',
    errPassword: 'Das Passwort muss zwischen 8 und 256 Zeichen lang sein.',
    errPasswordMatch: 'Die Passwörter stimmen nicht überein.',
    errLegal: 'Du musst die Nutzungsbedingungen akzeptieren.',
    errLegalVersion: 'Das Rechtsdokument konnte nicht geladen werden. Bitte erneut versuchen.',
    errPrivacy: 'Du musst den Datenschutzhinweis akzeptieren.',
    errLocalId: 'Bitte gib deine lokale Mitarbeiter-ID (bis zu 8 Stellen) ein.',
    errDepartment: 'Bitte wähle deine Abteilung aus.',
    acceptPrivacy: 'Ich habe den Datenschutzhinweis gelesen und akzeptiert',
    acceptLegalBases: 'Ich habe die Nutzungsbedingungen gelesen und akzeptiert',
    privacyLink: 'Datenschutzhinweis',
    legalLink: 'Nutzungsbedingungen',
    localId: 'Lokale Mitarbeiter-ID / Personalnummer',
    policyPlaceholder: 'Lies das vollständige Dokument. Anschließend kannst Du es akzeptieren.',
    createdTitle: 'Konto erstellt',
    createdSub: 'Du kannst dich jetzt mit deiner E-Mail und deinem Passwort anmelden. Nach der Anmeldung kannst Du deinen Avatar auswählen.',
    checkEmailHint: 'Öffne den Link, um deine E-Mail-Adresse zu bestätigen und dich anmelden zu können. Der Link ist 24 Stunden gültig.',
    resend: 'E-Mail erneut senden',
    resendDone: 'Wenn dein Konto noch bestätigt werden muss, haben wir dir einen weiteren Link gesendet (24 Stunden gültig). Prüfe auch deinen Spam-Ordner. Wenn du es bereits bestätigt hast, melde dich mit deiner E-Mail-Adresse und deinem Passwort an.',
    errOuNotFound: 'Wir haben diese Organisation nicht gefunden. Wähle eine andere aus der Liste.',
    errOuUnavailable: 'Die Registrierung ist für die ausgewählte Organisation nicht verfügbar.',
    errNoMatch: 'Wir konnten deine Angaben nicht mit den Unternehmensdaten abgleichen. Prüfe, ob deine Organisationseinheit und deine Personalnummer (oder deine Local ID, wenn du in Europa bist) stimmen. Wenn du dich bereits registriert hast, melde dich an oder setze dein Passwort zurück. Besteht das Problem weiter, wende dich an die Personalabteilung.',
    errEmailInUse: 'Mit dieser E-Mail-Adresse ist bereits ein Konto verknüpft.',
    corporateEmail: 'Das ist eine Unternehmens-E-Mail-Adresse, und du hast bereits Zugang über die Sigma-Anmeldung (SSO). Sie kann daher nicht zur Registrierung verwendet werden. Melde dich mit deinem Sigma-Konto an.',
    errNetwork: 'Verbindung nicht möglich. Prüfe deine Verbindung und versuche es erneut.',
    errTooMany: 'Zu viele Versuche. Warte einen Moment und versuche es erneut.',
    errServer: 'Bei uns ist ein Problem aufgetreten, und die Registrierung konnte nicht abgeschlossen werden. Versuche es in einigen Minuten erneut. Wenn es weiter auftritt, nenne dem Support diese Referenz: {{referencia}}.',
    verifyConfirmTitle: 'Bestätige deine E-Mail-Adresse',
    verifyConfirmSub: 'Klicke auf die Schaltfläche, um die Bestätigung deiner E-Mail-Adresse abzuschließen und dein Konto zu aktivieren.',
    verifyConfirmCta: 'Meine E-Mail bestätigen',
    verifyAlready: 'Deine E-Mail-Adresse ist bereits bestätigt',
    verifyAlreadySub: 'Du musst nichts weiter tun: Du kannst dich jetzt anmelden.',
    verifyTemporary: 'Wir konnten deine E-Mail-Adresse gerade nicht bestätigen',
    verifyTemporarySub: 'Der Link ist weiterhin gültig. Prüfe deine Verbindung und versuche es erneut.',
    verifyRetry: 'Erneut versuchen',
    errPayrollTaken: 'Mit dieser Personalnummer ist bereits ein Konto verknüpft.',
    payrollTakenAction: 'Wenn du dich bereits registriert hast, kannst du dich direkt in deinem Konto anmelden oder dein Passwort zurücksetzen, falls du es vergessen hast.',
    payrollTakenRecover: 'Passwort wiederherstellen',
    linkInvalidTitle: 'Der Link ist nicht mehr gültig',
    linkInvalidBody: 'Leider ist dieser Bestätigungslink abgelaufen oder wurde aus Sicherheitsgründen ungültig gemacht.',
    linkInvalidHint: 'Wenn du diesen Zugang angefordert hast, fordere bitte in unserer Anwendung einen neuen an. Wenn du diese Website nicht kennst, kannst du diese Nachricht bedenkenlos ignorieren.',
    linkInvalidCta: 'Zur Startseite',
    checkEmailWrong: 'Nicht deine E-Mail-Adresse? Korrigiere sie',
    verifyEmailTaken: 'Diese E-Mail-Adresse ist bereits registriert',
    verifyEmailTakenSub: 'Jemand anderes hat diese E-Mail-Adresse zuerst bestätigt. Wenn sie dir gehört, melde dich an oder setze dein Passwort zurück; wenn nicht, registriere dich erneut mit deiner eigenen E-Mail-Adresse.',
  },
  // ── Anmeldung (RF-002) ──
  login: {
    title: 'Anmelden',
    subtitle: 'Anerkennungsprogramm',
    entraRouteTitle: 'Mit deiner geschäftlichen E-Mail anmelden',
    entraRouteSub: 'Verwende dein Sigma-Konto (Entra ID).',
    entra: 'Mit Sigma-E-Mail anmelden',
    frontlineRouteTitle: 'Keine geschäftliche E-Mail?',
    frontlineRouteSub: 'Melde dich mit deiner E-Mail und deinem Passwort an.',
    email: 'E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Anmeldung…',
    or: 'oder',
    toRegister: 'Noch kein Konto? Registrieren',
    noAccountLede: 'Kein institutionelles Konto?',
    noAccountSub: 'Verwende eine private E-Mail',
    alreadyRegisteredLede: 'Schon registriert?',
    hasInstitutionalEmailLede: 'Hast du eine geschäftliche E-Mail?',
    register: 'Registrieren',
    back: 'Zurück',
    forgot: 'Passwort vergessen?',
    forgotIntro: 'Gib deine E-Mail-Adresse ein und wir schicken dir einen Link, um ein neues Passwort zu erstellen.',
    forgotSubmit: 'Link zusenden',
    forgotSent: 'Wenn diese Adresse registriert ist, haben wir dir einen Link geschickt. Er läuft in 60 Minuten ab.',
    resendVerification: 'Keine Bestätigungs-E-Mail erhalten?',
    resendIntro: 'Gib deine E-Mail-Adresse ein und wir schicken dir einen neuen Bestätigungslink.',
    resendSubmit: 'E-Mail erneut senden',
    resendSent: 'Wenn dein Konto noch bestätigt werden muss, haben wir dir einen weiteren Link gesendet (24 Stunden gültig). Prüfe auch deinen Spam-Ordner. Wenn du es bereits bestätigt hast, melde dich mit deiner E-Mail-Adresse und deinem Passwort an.',
    errNotVerified: 'Deine E-Mail-Adresse ist noch nicht bestätigt. Öffne den Link, den wir dir gesendet haben, oder fordere über „Keine Bestätigungs-E-Mail erhalten?“ einen neuen an.',
    errInactive: 'Dein Konto ist deaktiviert. Wende dich an die Personalabteilung.',
    errTempExpired: 'Dein temporäres Passwort ist abgelaufen. Fordere bei der Personalabteilung ein neues an.',
    errNetwork: 'Verbindung nicht möglich. Prüfe deine Verbindung und versuche es erneut.',
    corporateEmailHint: 'Das ist eine Unternehmens-E-Mail-Adresse: Melde dich mit deinem Sigma-Konto an, ohne Passwort.',
    errRequired: 'Gib deine E-Mail und dein Passwort ein.',
    errCredentials: 'E-Mail oder Passwort falsch.',
  },
  // ── Gemeinsame Landingpage (Regel #3) ──
  landing: {
    question: 'Welche Fundamentals wollen wir heute anerkennen?',
    subtitle: 'Wähle einen Bereich, um deine Fundamentals zu leben',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Wie war dein Team im letzten Meeting? Sag ihnen, was dir aufgefallen ist 💬',
    shineHover: 'Willst du sehen, wer glänzt, und eine Kollegin nominieren?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  activate: {
    errTemporary: 'Wir konnten dein Konto gerade nicht aktivieren. Prüfe deine Verbindung und versuche es erneut; dein Link ist weiterhin gültig.',
  },
  reset: {
    titleTemporary: 'Wähle dein endgültiges Passwort',
    subtitleTemporary: 'Du hast dich mit einem temporären Passwort angemeldet. Wähle ein neues, um fortzufahren.',
    errTemporary: 'Wir konnten deine Anfrage gerade nicht verarbeiten. Prüfe deine Verbindung und versuche es erneut; dein Link ist weiterhin gültig.',
    title: 'Erstelle dein neues Passwort',
    subtitle: 'Wähle ein Passwort, um wieder hineinzukommen.',
    password: 'Neues Passwort (mind. 8 Zeichen)',
    confirmPassword: 'Passwort bestätigen',
    submit: 'Mein Passwort ändern',
    errPassword: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    errPasswordMatch: 'Die Passwörter stimmen nicht überein.',
    errInvalidLink: 'Der Link ist ungültig oder abgelaufen. Fordere auf der Anmeldeseite einen neuen an.',
    doneTitle: 'Passwort aktualisiert',
    doneSub: 'Du kannst dich jetzt mit deiner E-Mail-Adresse und deinem neuen Passwort anmelden.',
    noToken: 'Ungültiger Link',
    noTokenSub: 'Der Link ist ungültig oder unvollständig. Sieh in der E-Mail nach, die du erhalten hast.',
  },
  auth: {
    retryIn: 'Du kannst es in {{seconds}} s erneut versuchen',
    contactHR: 'Wenn Sie Probleme bei der Registrierung haben, wenden Sie sich an Ihr Human-Capital-Team.',
    errorTitle: 'Wir konnten nicht fortfahren',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Wähle deinen Avatar',
    subtitle: 'Wählen Sie das Bild, das Sie repräsentiert.',
    loading: 'Avatare werden geladen…',
    empty: 'Es sind noch keine Avatare verfügbar.',
    loadError: 'Avatare konnten nicht geladen werden.',
    saveError: 'Dein Avatar konnte nicht gespeichert werden.',
    saved: 'Avatar gespeichert',
    confirm: 'Bestätigen',
    required: 'Wähle deinen Avatar, um fortzufahren.',
    unavailable: 'Dieser Avatar ist nicht mehr verfügbar. Bitte wähle einen anderen.',
    change: 'Avatar ändern',
    continueWithout: 'Ohne Avatar fortfahren',
  },
  // ── WP-08 — Berichte zur Anerkennung ──
  reports: {
    title: 'Berichte',
    subtitle: 'Analytik des Anerkennungsprogramms. Zeigt nie Punkte an.',
    emptyScope: 'Dir ist innerhalb deines Bereichs keine Organisationseinheit zugewiesen.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      heatmap: 'Heatmap',
      network: 'ONA-Netzwerk',
      generational: 'Demografisch',
      leaders: 'Führungskräfte',
      moderation: 'Moderation',
      campaigns: 'Historie',
    },
    common: {
      loading: 'Berichte werden geladen…',
      error: 'Der Bericht konnte nicht geladen werden.',
      empty: 'Für die gewählten Filter gibt es keine Daten.',
      retry: 'Erneut versuchen',
      suppressedNote: 'Einige Aggregate wurden wegen der Anonymitätsschwelle ausgeblendet (weniger als 5).',
      suppressedNoteHelp: 'Wenn eine Gruppe weniger als 5 Personen hat, werden ihre aufgeschlüsselten Kennzahlen nicht veröffentlicht: Bei so wenigen ließe sich aus den Daten auf einzelne Personen schließen. Das ist weder ein Fehler noch eine fehlende Angabe.',
      colScope: 'Geltungsbereich (Einheiten)',
      colScopeHelp: 'Organisationseinheiten, an die sich die Kampagne richtete.',
      colAudienceHelp: 'Anzahl der Mitarbeitenden, an die sich die Kampagne richtete. Sie ist der Nenner der Teilnahmequote.',
      scopeAll: 'Gesamte Organisation',
      scopeMore: '+{{n}} weitere',
      masked: 'Aus Anonymitätsgründen ausgeblendet',
      showingRange: '{{desde}}–{{hasta}} von {{total}}',
      pageSize: 'Zeilen pro Seite',
      perPage: '{{n}} pro Seite',
      exportExcel: 'Nach Excel exportieren',
      yes: 'Ja',
      no: 'Nein',
    },
    context: {
      unifiedTitle: 'Einheitliche Kennzahlen',
      unifiedText: '— Tägliche Anerkennung und Shine Together verwenden dieselbe Zähllogik. Die Daten sind modulübergreifend konsistent.',
      auditTitle: 'Auditierung aktiv.',
      auditText: 'Jeder Download wird mit deinem Benutzer, der Registerkarte und dem Datum protokolliert.',
      showing: 'Anzeige:',
      wholeOrg: 'die gesamte Organisation',
    },
    filters: {
      allFundamentals: 'Alle Grundwerte',
      allOus: 'Alle OUs',
      site: 'Standort',
      allSites: 'Alle Standorte',
      dateFrom: 'Von',
      dateTo: 'Bis',
      reset: 'Leeren',
      ou: 'Einheit',
      fundamental: 'Fundamentals',
      dateRange: 'Daten',
      remove: 'Filter {{filter}} entfernen',
      person: 'Person',
      personPlaceholder: 'Person suchen…',
      openCalendar: "Kalender öffnen",
      personClear: 'Ausgewählte Person entfernen',
      personNoResults: 'Keine Treffer im Verzeichnis',
      personSearching: 'Suche läuft…',
      personError: 'Verzeichnis konnte nicht abgefragt werden',
    },
    notApplicable: {
      title_one: 'Der Filter {{filtros}} gilt nicht für diesen Bereich.',
      // `title_few` — inerter Alias von `title_other`, nur wegen der Schlüsselparität mit `ro`.
      title_few: 'Die Filter {{filtros}} gelten nicht für diesen Bereich.',
      title_other: 'Die Filter {{filtros}} gelten nicht für diesen Bereich.',
      and: 'und',
      reason: {
        embudo: 'Der Trichter teilt die gesamte Belegschaft in Stammnutzer, Gelegentliche und Inaktive auf; auf eine einzelne Person eingegrenzt wäre er keine Aufteilung mehr.',
        historico: 'Diese Zahlen gelten für „irgendwann“, nicht für den gewählten Zeitraum: Sie zählen jeden, der jemals jemanden nominiert hat, in seiner gesamten Historie auf der Plattform.',
        audienciaCampana: 'Diese Kennzahl wird über die von der Kampagne einberufene Zielgruppe berechnet, die unabhängig von den gewählten Grundwerten oder der Person gleich bleibt.',
        porBanda: 'Die Verteilung gruppiert Personen nach Generationsband; bei nur einer ausgewählten Person bliebe nur ein Band übrig, und es wäre keine Verteilung mehr.',
        porOu: 'Diese Ansicht gruppiert nach Organisationseinheit, nicht nach Person.',
        redOu: 'Die Knoten des Netzwerks sind Organisationseinheiten, keine Personen.',
        promedioPulso: 'Diese Tabelle stammt aus den durchschnittlichen Pulso-Werten (1-4) nach Generation und Grundwerten, nicht aus der Nominierungszahl oder der Personalzählung: Keiner der beiden Filter grenzt sie ein.',
        resumenCampana: 'Diese Kennzahl stammt aus der Zusammenfassung der gesamten Kampagne: Das Backend unterstützt keine Eingrenzung auf eine einzelne Person (wohl aber nach Grundwerten).',
        casosReportados: 'Der Bericht listet gemeldete FÄLLE auf, und den Meldegrund schreibt die meldende Person: Er ist nicht an einen Grundwert der Nominierung gebunden. OU, Zeitraum und Person grenzen diese Tabelle hingegen ein.',
        campanaFinalizada: "Die gewählte Kampagne ist beendet: Sie wird vollständig angezeigt, vom Beginn bis zum Ende.",
      },
    },
    daily: {
      title: 'Tägliche Anerkennung',
      subtitle: 'Nur Anerkennungen aus dem Alltag, ohne Kampagnen: gewählter vs. vorheriger Zeitraum, Beteiligungstrichter und Tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Gewählter Zeitraum',
      prevPeriod: 'Vorheriger Zeitraum',
      vsPrev: '{{variacion}} vs. Vorperiode · {{previo}}',
      fundamentalDistribution: 'Verteilung nach Grundwert',
      totalSentTitle: 'Gesendete Nominierungen insgesamt',
      totalSentHint: 'Summe aller im Zeitraum gesendeten Nominierungen',
      retiredFundamental: 'Zurückgezogener Grundwert',
      unresolvedFundamental: 'Grundwert (Katalog nicht verfügbar)',
      retiredFundamentalHint: 'Aus dem Katalog entfernter Grundwert: Er bleibt in der Historie, weil es Nominierungen damit gab, kann aber nicht mehr ausgewählt werden.',
      adoptionStaff: 'Staff-Nutzende',
      adoptionFrontline: 'Frontline-Nutzende',
      adoptionTotal: 'Nutzende insgesamt',
      noActivity: 'Ohne Aktivität',
      adoptionHint: '{{reconocedores}} von {{plantilla}} haben jemanden nominiert',
      adoptionTotalHint: '{{pct}} der Gesamtbelegschaft ({{plantilla}})',
      noActivityHint: 'Haben noch nie eine Nominierung gesendet',
      variation: 'Veränderung',
      sparkAria: 'Täglicher Trend für {{label}}: {{dias}} Tage, von {{primero}} bis {{ultimo}}',
      uniquePeople: 'Einzelpersonen',
      pares: 'Kollegen',
      lideres: 'Führungskräfte',
      groupRecognitions: 'Gruppenanerkennungen',
      groupRecognitionsHint: 'von {{total}} gesendet · an 2 oder mehr Personen',
      funnel: 'Beteiligungstrichter',
      funnelRange: 'Zeitraum: {{from}} – {{to}}',
      funnelPeople: '{{count}} Personen',
      topPeople: 'Top anerkannte Personen',
      topRecognizers: 'Top Anerkennende',
      topFundamentals: 'Top Grundprinzipien',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Täglich exportieren (6 Blätter)',
      colStage: 'Phase',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Name",
      colDepto: "Abteilung",
      colOu: "OU",
      colFundamental: "Grundwert",
      colRecos: 'Anerkennungen',
      colEnviados: "Gesendet",
      colCrossOu: "OU-übergreifend",
      colType: "Typ",
      crossOu: {
        si: "Ja",
        no: "Nein",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'E-Mail',
      colEmployeeId: 'Personalnummer',
      colRecognitions: 'Nominierungen',
      colDominantType: 'Dominanter Typ',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Management-Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetFunnel: 'Adoptionstrichter',
        sheetTopRecognized: 'Top Nominierte',
        sheetTopRecognizers: 'Top Nominierende',
        sheetAllRecognitions: 'Alle Nominierungen',
        sheetReceived: 'Erhaltene Anerkennungen',
        summaryTitle: 'Tägliche Anerkennung — Grundwerte des Arbeitsalltags',
        summarySubtitle: 'Kennzahlen des gewählten Zeitraums: wer nominiert, wen und wie häufig.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen — ganz ohne Datenkenntnisse.',
        funnelTitle: 'Adoptionstrichter',
        funnelSubtitle: 'Segmentierung nach der Häufigkeit der im Zeitraum gesendeten Nominierungen ({{rango}}), als Monatsdurchschnitt.',
        funnelEmpty: 'Keine Daten: Im Zeitraum gibt es keine Nominierungen.',
        topRecognizedTitle: 'Am häufigsten nominiert',
        topRecognizersTitle: 'Top Nominierende',
        rankingSubtitle: 'Rangliste auf Basis der Nominierungen dieses Zeitraums.',
        topRecognizersEmpty: 'Keine Daten: In diesem Zeitraum hat niemand eine Nominierung gesendet.',
        allRecognitionsTitle: 'Alle Nominierungen',
        allRecognitionsSubtitle: 'Rohdaten des Alltags im Zeitraum, ohne Kampagnen-Einsendungen: eine Zeile pro nominierter Person. Die Spaltennamen behalten ihre Originalform, damit die Pivot-Tabellen des Komitees weiter funktionieren.',
        allRecognitionsNoRange: 'Keine Daten: Der genaue Zeitraum ließ sich nicht bestimmen, weil die Aggregation durch die Anonymitätsschwelle unterdrückt ist und der Filter keine expliziten Daten enthält.',
        receivedTitle: 'Erhaltene Anerkennungen',
        receivedSubtitle: 'Anerkennungen des Zeitraums, die Personen der ausgewählten OUs erhalten haben, unabhängig von der OU der sendenden Person: eine Zeile pro anerkannter Person. Bei einer Gruppenanerkennung erscheinen nur die Personen dieser OUs.',
        receivedAllOus: 'Keine Einträge: Mit allen OUs entspricht das Erhaltene dem Gesendeten und steht bereits in „Alle Nominierungen“. Wählen Sie eine oder mehrere OUs, um hier zu sehen, was sie erhalten haben.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaFunnelMonth: 'Trichterzeitraum',
        metaGenerated: 'Erstellt',
        colKpi: 'KPI',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Kennzahl',
        colWhatIs: 'Was sie ist',
        colHowCalculated: 'Wie sie berechnet wird',
        colPercentOfTotal: '% des Gesamtwerts',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Verwaltung',
        colOperational: 'Operativ',
        colFundamental: 'Grundwert',
        colRank: '#',
        colArea: 'Bereich',
        colSite: 'Standort',
        headcountTitle: 'Belegschaft',
        headcountTotal: 'Gesamt',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Peers (eindeutige Nominierungen unter Peers)',
        kpiLeaders: 'Führungskräfte (eindeutige Nominierungen mit Beteiligung einer Führungskraft)',
        datumTeamRecognitions: 'Nominierungen an Teams',
        datumAudienceStaff: 'Zielgruppe Staff (Verwaltung)',
        datumAudienceFrontline: 'Zielgruppe Frontline (operativ)',
        datumComparison: 'Vorheriger Zeitraum und Veränderung',
        datumRankings: 'Top Nominierte / Top Nominierende',
        datumLeader: 'Führungskraft',
        whatRecognitionsMade: 'Wie viele Nominierungen im Zeitraum insgesamt gesendet wurden, mit den angewendeten Filtern.',
        calcRecognitionsMade: 'Die Nominierungen aus dem Alltag mit Datum im gewählten Zeitraum werden summiert. Die zu einer Kampagne gehörenden werden im Bericht «Shine Together» gezählt.',
        whatUniqueRecognized: 'Wie viele verschiedene Personen mindestens eine Nominierung erhalten haben. Wer fünf erhalten hat, zählt nur einmal.',
        calcUniqueRecognized: 'Gezählt werden die verschiedenen Personen, die im Zeitraum als Empfangende auftreten.',
        whatTeamRecognitions: 'Eine Nominierung gilt als Gruppennominierung, wenn sie mehr als eine empfangende Person hat.',
        calcTeamRecognitions: 'Die Spalte «Recognition type» im Blatt «Alle Nominierungen» kennzeichnet jede Zeile als Individual oder Grupal.',
        whatPeers: 'Nominierungen, bei denen weder die sendende noch die empfangende Person Mitarbeitende führt: Kollege zu Kollege, Führungskraft zu Führungskraft, Manager zu Manager.',
        calcPeers: 'Gefiltert werden die Nominierungen unter Peers innerhalb des Zeitraums.',
        whatLeaders: 'Nominierungen, an denen mindestens eine Person mit Führungsverantwortung beteiligt ist.',
        calcLeaders: 'Gefiltert werden die Nominierungen, bei denen die sendende oder die empfangende Person eine Rolle als Führungskraft, Supervisor oder Manager hat.',
        whatStaffAdoption: 'Von allen Büromitarbeitenden (Staff) der Anteil, der im Zeitraum bereits jemanden nominiert hat.',
        calcStaffAdoption: 'Staff-Personen mit mindestens einer im Zeitraum gesendeten Nominierung, geteilt durch die gesamte Staff-Belegschaft des Geltungsbereichs.',
        whatFrontlineAdoption: 'Von allen Personen in Betrieb oder Werk (Frontline) der Anteil, der im Zeitraum bereits jemanden nominiert hat.',
        calcFrontlineAdoption: 'Frontline-Personen mit mindestens einer im Zeitraum gesendeten Nominierung, geteilt durch die gesamte Frontline-Belegschaft des Geltungsbereichs.',
        whatTotalUsers: 'Wie viele Personen im Geltungsbereich seit Bestehen ihres Kontos jemals mindestens eine Nominierung gesendet haben.',
        calcTotalUsers: 'Personen mit mindestens einer gesendeten Nominierung in ihrer gesamten Historie. Unabhängig vom gewählten Zeitraum: der Wert stammt aus der täglichen Erhebung.',
        whatNoActivity: 'Personen, die seit Bestehen ihres Kontos noch nie eine einzige Nominierung gesendet haben.',
        calcNoActivity: 'Gesamtbelegschaft des Geltungsbereichs abzüglich der Personen mit mindestens einer gesendeten Nominierung in ihrer gesamten Historie.',
        whatAudienceStaff: 'Personen mit einem Entra-ID-Firmenkonto.',
        whatAudienceFrontline: 'Personen, die sich mit ihrer eigenen E-Mail-Adresse auf der Plattform registrieren.',
        whatPrevPeriod: 'Nominierungen, die in denselben Tagen unmittelbar vor dem gewählten Zeitraum gesendet wurden.',
        whatVariation: 'Wie stark das Nominierungsvolumen gegenüber dem gleichwertigen Vorzeitraum gestiegen oder gefallen ist.',
        calcVariation: 'Der Vorzeitraum umfasst dieselben Tage unmittelbar vor dem gewählten. Die Veränderung ist die Differenz beider, geteilt durch den Gesamtwert des Vorzeitraums.',
        whatFunnel: 'Segmentiert den Geltungsbereich nach Sendehäufigkeit im gewählten Zeitraum, demselben wie oben: Regelmäßige (im Durchschnitt vier oder mehr pro Monat), Gelegentliche (mindestens eine, unter diesem Durchschnitt) und Inaktive (keine). Bei Zeiträumen unter einem Monat gilt die Schwelle eines Monats. Jede Stufe wird nach Verwaltung und operativ aufgeschlüsselt.',
        calcFunnel: 'Prozentsatz und Spalte Personen werden auf die Belegschaft des Geltungsbereichs bezogen. Verwaltung und operativ zählen dieselben Personen nach Stellentyp und bleiben leer, wenn diese Einstufung nicht verfügbar ist.',
        whatRankings: 'Die am häufigsten nominierten Personen und jene, die am meisten nominieren, bis zu 200 pro Liste.',
        calcRankings: 'Sortiert nach der Zahl der erhaltenen oder gesendeten Nominierungen. Wer die Anonymitätsschwelle nicht erreicht, erscheint maskiert.',
        whatAllRecognitions: 'Rohdaten des Zeitraums, eine Zeile pro Kandidat: die vollständigen Blöcke Nominee, OnBehalfOf und Candidate, das Datum, die Matrix der aktiven Habits und die Audit-Kennzeichen. Personen werden nicht maskiert: Es ist die Arbeitsquelle des Komitees, und die Anonymitätsschwelle gilt für aggregierte Berichte. Enthalten sind auch Nominierungen aus laufenden Shine-Together-Kampagnen, denn der Tagesbericht zählt sie alle.',
        calcAllRecognitions: 'Vollständige Liste der Nominierungen des Zeitraums. Die Habit-Spalten enthalten nur die zum Exportzeitpunkt im Katalog aktiven. Die Spalte Reco_ID bleibt leer, weil das System noch keine eindeutige Kennung je Zeile erzeugt.',
        whatGroupRecognitions: 'Wie viele der gesendeten Anerkennungen an zwei oder mehr Personen gingen. Jede Gruppenanerkennung zählt einmal, egal wie viele Personen sie anerkennt.',
        calcGroupRecognitions: 'Gezählt werden Anerkennungen mit zwei oder mehr anerkannten Personen. „Alle Nominierungen“ hat eine Zeile pro anerkannter Person und kann daher mehr Zeilen haben als die Gesamtzahl der gesendeten Anerkennungen.',
        whatReceived: 'Detail dessen, was Personen der im Filter ausgewählten OUs erhalten haben, auch wenn die anerkennende Person zu einer anderen OU gehört (Cross-OU-Anerkennungen).',
        calcReceived: 'Aufgenommen wird jede anerkannte Person, deren OU zu den ausgewählten gehört (einschließlich ihrer untergeordneten Einheiten). Eine Person ohne OU zählt mit der OU der Person, die sie anerkannt hat. Mit allen OUs bleibt das Blatt ohne Einträge.',
        noteLeader: 'Eine Rolle gilt als Führungskraft, wenn ihr Mitarbeitende unterstellt sind.',
        masked: 'Aus Anonymitätsgründen ausgeblendet',
      },
    },
    shine: {
      pointsAwarded: 'Vergebene Punkte',
      pointsAwardedHint: '{{nominaciones}} Nominierungen · {{personas}} Personen',
      personaNoFiltraCampanas: 'Der Filter Person gilt nicht für die Kampagnenliste: Sie wird nach OE und Status eingegrenzt.',
      personaEnElReporte: "Mit Person zeigt der Bericht, was diese Person in der Kampagne gesendet oder erhalten hat; „Abgegebene Anerkennungen“ und das Ranking zählen nur, was sie gesendet hat.",
      title: 'Gemeinsam Strahlen',
      subtitle: 'Nominierungsranking der Kampagne und Live-KPIs.',
      recognitionsMade: 'Abgegebene Anerkennungen',
      uniqueRecognized: 'Eindeutig anerkannte Personen',
      uniqueRecognizers: 'Eindeutige anerkennende Personen',
      participationRate: 'Beteiligungsquote',
      totalHeadcount: 'Gesamtbelegschaft',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Shine exportieren (7 Blätter)',
      exporting: 'Wird exportiert…',
      exportError: 'Der Download konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      exportTooLarge: 'Der Bericht überschreitet 200.000 Zeilen pro Blatt. Grenze den Zeitraum oder die Filter ein und exportiere erneut.',
      winnersFormat: 'Format des Gewinner:innen-Exports',
      datesFromCampaign: "Die Daten wurden an den Zeitraum der gewählten Kampagne angepasst; Sie können sie ändern.",
      rankingCountsPeople: "Die Karten zählen Anerkennungen, das Ranking zählt Personen: Eine Gruppenanerkennung zählt oben einmal und hier einmal pro Person, daher können die Zahlen abweichen.",
      winnersOnlyExpired: "Verfügbar, sobald die Kampagne abgelaufen ist: Vorher gibt es keine Gewinner.",
      winnersEmpty: "Für diese Kampagne sind noch keine Gewinner erfasst.",
      formatRaw: 'Roh',
      formatCascaded: 'Kaskadiert',
      exportWinners: 'Gewinner:innen exportieren',
      colPos: 'Platzierung',
      kpiTotal: 'Gesamt',
      kpiParticipants: 'Teilnehmende',
      kpiParticipation: 'Teilnahme',
      kpiAvgPerPerson: 'Durchschnitt pro Person',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Kampagne',
      campaignScope: "Reichweite der Kampagne:",
      allCampaigns: "Alle Kampagnen",
      scopeOnlyCoversAll: "Diese Kampagne umfasst nur {{alcance}}; andere OUs sind in diesem Bericht nicht enthalten.",
      scopeOnlyCoversSome: "Diese Kampagne umfasst nur {{alcance}}. Außerhalb ihrer Reichweite: {{fuera}}.",
      campaignStatusLabel: "Kampagnenstatus",
      campaignStatus: { activa: "Aktiv", finalizada: "Abgelaufen" },
      noCampaigns: "Keine Kampagnen mit diesem Status für die gewählten OUs",
      campaignsForbidden: 'Sie haben keine Berechtigung, Kampagnen anzuzeigen',
      campaignsLoadError: 'Die Kampagnen konnten nicht geladen werden',
      filtersHelp: "Wählen Sie zuerst die OU: Die Kampagnenliste hängt davon ab. Danach Status und Kampagne, die maßgeblich ist: Die Zahlen stammen aus ihrem Geltungsbereich. Site, Fundamental und Person grenzen innerhalb dieses Bereichs ein. Der Datumsbereich gilt nur für aktive Kampagnen; eine abgelaufene wird vollständig ausgewertet.",
      filtersHelpAria: "Wie die Filter mit der Kampagne zusammenwirken",
      modalidadSelector: 'Shine-Together-Filter',
      daysLeft: 'Verbleibende Tage',
      activeOus: 'Aktive OUs',
      modalidadTodos: 'Alle Nominierten',
      modalidadPersonaUnica: 'Nur einzelne Empfangende',

      modalidadGrupal: 'Nur Gruppe (Team)',
      modalidadCrossOu: 'OU-übergreifend',
      pickCampaign: "Wähle zuerst eine Kampagne aus.",
      habitsRanking: 'Ranking der Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Anerkennungen',
      colName: 'Name',
      colBu: 'BU',
      colDept: 'Abteilung',
      colOrigin: 'Herkunft',
      filterHabitsByFundamental: 'Tägliche Verhaltensweisen nach Grundwert filtern',
      allFundamentals: 'Alle Grundwerte',
      colCount: 'Anerkennungen',
      colOu: 'OU',
      colCountry: 'Land',
      colBadge: 'Abzeichen',
      colCrossed: 'Gekreuzter Ursprung',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-Mail',
      colEmployeeId: 'Personalnummer',
      colCrossOu: 'OU-übergreifend',
      colDominantType: 'Vorherrschender Typ',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Staff-Nutzer',
      adoptionFrontline: 'Frontline-Nutzer',
      adoptionTotal: 'Nutzer insgesamt',
      noActivity: 'Ohne Aktivität',
      adoptionHint: '{{reconocedores}} von {{plantilla}} haben nominiert',
      adoptionTotalHint: '{{pct}} des Gesamtbestands ({{plantilla}})',
      noActivityHint: 'Haben noch nie nominiert',
      clearAll: 'Alles löschen',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        kpiCrossOu: 'OE-übergreifende Anerkennungen',
        whatCrossOu: 'Anerkennungen, bei denen mindestens eine anerkannte Person zu einer anderen OE gehört als die anerkennende Person.',
        calcCrossOu: 'Einmal pro Anerkennung gezählt: Es genügt eine anerkannte Person aus einer anderen OE. Ist die OE einer anerkannten Person unbekannt, zählt das nicht als Übergang.',
        datumAwardsPoints: 'Die Kampagne vergibt Punkte',
        whatAwardsPoints: '{{valor}}. Zeigt, ob die Anerkennungen dieser Kampagne den anerkannten Personen Punkte bringen.',
        calcAwardsPoints: 'Aus der Kampagnenkonfiguration („Punkte vergeben“). Punkte sehen nur Punkte-Administratoren.',
        sheetReceivedRecognitions: 'Alle erhaltenen Anerkennungen',
        receivedRecognitionsTitle: 'Alle erhaltenen Anerkennungen',
        receivedRecognitionsSubtitle: "Dieselben Spalten wie «Alle Anerkennungen», mit dem, was die Personen der gefilterten OU (oder der OU der exportierenden Person) in allen Brillamos-Kampagnen des Zeitraums erhalten haben. Die Spalte Campaign nennt die jeweilige Kampagne.",
        sheetSummary: 'Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetDistribution: 'Verteilung Grundwert',
        sheetFunnel: 'Adoptions-Funnel',
        sheetTopRecognized: 'Meistnominierte',
        sheetTopRecognizers: 'Top-Nominierende',
        sheetAllRecognitions: 'Alle Nominierungen',
        summaryTitle: 'Kampagne Shine Together',
        definitionsTitle: 'Was bedeutet welche Angabe?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen, ganz ohne Datenkenntnisse.',
        distributionTitle: 'Verteilung nach Grundwert',
        distributionSubtitle: 'Anteil berechnet aus den Nominierungen dieser Kampagne.',
        distributionChart: 'Nominierungen nach Grundwert',
        distributionNote: 'Eine Nominierung kann mehrere Grundwerte oder mehrere tägliche Verhaltensweisen zugleich enthalten, und jede wird einzeln gezählt: Die Summen dieser Tabelle müssen daher weder der Gesamtzahl der Kampagne noch der Zahl ihres Grundwerts entsprechen.',
        distributionEmpty: 'Keine Daten: Die Kampagne hat im Zeitraum keine Nominierung mit erfasstem Grundwert.',
        funnelTitle: 'Adoptions-Funnel',
        funnelSubtitle: 'Segmentierung nach der Häufigkeit der im Kampagnenzeitraum gesendeten Nominierungen.',
        funnelEmpty: 'Keine Daten: Die Kampagne hat im Zeitraum keine Nominierungen.',
        topRecognizedTitle: 'Meistnominierte Personen',
        topRecognizersTitle: 'Top-Nominierende',
        rankingSubtitle: 'Rangliste berechnet aus den Nominierungen dieser Kampagne.',
        topRecognizersEmpty: 'Keine Daten: In dieser Kampagne hat niemand jemanden nominiert.',
        allRecognitionsTitle: 'Alle Nominierungen',
        allRecognitionsSubtitle: 'Rohdaten der Kampagne: eine Zeile je nominierter Person. Die Spaltennamen bleiben in ihrer Originalform, damit die Pivot-Tabellen des Komitees weiter funktionieren.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaScope: 'Geltungsbereich',
        whatPointsAwarded: 'Summe der gültigen Punkte, die die Kampagne jeder anerkannten Person vergeben hat, im Zeitraum und Geltungsbereich des Berichts. Nur für Punkte-Administratoren.',
        noPoints: "Keine Punkte",
        metaGenerated: 'Erstellt',
        colKpi: 'KPI',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Angabe',
        colWhatIs: 'Was es ist',
        colHowCalculated: 'Berechnung',
        colFundamentals: 'Grundwerte',
        colPercentOfTotal: '% der Gesamtzahl',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Verwaltung',
        colOperational: 'Produktion',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Grundwert',
        colRank: '#',
        colArea: 'Bereich',
        colSite: 'Standort',
        headcountTitle: 'Belegschaft',
        headcountTotal: 'Gesamt',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Kolleginnen und Kollegen (eindeutige Nominierungen unter Gleichrangigen)',
        kpiLeaders: 'Führungskräfte (eindeutige Nominierungen mit Beteiligung einer Führungskraft)',
        kpiTotalSent: 'Gesendete Nominierungen insgesamt',
        kpiIndividual: 'Nominierungen an eine einzelne Person insgesamt',
        kpiGroup: 'Nominierungen an Gruppen insgesamt',
        kpiPeopleInGroup: "In Gruppenanerkennungen anerkannte Personen",
        whatPeopleInGroup: "Wie viele Personen die Gruppenanerkennungen erhalten haben: eine Gruppenanerkennung an 5 Personen zählt 5.",
        calcPeopleInGroup: "Summe der Empfänger jeder Anerkennung mit mehr als einem, mit denselben Filtern wie die übrigen KPIs.",
        kpiTotalNominations: "Nominierungen gesamt (eine pro anerkannter Person)",
        whatTotalNominations: "An eine einzelne Person + In Gruppenanerkennungen anerkannte Personen. Das ist die Einheit des Blatts «Alle Anerkennungen», das eine Zeile pro Person hat.",
        calcTotalNominations: "Anerkennungen an eine einzelne Person + In Gruppenanerkennungen anerkannte Personen. Nicht zu verwechseln mit «Gesendete Anerkennungen gesamt» (= einzelne Person + Gruppe), das jede Anerkennung einmal zählt. «Alle Anerkennungen» listet außerdem ausgeblendete oder gemeldete Nominierungen (mit ihrem Status) und solche, die über «an Gemeinsam Strahlen senden» aus einer anderen Kampagne kamen; die Spalte Reco_ID fasst die Zeilen derselben Anerkennung zusammen.",
        datumTeamRecognitions: 'Nominierungen an Teams',
        datumAudienceStaff: 'Zielgruppe Staff (Verwaltung)',
        datumAudienceFrontline: 'Zielgruppe Frontline (Produktion)',
        datumLeader: 'Führungskraft',
        whatRecognitionsMade: 'Wie viele Nominierungen innerhalb der Kampagne insgesamt gesendet wurden, mit den angewendeten Filtern.',
        calcRecognitionsMade: 'Alle Nominierungen mit Datum innerhalb des Kampagnenzeitraums werden addiert.',
        whatUniqueRecognized: 'Wie viele verschiedene Personen mindestens eine Nominierung erhalten haben. Wer fünf erhalten hat, zählt einmal.',
        calcUniqueRecognized: 'Gezählt werden die verschiedenen Personen, die im Zeitraum als Empfangende auftreten.',
        whatTeamRecognitions: 'Eine Nominierung gilt als Gruppennominierung, wenn sie mehr als eine empfangende Person hat.',
        calcTeamRecognitions: 'Gezählt werden Nominierungen mit zwei oder mehr Empfangenden.',
        whatIndividual: 'Nominierungen der Kampagne, die an eine einzelne Person gerichtet sind.',
        calcIndividual: 'Gezählt werden Nominierungen mit genau einer empfangenden Person.',
        whatPeers: 'Nominierungen, bei denen weder die sendende noch die empfangende Person Mitarbeitende führt: Kollegin zu Kollege, Führungskraft zu Führungskraft, Leitung zu Leitung.',
        calcPeers: 'Es werden die Nominierungen unter Gleichrangigen innerhalb dieser Kampagne gefiltert.',
        whatLeaders: 'Nominierungen, an denen mindestens eine Person mit Führungsverantwortung beteiligt ist.',
        calcLeaders: 'Es werden die Nominierungen gefiltert, bei denen die sendende oder die empfangende Person eine Rolle als Führungskraft, Supervisor oder Manager hat.',
        whatStaffAdoption: 'Von allen Büroangestellten (Staff) der Anteil, der in dieser Kampagne bereits jemanden nominiert hat.',
        calcStaffAdoption: 'Staff-Personen mit mindestens einer gesendeten Nominierung in der Kampagne, geteilt durch alle Staff-Personen ihrer Zielgruppe.',
        whatFrontlineAdoption: 'Von allen Personen in Betrieb oder Werk (Frontline) der Anteil, der in dieser Kampagne bereits jemanden nominiert hat.',
        calcFrontlineAdoption: 'Frontline-Personen mit mindestens einer gesendeten Nominierung in der Kampagne, geteilt durch alle Frontline-Personen ihrer Zielgruppe.',
        whatTotalUsers: 'Wie viele Personen der Kampagnen-Zielgruppe innerhalb der Kampagne mindestens eine Nominierung gesendet haben.',
        calcTotalUsers: 'Personen mit mindestens einer gesendeten Nominierung im Kampagnenzeitraum. Es ist keine lebenslange Gesamtzählung.',
        whatNoActivity: 'Personen der Zielgruppe, die während der Kampagne keine Nominierung gesendet haben.',
        calcNoActivity: 'Zielgruppe der Kampagne abzüglich der Personen mit mindestens einer darin gesendeten Nominierung.',
        whatAudienceStaff: 'Personen mit einem Entra-ID-Firmenkonto.',
        whatAudienceFrontline: 'Personen, die sich mit ihrer eigenen E-Mail-Adresse auf der Plattform registrieren.',
        whatParticipationRate: 'Anteil der Zielgruppe, der an der Kampagne teilgenommen hat, indem er mindestens eine Anerkennung gesendet hat.',
        calcParticipationRate: 'Teilnehmende geteilt durch die Zielgruppe der Kampagne.',
        whatUniqueRecognizers: 'Verschiedene Personen, die innerhalb dieser Kampagne mindestens eine Nominierung gesendet haben.',
        calcUniqueRecognizers: 'Zählung der verschiedenen Sendenden in den Nominierungen der Kampagne.',
        whatDistribution: 'Hierarchie mit zwei Ebenen: jeder Grundwert mit seinem Anteil an der Gesamtzahl der Kampagne und darunter eingerückt seine täglichen Verhaltensweisen mit dem Anteil, den sie innerhalb dieses Grundwerts ausmachen.',
        calcDistribution: 'Der Anteil eines Grundwerts ist seine Zahl der Nominierungen geteilt durch die Gesamtzahl der Kampagne. Der einer täglichen Verhaltensweise ist ihre Zahl der Nominierungen geteilt durch die Gesamtzahl ihres Grundwerts.',
        whatFunnel: 'Segmentiert die Zielgruppe der Kampagne nach Häufigkeit: Regelmäßige (vier oder mehr pro Monat), Gelegentliche (eine bis drei) und Inaktive (keine). Jede Stufe wird zusätzlich nach Verwaltung und Produktion aufgeschlüsselt.',
        calcFunnel: 'Prozentsatz und Spalte Personen werden über die Zielgruppe der Kampagne berechnet, nicht über die gesamte Organisation. Verwaltung und Produktion zählen dieselben Personen nach Tätigkeitsart und bleiben leer, wenn diese Einordnung nicht verfügbar ist.',
        whatAllRecognitions: 'Rohdaten der Kampagne, eine Zeile je Person: die vollständigen Blöcke Nominee, OnBehalfOf und Candidate, das Datum, die Matrix der aktiven Habits und die Prüfkennzeichen. Personen werden nicht maskiert: Dies ist die Arbeitsgrundlage des Komitees, und die Anonymitätsschwelle gilt für aggregierte Berichte.',
        calcAllRecognitions: 'Vollständige Liste der Nominierungen des Zeitraums. Die Habit-Spalten enthalten nur die zum Exportzeitpunkt im Katalog aktiven. Die Spalte Reco_ID bleibt leer, weil das System noch keine eindeutige Kennung je Zeile erzeugt.',
        noteLeader: 'Eine Rolle gilt als Führungskraft, sobald ihr Mitarbeitende unterstellt sind.',
        masked: 'Aus Anonymitätsgründen ausgeblendet',
        crossOuCount: '{{count}} OUs',
      },
    },
    history: {
      selectCampaign: 'Kampagne auswählen',
      colName: 'Name',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
        colType: "Typ",
        colStatus: "Status",
        colRecognitions: "Anerkennungen",
        colExpiration: "Enddatum",
        colActions: "Aktionen",
        status: {
        activo: "Aktiv",
          expirado: "Abgelaufen",
          borrador: "Entwurf",
        },
      // P18-ter — GLOBALER Kampagnenbericht (alle, nicht nur eine), nach Vorbild von 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Kampagnen gesamt',
      kpiTotalRecognitions: 'Nominierungen gesamt',
      kpiAudienceTotal: 'Zielgruppe gesamt',
      kpiParticipantsTotal: 'Teilnehmer',
      kpiParticipantsStaff: 'Teilnehmer Staff',
      kpiParticipantsFrontline: 'Teilnehmer Frontline',
      kpiParticipationRate: 'Teilnahmequote',
      kpiAvgPerParticipant: 'Durchschnittliche Nominierungen pro Teilnehmer',
      colDescription: 'Beschreibung',
      colParticipants: 'Teilnehmer',
      colParticipantsStaff: 'Teilnehmer Staff',
      colParticipantsFrontline: 'Teilnehmer Frontline',
      colDuration: 'Kampagnendauer',
      colFrequency: 'Häufigkeit',
      colGoalPercent: '% des Ziels',
      downloadGlobalExcel: 'Globalen Bericht herunterladen',
      downloadGlobalError: 'Der globale Bericht konnte nicht heruntergeladen werden.',
      // Historien-Excel (`historicosExcel.ts`) — Texte, die AUSSCHLIESSLICH zur Datei gehören:
      // Blattnamen, Banner, Metadaten und Glossar. Datenbeschriftungen werden nicht wiederholt: die
      // `kpi*`/`col*`-Schlüssel oben werden wiederverwendet, damit Datei und Bildschirm übereinstimmen.
      excel: {
        sheetSummary: 'Management-Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetCampaigns: 'Historische Kampagnen',
        summaryTitle: 'Historie nach Kampagne',
        summarySubtitle: 'Fasst die Historie der Nominierungskampagnen zusammen: Zielgruppe, Teilnahme und Nominierungsvolumen jeder Kampagne.',
        campaignsSubtitle: 'Vergleichende Detailansicht je Kampagne.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache, abgestimmt auf die Management-Zusammenfassung, inklusive der Messweise jedes KPI.',
        metaFilter: 'Angewendeter Filter',
        metaGenerated: 'Erstellt',
        filterAllCampaigns: 'Alle Kampagnen',
        colKpi: 'KPI',
        colValue: 'Wert',
        colNote: 'Hinweis / Definition',
        colDatum: 'Kennzahl',
        colWhatIs: 'Was sie ist',
        colHowMeasured: 'Wie sie gemessen wird',
        colHowCalculated: 'Wie sie berechnet wird',
        colComparedTo: 'Vergleichsmaßstab',
        colWhereShown: 'Wo sie erscheint',
        colAudienceOu: 'Zielgruppe OU',
        whereSummary: 'Management-Zusammenfassung',
        whereSummaryCampaigns: 'Management-Zusammenfassung / Historische Kampagnen',
        datumStaffFrontline: 'Teilnehmer Staff / Teilnehmer Frontline',
        durationDays_one: '{{count}} Tag',
        durationDays_few: '{{count}} Tage',
        durationDays_other: '{{count}} Tage',
        whatCampaigns: 'Anzahl der Kampagnen in der Historie bzw. im angewendeten Filter.',
        measuredCampaigns: 'Gezählt wird jede Kampagne, die mit gültigem Namen in der Historie steht.',
        calcCampaigns: 'Anzahl eindeutiger Kampagnen im Berichtsumfang.',
        vsCampaigns: 'Gegen alle verfügbaren Kampagnen oder gegen frühere Stichtage.',
        whatRecognitions: 'Im gewählten Umfang aufgelaufene Nominierungen.',
        measuredRecognitions: 'Gezählt wird jede Nominierung, die zu den einbezogenen Kampagnen erfasst ist.',
        calcRecognitions: 'Summe aller Nominierungen der gefilterten Kampagnen.',
        vsRecognitions: 'Gegen andere Kampagnen, frühere Zeiträume oder das gesetzte Ziel.',
        whatAudience: 'Zahl der Mitarbeitenden, an die sich die Kampagne richtete.',
        measuredAudience: 'Gemessen an der Zielgruppe, die in der Kampagnenkonfiguration hinterlegt ist.',
        calcAudience: 'Alle berechtigten Mitarbeitenden in der OU, im Land, in der BU oder im konfigurierten Umfang.',
        vsAudience: 'Basis der Teilnahmequote; 100 % entspricht der gesamten Zielgruppe.',
        whatParticipants: 'Verschiedene Personen, die mindestens eine Nominierung gesendet haben.',
        measuredParticipants: 'Gezählt werden eindeutige Personen mit mindestens einer gesendeten Nominierung.',
        calcParticipants: 'Eindeutige Anzahl der Sendenden mit einer oder mehreren Nominierungen.',
        vsParticipants: 'Gegen die Zielgruppe gesamt und gegen vergleichbare Kampagnen.',
        whatStaffFrontline: 'Von den Teilnehmenden: wie viele im Büro (Staff) und wie viele im Betrieb (Frontline) arbeiten.',
        measuredStaffFrontline: 'Maßgeblich ist das aktuelle Segment der Person zum Zeitpunkt des Berichts, nicht das zur Teilnahme.',
        calcStaffFrontline: 'Anzahl der Teilnehmenden nach dem Segment in ihrem Verzeichniseintrag.',
        vsStaffFrontline: 'Gegen die Gesamtzahl der Teilnehmenden derselben Zeile.',
        whatRate: 'Anteil der Zielgruppe, der tatsächlich teilgenommen hat.',
        measuredRate: 'Gemessen als Anteil der Teilnehmenden an der gesamten Zielgruppe.',
        calcRate: 'Teilnehmer / Zielgruppe gesamt.',
        vsRate: 'Gegen das Teilnahmeziel; 100 % heißt, die gesamte Zielgruppe hat teilgenommen.',
        whatAvg: 'Durchschnittliche Zahl der Nominierungen je aktivem Teilnehmenden.',
        measuredAvg: 'Gemessen unter den Personen, die mindestens eine Nominierung gesendet haben.',
        calcAvg: 'Nominierungen gesamt / Teilnehmer.',
        vsAvg: 'Gegen andere Kampagnen oder gegen den erwarteten Schnitt je Teilnehmenden.',
      },
    },
    headcount: {
      notaPeriodo: 'Referenz für den Zeitraum: die Kennzahlen oben werden auf diesen Personalbestand berechnet.',
      notaAdopcion: 'Das ist der Nenner der Nutzung: von diesem Bestand, wie viele Personen nominiert haben.',
      title: 'Belegschaft',
      updatedOn: 'Belegschaft aktualisiert: {{fecha}}',
      updatedOnTitle: 'Belegschaft aktualisiert',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europa: {{fecha}}',
      sourceUsa: 'USA: {{fecha}}',
      sinDato: 'Keine Daten',
      hint: 'Letzter Import der auf der Plattform registrierten Nutzenden',
      total: 'Personen insgesamt',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Heatmap OU × Grundprinzip',
      subtitle: 'Anerkennungsvolumen nach Einheit und Grundprinzip. Die Farbintensität zeigt die relative Konzentration innerhalb jeder Spalte.',
      ou: 'Organisationseinheit',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Gesamt',
    },
    network: {
      title: 'ONA-Netzwerk',
      subtitle: 'Anerkennungsfluss zwischen Einheiten (übergreifende Zusammenarbeit).',
      ous: 'Einheiten',
      flows: 'Flüsse',
      legendCross: 'Cross-OU-Fluss',
      legendInternal: 'Interner Fluss',
      legendNode: 'Einheit (Größe = Volumen)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Fluss (Von → Nach)',
      colRecognitions: 'Anerkennungen',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Anerkennungsvolumen',
      colDominantFundamentalHelp: 'Die Länge des Balkens stellt das Nominierungsvolumen des Flusses dar; die Farbe zeigt, welcher Grundwert darin am häufigsten nominiert wurde.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'Was bedeutet jede Kennzahl?',
      subtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen, ganz ohne Datenkenntnisse.',
      colData: 'Kennzahl',
      colWhat: 'Was sie ist',
      colHow: 'Wie sie berechnet wird',
      colVs: 'Verglichen mit',
      percentTotalWhat: 'Welcher Anteil der gesamten aktiven Belegschaft auf jede Generation entfällt.',
      percentTotalHow: 'Aktive Personen dieser Generation über alle OUs im Geltungsbereich, geteilt durch die gesamte aktive Belegschaft mit bekanntem Generationenband.',
      percentTotalVs: 'Die übrigen Generationen derselben Tabelle.',
      gapWhat: 'Wie stark eine Generation jeden Grundwert lebt, auf einer Skala von 1 bis 4, und wie weit ihr niedrigster Grundwert vom höchsten entfernt liegt.',
      gapHow: 'Durchschnitt der Pulso-Werte je Generation und Grundwert; das Δ ist das Maximum minus das Minimum der Zeile, auf eine Dezimalstelle.',
      gapVs: 'Die übrigen Grundwerte derselben Generation.',
      heatmapWhat: 'Wie viele Nominierungen in jeder Organisationseinheit vergeben wurden, aufgeschlüsselt nach Grundwert.',
      heatmapHow: 'Zählung gruppiert nach OU und Grundwert; Zellen mit weniger als 5 Nominierungen werden aus Anonymitätsgründen ausgeblendet.',
      heatmapVs: 'Die übrigen OUs und Grundwerte derselben Tabelle.',
      networkWhat: 'Wie viele Nominierungen von einer Organisationseinheit zu einer anderen geflossen sind.',
      networkHow: 'Zählung der von einer OU an eine andere gesendeten Nominierungen, absteigend sortiert.',
      networkVs: 'Die übrigen Flüsse derselben Tabelle.',
    },
    generational: {
      title: 'Generationenverteilung',
      subtitle: 'Anerkennungen gruppiert nach Generationenband.',
      filterBu: 'Nach BU filtern…',
      buAll: 'BU: Alle',
      filterDepto: 'Nach Abteilung filtern…',
      roleAll: 'Alle',
      roleLeaders: 'Führungskräfte',
      rolePeers: 'Kollegen',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Generationslücke × Fundamental',
      gapSubtitle: 'Durchschnittswert (1–4) je Generation und Fundamental. Δ Lücke ≥ 1,0 = kritisch.',
      gapTitleHelp: 'Jede Zelle wird für die Anzeige auf 1 Dezimalstelle gerundet. Die Δ Lücke wird anhand des vollständigen (ungerundeten) Werts aus Maximum minus Minimum der Zeile berechnet und kann daher von der visuellen Subtraktion der gerundeten Spalten abweichen.',
      colGeneration: 'Generation',
      colGap: 'Δ Lücke',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} Person',
      people_other: '{{count}} Personen',
      majority: 'Mehrheit',
      coverageTitle: 'Einheiten mit generationsbezogener Datenabdeckung',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Demografie-Bereich exportieren (4 Tabellenblätter)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Zusammensetzung der Belegschaft nach Generation, OU und Mitarbeitertyp',
      metaPeriod: 'Zeitraum',
      metaFilters: 'Angewendete Filter',
      metaGenerated: 'Erstellt',
      colPercentTotal: '% der Gesamtzahl',
      colYearRange: 'Jahresspanne',
      colPeople: 'Personen',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Hinweis',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Mehrheit',
      noteSmallSample: 'Kleine Stichprobe',
    },
    leaders: {
      title: 'Führungskräfte',
      subtitle: 'Direkte Teamgröße und Anerkennungen pro Führungskraft.',
      export: 'Nach Excel exportieren',
      colLeader: 'Führungskraft',
      colPosition: 'Position',
      colOu: 'OE',
      colLevel: 'Ebene',
      colTeamSize: 'Teamgröße',
      colTeamReceived: 'Team-Anerkennungen (erhalten)',
      colTeamReceivedHelp: 'Gesamtzahl der Anerkennungen, die Personen innerhalb der Führungsstrukturen erhalten haben.',
      colTeamSent: 'Team-Anerkennungen (gesendet)',
      colTeamSentHelp: 'Gesamtzahl der Anerkennungen, die Personen innerhalb der Führungsstrukturen gesendet haben.',
      colLeaderSent: 'Von der Führungskraft gesendete Anerkennungen',
      colLeaderReceived: 'Von der Führungskraft erhaltene Anerkennungen',
      colParticipation: 'Beteiligung',
      colRatio: 'Verhältnis',
      colExport: 'Exportieren',
      exportRow: 'Diese Zeile exportieren',
      exportRowFor: 'Zeile von {{name}} exportieren',
      kpiTotalLeaders: 'Führungskräfte insgesamt',
      kpiTeamSizeSum: 'Teamgröße',
      kpiRatioAvg: 'Verhältnis erhalten/gesendet',
      kpiParticipationAvg: 'Beteiligung',
      emptyByPerson: 'Keine Ergebnisse gefunden: Die ausgewählte Person hat in deinem Bereich keine direkt unterstellten Mitarbeitenden.',
      currentWeek: '(aktuelle Woche, standardmäßig)',
      teamSizeNote: 'Die Teamgröße zählt die direkt Unterstellten laut Organigramm und ändert sich weder mit den Daten noch mit dem Fundamental; die Anerkennungen des Teams schon.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetTeams: 'Teams nach Führungskraft',
        teamsSubtitle: 'Detail der Nominierungen nach Führungsstruktur.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen — ganz ohne Datenkenntnisse.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaGenerated: 'Erstellt am',
        colKpi: 'Kennzahl',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Angabe',
        colWhatIs: 'Was es ist',
        colHowCalculated: 'Wie es berechnet wird',
        detailTotalLeaders: 'Gesamtzahl der Führungskräfte mit unterstellten Personen in der Belegschaft.',
        detailTeamSize: 'Summe der Teamgröße (direkt Unterstellte) der angezeigten Führungskräfte.',
        detailTeamReceived: 'Gesamtzahl der Nominierungen, die Personen in den Strukturen der Führungskräfte erhalten haben.',
        detailTeamSent: 'Gesamtzahl der Nominierungen, die Personen in den Strukturen der Führungskräfte gesendet haben.',
        detailLeaderReceived: 'Gesamtzahl der Nominierungen, die die Führungskräfte direkt erhalten haben.',
        detailLeaderSent: 'Gesamtzahl der Nominierungen, die die Führungskräfte direkt gesendet haben.',
        detailRatio: 'Erhaltene Team-Nominierungen geteilt durch die gesendeten.',
        detailParticipation: 'Durchschnittliche Beteiligung der Teams der Führungskräfte.',
        whatTeamSize: 'Wie viele Personen dieser Führungskraft direkt berichten.',
        howTeamSize: 'Anzahl der Personen, deren Vorgesetzter die Führungskraft ist. Tiefere Ebenen des Organigramms werden nicht kumuliert.',
        whatTeamReceived: 'Wie viele Nominierungen das Team dieser Führungskraft insgesamt erhalten hat, von wem auch immer.',
        howTeamReceived: 'Summe der Nominierungen, bei denen die empfangende Person zum direkten Team der Führungskraft gehört.',
        whatTeamSent: 'Wie viele Nominierungen das Team dieser Führungskraft insgesamt gesendet hat, an wen auch immer.',
        howTeamSent: 'Summe der Nominierungen, bei denen die sendende Person zum direkten Team der Führungskraft gehört.',
        whatLeaderReceived: 'Wie viele Nominierungen die Führungskraft insgesamt erhalten hat, von wem auch immer.',
        howLeaderReceived: 'Anzahl der Nominierungen, bei denen die Führungskraft die empfangende Person ist. Das eigene Team zählt nicht mit.',
        whatLeaderSent: 'Wie viele Nominierungen die Führungskraft gesendet hat, an wen auch immer.',
        howLeaderSent: 'Anzahl der Nominierungen, bei denen die Führungskraft die sendende Person ist. Das eigene Team zählt nicht mit.',
        whatRatio: 'Wie viele Nominierungen ein Team mehr erhält, als es selbst vergibt.',
        howRatio: 'Erhaltene Team-Nominierungen geteilt durch die gesendeten. „—“, wenn das Team keine gesendet hat.',
        whatParticipation: 'Welcher Anteil des Teams dieser Führungskraft mindestens einmal jemanden nominiert hat.',
        howParticipation: 'Teammitglieder mit mindestens 1 gesendeten Nominierung, geteilt durch die Teamgröße. Empfangen zählt nicht: Das ist die Handlung einer anderen Person.',
        whatLeader: 'Mitarbeitende Person, der im Personalbestand des Unternehmens Personal unterstellt ist.',
        howLeader: 'Jede Person mit mindestens einem direkt unterstellten Mitarbeitenden. Die Zusammenfassung addiert die Führungskräfte aller Regionen des abgefragten Bereichs.',
        whatLevel: 'Tiefe der Führungskraft im Organigramm: N-1 ist die Wurzel (ohne Vorgesetzten), dann N-2, N-3… abwärts.',
        howLevel: 'Kette der Vorgesetzten bis zur Wurzel + 1, berechnet über das gesamte Unternehmen und nicht nur unter den in dieser Liste sichtbaren Führungskräften.',
      },
    },
    moderation: {
      title: 'Moderation',
      subtitle: 'Detail der gemeldeten Anerkennungen. Enthält Kontaktdaten zur Eskalation.',
      total: 'Meldungen gesamt',
      pending: 'Ausstehend',
      hidden: 'Ausgeblendet',
      restored: 'Wiederherstellt',
      colReported: 'Gemeldet',
      colReportedEmail: 'E-Mail gemeldet',
      colOu: 'OE',
      colCountry: 'Land',
      colReporter: 'Meldender',
      colReporterEmail: 'E-Mail Meldender',
      colReason: 'Grund',
      colStatus: 'Status',
      colDate: 'Datum',
      statusPending: 'Ausstehend',
      statusHidden: 'Ausgeblendet',
      statusRestored: 'Wiederherstellt',
      statusPublished: 'Veröffentlicht',
      colComment: 'Gemeldeter Kommentar',
      colLanguage: 'Sprache',
      colReportCount: '# Meldungen',
      export: 'Nach Excel exportieren',
      colCampaign: 'Kampagne',
      allCampaigns: 'Alle Kampagnen',
      campaignNone: 'Ohne Kampagne',
      campaignUnavailable: 'Kampagne nicht verfügbar',
    },
    campaigns: {
      title: 'Kampagnenverlauf',
      subtitle: 'Abgeschlossene Kampagnen: Zielgruppe und Anerkennungen.',
      search: 'Nach Namen suchen…',
      // D4 — Kategorieauswahl (Fundamentales/Brillamos/Personalizada), die den kombinierten
      // Tabellenexport ersetzt.
      filterTypeLabel: 'Kategorie',
      filterAllTypes: 'Alle Kategorien',
      summaryParticipants: 'Teilnehmende gesamt',
      summaryRate: 'Teilnahme in %',
      colName: 'Name',
      colType: 'Typ',
      colAudience: 'Zielgruppe (Personen)',
      colRecognitions: 'Anerkennungen',
      // C2 — «Teilnahme pro Kampagne» (rep-panel-campgeneral).
      colParticipants: 'Teilnehmende',
      colRate: 'Teilnahmequote',
      colAvgUser: 'Durchschnitt je Teilnehmer',
      colAvgUserHelp: 'Durchschnittliche Anerkennungen je Teilnehmer der Kampagne: Anerkennungen ÷ Teilnehmer.',
      dominantFundamentalTooltip: 'Am häufigsten nominierter Grundwert: {{name}}',
      colStart: "Startdatum",
      colExpiration: "Enddatum",
      prevPage: 'Zurück',
      nextPage: 'Weiter',
      pageOf: 'Seite {{page}} von {{total}}',
      type: {
        Fundamentales: 'Grundprinzipien',
        Brillamos: 'Shine Together',
        Personalizada: 'Individuell',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      // D6 — nutzersichtbare Fehlermeldung, wenn der Kampagnen-Export fehlschlägt (Netzwerk/Backend), via Toast.
    },
  },
  // ── D5 Pass-C — Präferenzen, Team, Übersicht, Ranking, individuelle Kampagne ──
  notifPrefs: {
    title: 'Benachrichtigungen',
    subtitle: 'Wählen Sie, welche Hinweise Sie per E-Mail erhalten möchten.',
    unavailable: 'Deine Präferenzen konnten nicht geladen werden.',
    emailEnabled: 'E-Mails erhalten',
    emailHint: 'Hauptschalter für alle E-Mails.',
    saveError: 'Deine Präferenzen konnten nicht gespeichert werden.',
    cat: {
      recognitionReceived: 'Erhaltene Anerkennungen',
      streakAndBadges: 'Serien und Abzeichen',
      campaigns: 'Kampagnen',
      digest: 'Aktivitätsübersicht',
    },
    catHint: {
      recognitionReceived: 'Wenn jemand Sie anerkennt.',
      streakAndBadges: 'Deine Serie und freigeschaltete Abzeichen.',
      campaigns: 'Neuigkeiten zu Kampagnen Wir strahlen.',
      digest: 'Regelmäßige Übersicht deiner Aktivität.',
    },
    catLockedAntiSpoiler: 'Gesperrt, solange der Anti-Spoiler-Modus aktiv ist: Wir können dich erst nach Kampagnenende über deine Nominierungen benachrichtigen.',
  },
  team: {
    mostRecognized: 'Am meisten anerkannt', mostRecognizers: 'Aktivste Anerkenner:innen',
    title: 'Mein Team',
    subtitle: 'Beteiligung deines Teams an der Anerkennung.',
    subtitleFor: 'Team von {{name}}',
    empty: 'Es gibt noch keine Aktivität deines Teams.',
    teamSize: 'Teamgröße',
    sent: 'Gesendet',
    received: 'Erhalten',
    participation: 'Beteiligung',
    members: 'Teammitglieder',
    emptyMembers: 'Es gibt keine Mitglieder zum Anzeigen.',
    colMember: 'Mitglied',
    colSent: 'Gesendet',
    colReceived: 'Erhalten',
    colStreak: 'Serie',
    noStreak: 'Keine Serie',
    explore: 'Sein Team erkunden',
    myTeam: 'Mein Team',
    breadcrumb: 'Teampfad',
    colTopFundamental: 'Top-Grundprinzip',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Nominiert für:',
    fundEnviado: 'Erkennt an für:',
    colActions: 'Aktionen',
    viewButton: 'Profil von {{name}} ansehen',
    viewButton_short: 'Ansehen',
    backToTeam: 'Zurück zum Team',
    backToProfile: 'Zurück zu meinem Profil',
    expandMember: 'Details von {{name}} ansehen',
  },
  tablero: {
    title: 'Management-Übersicht',
    subtitle: 'KPIs des Anerkennungsprogramms. Punkte sehen nur Punkte-Administratoren.',
    pointsTitle: 'Kampagnenpunkte',
    pointsCampaign: 'Kampagne mit Punkten',
    pointsNone: 'Keine Kampagne vergibt Punkte.',
    pointsHint: 'Mit der OE und dem Zeitraum aus der Leiste.',
    empty: 'Für den gewählten Geltungsbereich gibt es keine KPIs.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Alle Grundwerte',
    allGenerations: 'Alle Generationen',
    notApplicableNote: 'Mit dem Generationsfilter werden KPIs, die auf der Gesamtbelegschaft beruhen, als „n/a“ angezeigt: Der Personalbestand ist nicht nach Generation aufgeschlüsselt, dieser Prozentsatz würde also etwas anderes bedeuten.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Generation Alpha',
      GenZ: 'Generation Z',
      Millennial: 'Millennials',
      GenX: 'Generation X',
      BabyBoomer: 'Babyboomer',
      Silent: 'Stille Generation',
    },
  },
  leaderboard: {
    title: 'Ranking nach OU',
    subtitle: 'Nominierungen nach Organisationseinheit/Land.',
    noOu: 'Ohne OU',
    you: ' (Sie)',
  },
  campaignType: {
    personalizada: 'Individuelle Kampagne',
  },
  campaignLanding: {
    customNote: 'Dies ist eine informative Kampagne. Erkunde ihre Dokumente und ihre Microsite.',
  },
  innovacion: {
    kpiStreak: 'Serie',
    kpiStreakHint: 'Rekord: {{record}} Wochen',
    kpiStreakHintMonthly: 'Rekord: {{record}} Monate',
    kpiNominations: 'Nominierungen',
    kpiNominationsHint: 'In dieser Kampagne eingereicht',
    kpiNominationsHint2: '{{count}} verschiedene Personen',
    kpiUnique: 'Nominierte Personen',
    kpiUniqueHint: 'Eindeutige Empfänger',
    kpiDaysLeft: 'Verbleibende Tage',
    suppressed: 'Die Daten werden aus Datenschutzgründen nicht angezeigt, da die Gruppe zu klein ist, um Kennzahlen darzustellen.',
    kpisUnavailable: 'Live-KPIs sind derzeit nicht verfügbar.',
    fundamentalsTitle: 'Grundprinzipien dieser Kampagne',
    nominateSecondary: 'Zur Nominierungsseite',
    recentTitle: 'Aktuelle Nominierungen',
    recentEmpty: 'In dieser Kampagne gibt es noch keine Nominierungen.',
    noCampaign: 'Derzeit ist keine individuelle Kampagne aktiv. Eine neue Kampagne kann unter Administration → Kampagnen erstellt werden.',
  },
};

export default recognition;
